"use strict";

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.array.sort.js");

require("core-js/modules/es.array.flat-map.js");

require("core-js/modules/es.array.unscopables.flat-map.js");

function n(n) {
  return n && "object" == typeof n && "default" in n ? n.default : n;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("styled-system"),
    t = require("@ifood/pomodoro-icons"),
    r = require("styled-components"),
    o = n(r),
    i = require("framer-motion"),
    a = require("@styled-system/props"),
    u = require("prop-types"),
    c = n(u),
    l = require("react"),
    s = n(l),
    f = n(require("react-useportal")),
    d = n(require("@emotion/is-prop-valid")),
    m = require("@ifood/pomodoro-tokens"),
    p = n(m),
    h = require("react-popper"),
    g = n(require("lodash.debounce")),
    v = require("downshift"),
    b = n(require("lodash.range")),
    y = n(require("segmentize")),
    x = require("react-toastify"),
    k = n(require("deepmerge")),
    w = require("react-day-picker"),
    E = n(w),
    C = require("date-fns"),
    z = n(require("react-day-picker/DayPickerInput")),
    D = require("react-dropzone");

function S() {
  return (S = Object.assign || function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }

    return n;
  }).apply(this, arguments);
}

function O(n, e) {
  if (null == n) return {};
  var t,
      r,
      o = {},
      i = Object.keys(n);

  for (r = 0; r < i.length; r++) {
    e.indexOf(t = i[r]) >= 0 || (o[t] = n[t]);
  }

  return o;
}

function P(n, e) {
  return e || (e = n.slice(0)), n.raw = e, n;
}

function I() {
  var n = P([""]);
  return I = function I() {
    return n;
  }, n;
}

function _() {
  var n = P(["\n  display: flex;\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n"]);
  return _ = function _() {
    return n;
  }, n;
}

function L() {
  var n = P(["\n  align-items: center;\n  justify-content: center;\n"]);
  return L = function L() {
    return n;
  }, n;
}

var T = r.css(L()),
    M = o.div(_(), function (n) {
  return n.centered ? T : r.css(I());
}, e.flexbox, e.layout, e.space);

function j() {
  var n = P(["\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: black;\n  overflow: hidden;\n  z-index: 1;\n"]);
  return j = function j() {
    return n;
  }, n;
}

function R() {
  var n = P(["\n  cursor: pointer;\n  color: ", ";\n"]);
  return R = function R() {
    return n;
  }, n;
}

function A() {
  var n = P(["\n  margin-bottom: ", ";\n"]);
  return A = function A() {
    return n;
  }, n;
}

function N() {
  var n = P(["\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  box-sizing: border-box;\n  z-index: 2;\n  padding: ", ";\n  background: ", ";\n  ", "\n  ", "\n"]);
  return N = function N() {
    return n;
  }, n;
}

function F() {
  var n = P(["\n  z-index: ", ";\n"]);
  return F = function F() {
    return n;
  }, n;
}

var B = o.div(F(), function (n) {
  return n.zIndexCustom;
}),
    q = o(i.motion.div)(N(), function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.colors.white;
}, e.space, e.layout),
    H = o(M)(A(), function (n) {
  return n.theme.space.regular;
}),
    V = o(t.Close)(R(), function (n) {
  return n.theme.colors.primary;
}),
    U = o(i.motion.div)(j()),
    G = function G(n) {
  void 0 === n && (n = !0), l.useEffect(function () {
    return document && document.body && (document.body.style.overflow = n ? "hidden" : "unset"), function () {
      document.body.style.overflow = "unset";
    };
  }, [n]);
},
    W = function W(n, e) {
  var t = l.useRef(null),
      r = l.useRef(null);
  return l.useEffect(function () {
    var e, o;
    n ? (r.current = document.activeElement, null === (e = t.current) || void 0 === e || e.focus()) : null === (o = r.current) || void 0 === o || o.focus();
  }, [n]), {
    elementToFocusRef: t,
    onKeyDown: function onKeyDown(n) {
      "Escape" === n.key && e && e(n);
    }
  };
},
    Q = {
  "pt-br": {
    close: "Fechar conteúdo"
  },
  "en-us": {
    close: "Close content"
  },
  "es-mx": {
    close: "Cerrar contenido"
  },
  "es-co": {
    close: "Cerrar contenido"
  }
},
    J = l.createContext({
  locale: "en-us"
});

function X(n) {
  var e = l.useRef(null);
  return l.useEffect(function () {
    n && ("function" != typeof n ? n.current = e.current : n(e.current));
  }, [e, n]), e;
}

function K(n) {
  return "url(data:image/svg+xml;utf8," + encodeURIComponent(n) + ")";
}

function Z(n) {
  return n.map(function (n) {
    return n.filter(Boolean).join(" ");
  }).join(",");
}

var Y = function Y(n) {
  return Object.entries(n).filter(function (n) {
    return d(n[0]);
  }).reduce(function (n, e) {
    var t = n;
    return t[e[0]] = e[1], t;
  }, {});
};

function $() {
  var n = P([""]);
  return $ = function $() {
    return n;
  }, n;
}

function nn() {
  var n = P([""]);
  return nn = function nn() {
    return n;
  }, n;
}

function en() {
  var n = P([""]);
  return en = function en() {
    return n;
  }, n;
}

function tn() {
  var n = P(["\n  font-family: ", ";\n  color: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  return tn = function tn() {
    return n;
  }, n;
}

function rn() {
  var n = P(["\n  font-size: ", ";\n  line-height: ", ";\n"]);
  return rn = function rn() {
    return n;
  }, n;
}

function on() {
  var n = P(["\n  font-size: ", ";\n  line-height: ", ";\n"]);
  return on = function on() {
    return n;
  }, n;
}

function an() {
  var n = P(["\n  font-size: ", ";\n  line-height: ", ";\n"]);
  return an = function an() {
    return n;
  }, n;
}

function un() {
  var n = P(["\n  font-size: ", ";\n  line-height: ", ";\n"]);
  return un = function un() {
    return n;
  }, n;
}

var cn = r.css(un(), function (n) {
  return n.theme.fontSizes.xl;
}, function (n) {
  return n.theme.lineHeights.xl;
}),
    ln = r.css(an(), function (n) {
  return n.theme.fontSizes.l;
}, function (n) {
  return n.theme.lineHeights.l;
}),
    sn = r.css(on(), function (n) {
  return n.theme.fontSizes.m;
}, function (n) {
  return n.theme.lineHeights.m;
}),
    fn = r.css(rn(), function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.lineHeights.m;
}),
    dn = o.h1(tn(), function (n) {
  return n.theme.fonts.primary;
}, function (n) {
  return n.theme.colors.black;
}, cn, function (n) {
  return "medium" === n.variant ? ln : r.css(en());
}, function (n) {
  return "small" === n.variant ? sn : r.css(nn());
}, function (n) {
  return "smallest" === n.variant ? fn : r.css($());
}, e.space, e.layout, e.typography, e.color),
    mn = function mn(n) {
  var e = n.variant,
      t = void 0 === e ? "large" : e,
      r = n.as,
      o = void 0 === r ? "h1" : r,
      i = O(n, ["variant", "as"]),
      u = Y(i),
      c = a.pick(i);
  return s.createElement(dn, Object.assign({
    as: o,
    variant: t
  }, u, c));
};

function pn() {
  var n = P(["\n    padding: 0 ", ";\n    background: ", ";\n    border-radius: ", ";\n    margin-bottom: ", ";\n    color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n\n    > svg {\n      margin-right: ", ";\n    }\n  "]);
  return pn = function pn() {
    return n;
  }, n;
}

function hn() {
  var n = P(["\n  width: 100%;\n  height: 48px;\n  border: 0;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  ", "\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"]);
  return hn = function hn() {
    return n;
  }, n;
}

mn.propTypes = {
  variant: c.oneOf(["large", "medium", "small", "smallest"]),
  as: c.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"])
};

var gn = o.button(hn(), function (n) {
  var e = n.theme;
  return r.css(pn(), e.space.regular, e.colors.grayLight, e.radii.s, e.space.regular, e.colors.black, e.fonts.primary, e.fontSizes.s, e.lineHeights.m, e.space.regular);
}),
    vn = function vn(n) {
  var e = n.text,
      t = n.onClick,
      r = n.icon,
      o = n.actionSheetButtonDataTestId,
      i = O(n, ["text", "onClick", "icon", "actionSheetButtonDataTestId"]);
  return s.createElement(gn, Object.assign({
    onClick: t,
    "data-testid": o || "action-sheet-button",
    type: "button"
  }, i), r && r, e);
};

vn.propTypes = {
  actionSheetButtonDataTestId: c.string,
  icon: c.node,
  onClick: c.func.isRequired,
  text: c.string.isRequired
};

var bn = function bn(n) {
  var e = n.children,
      t = n.closeAriaLabel,
      r = n.closeDataTestId,
      o = void 0 === r ? "pomodoro-action-sheet-close" : r,
      u = n.id,
      c = void 0 === u ? "pomodoro-action-sheet-root" : u,
      d = n.isOpen,
      m = n.onClose,
      p = n.title,
      h = n.zIndexCustom,
      g = void 0 === h ? 999999999 : h,
      v = O(n, ["children", "closeAriaLabel", "closeDataTestId", "id", "isOpen", "onClose", "title", "zIndexCustom"]),
      b = l.useContext(J).locale,
      y = W(d, m),
      x = y.elementToFocusRef,
      k = y.onKeyDown;
  G(d);
  var w = f().Portal,
      E = a.pick(v),
      C = Y(v);
  return s.createElement(w, {
    id: c
  }, s.createElement(i.AnimatePresence, null, d ? s.createElement(B, {
    zIndexCustom: g
  }, s.createElement(q, Object.assign({
    initial: {
      opacity: 0,
      y: "100%"
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: "100%"
    },
    transition: {
      duration: .25
    }
  }, C, E, {
    tabIndex: 0,
    onKeyDown: k,
    ref: x
  }), s.createElement(H, {
    alignItems: "center",
    justifyContent: "space-between"
  }, s.createElement(mn, {
    variant: "small",
    as: "h3",
    margin: "0"
  }, p), s.createElement(V, {
    role: "button",
    onClick: m,
    "aria-label": t || Q[b].close,
    "data-testid": o
  })), e), s.createElement(U, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: .5
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: .15
    }
  })) : null));
};

function yn() {
  var n = P(["\n  border-color: ", ";\n  color: ", ";\n"]);
  return yn = function yn() {
    return n;
  }, n;
}

bn.propTypes = {
  closeAriaLabel: c.string,
  closeDataTestId: c.string,
  isOpen: c.bool.isRequired,
  onClose: c.func.isRequired,
  title: c.string.isRequired,
  zIndexCustom: c.number
};
var xn = r.css(yn(), function (n) {
  return n.theme.colors.attention;
}, function (n) {
  return n.theme.colors.attention;
}),
    kn = {
  "pt-br": {
    close: "Fechar notificação"
  },
  "en-us": {
    close: "Close notification"
  },
  "es-mx": {
    close: "Cerrar notificación"
  },
  "es-co": {
    close: "Cerrar notificación"
  }
};

function wn() {
  var n = P(["\n  font-family: ", ";\n  font-style: normal;\n  color: ", ";\n  font-weight: normal;\n\n  margin-top: ", ";\n"]);
  return wn = function wn() {
    return n;
  }, n;
}

var En = o.div(wn(), function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.colors.black;
}, function (n) {
  return n.theme.space.small;
});

function Cn() {
  var n = P(["\n  border-color: ", ";\n  color: ", ";\n"]);
  return Cn = function Cn() {
    return n;
  }, n;
}

var zn = r.css(Cn(), function (n) {
  return n.theme.colors.error;
}, function (n) {
  return n.theme.colors.error;
}),
    Dn = {
  xs: "16px",
  s: "24px",
  m: "36px",
  l: "48px"
};

function Sn() {
  var n = P(["\n  display: inline-flex;\n  font-size: 0;\n  ", "\n  ", "\n"]);
  return Sn = function Sn() {
    return n;
  }, n;
}

var On = o.div(Sn(), e.space, e.layout),
    Pn = function Pn(n) {
  var e = n.component,
      t = n.height,
      r = n.size,
      o = void 0 === r ? "m" : r,
      i = n.svgProps,
      a = n.width,
      u = O(n, ["component", "height", "size", "svgProps", "width"]);
  return s.createElement(On, Object.assign({}, u), s.createElement(e, Object.assign({
    height: t || Dn[o],
    width: a || Dn[o]
  }, i)));
};

function In() {
  var n = P(["\n  border-color: ", ";\n  color: ", ";\n"]);
  return In = function In() {
    return n;
  }, n;
}

Pn.propTypes = {
  component: c.func.isRequired,
  height: c.string,
  width: c.string,
  size: c.oneOf(["xs", "s", "m", "l"]),
  svgProps: c.object
};

var _n = r.css(In(), function (n) {
  return n.theme.colors.informative;
}, function (n) {
  return n.theme.colors.informative;
});

function Ln() {
  var n = P(["\n  background-color: ", ";\n  border-color: ", ";\n  color: ", ";\n"]);
  return Ln = function Ln() {
    return n;
  }, n;
}

var Tn = r.css(Ln(), function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.colors.primaryDark;
}, function (n) {
  return n.theme.colors.white;
});

function Mn() {
  var n = P(["\n  border-color: ", ";\n  color: ", ";\n"]);
  return Mn = function Mn() {
    return n;
  }, n;
}

var jn = r.css(Mn(), function (n) {
  return n.theme.colors.positive;
}, function (n) {
  return n.theme.colors.positive;
});

function Rn() {
  var n = P(["\n  cursor: pointer;\n"]);
  return Rn = function Rn() {
    return n;
  }, n;
}

function An() {
  var n = P([""]);
  return An = function An() {
    return n;
  }, n;
}

function Nn() {
  var n = P(["\n  padding-left: ", ";\n  padding-right: ", ";\n  pointer-events: all;\n  margin-left: auto;\n  color: ", ";\n\n  width: ", ";\n\n  ", "\n"]);
  return Nn = function Nn() {
    return n;
  }, n;
}

function Fn() {
  var n = P(["\n  padding-left: ", ";\n  padding-right: ", ";\n\n  margin-top: 1px;\n"]);
  return Fn = function Fn() {
    return n;
  }, n;
}

function Bn() {
  var n = P([""]);
  return Bn = function Bn() {
    return n;
  }, n;
}

function qn() {
  var n = P([""]);
  return qn = function qn() {
    return n;
  }, n;
}

function Hn() {
  var n = P([""]);
  return Hn = function Hn() {
    return n;
  }, n;
}

function Vn() {
  var n = P([""]);
  return Vn = function Vn() {
    return n;
  }, n;
}

function Un() {
  var n = P([""]);
  return Un = function Un() {
    return n;
  }, n;
}

function Gn() {
  var n = P(["\n  display: flex;\n  border-width: 1px;\n  border-top-width: 4px;\n  border-style: solid;\n  border-radius: ", ";\n\n  font-family: ", ";\n  font-style: normal;\n  font-weight: bold;\n\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n  ", "\n"]);
  return Gn = function Gn() {
    return n;
  }, n;
}

function Wn() {
  var n = P(["\n  border-color: ", ";\n  color: ", ";\n"]);
  return Wn = function Wn() {
    return n;
  }, n;
}

var Qn = r.css(Wn(), function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.colors.grayDarker;
}),
    Jn = o.div(Gn(), function (n) {
  return n.theme.radii.m;
}, function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.smaller;
}, Qn, function (n) {
  return "success" === n.variant ? jn : r.css(Un());
}, function (n) {
  return "required" === n.variant ? Tn : r.css(Vn());
}, function (n) {
  return "attention" === n.variant ? xn : r.css(Hn());
}, function (n) {
  return "error" === n.variant ? zn : r.css(qn());
}, function (n) {
  return "informative" === n.variant ? _n : r.css(Bn());
}, e.space, e.layout),
    Xn = o.div(Fn(), function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}),
    Kn = o.div(Nn(), function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.colors.black;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return "required" === n.variant ? Tn : r.css(An());
}),
    Zn = o(Pn)(Rn()),
    Yn = function Yn(n) {
  var e = n.allowClose,
      r = n.children,
      o = n.closeAriaLabel,
      i = n.icon,
      u = void 0 === i ? t.AlertFilled : i,
      c = n.onClose,
      f = n.title,
      d = n.variant,
      m = void 0 === d ? "neutral" : d,
      p = O(n, ["allowClose", "children", "closeAriaLabel", "icon", "onClose", "title", "variant"]),
      h = l.useContext(J).locale,
      g = l.useState(!0),
      v = g[0],
      b = g[1],
      y = l.useCallback(function () {
    b(!1), null == c || c();
  }, [c]);
  if (!v) return null;
  var x = a.pick(p),
      k = Y(p);
  return s.createElement(Jn, Object.assign({
    variant: m
  }, k, x), s.createElement(Xn, null, s.createElement(Pn, {
    component: u,
    size: "xs"
  })), s.createElement("div", null, f, r), s.createElement(Kn, {
    variant: m
  }, e && s.createElement(Zn, {
    role: "button",
    onClick: y,
    component: t.Close,
    size: "xs",
    tabIndex: 0,
    "aria-label": o || kn[h].close
  })));
};

function $n() {
  var n = P([""]);
  return $n = function $n() {
    return n;
  }, n;
}

function ne() {
  var n = P(["\n        padding: ", ";\n      "]);
  return ne = function ne() {
    return n;
  }, n;
}

function ee() {
  var n = P([""]);
  return ee = function ee() {
    return n;
  }, n;
}

function te() {
  var n = P(["\n        cursor: progress;\n        background-color: ", ";\n        &:hover:not(:active):not(:disabled) {\n          background-color: ", ";\n        }\n      "]);
  return te = function te() {
    return n;
  }, n;
}

Yn.Description = En, Yn.propTypes = {
  allowClose: c.bool,
  closeAriaLabel: c.string,
  onClose: c.func,
  icon: c.oneOfType([c.node, c.func]),
  title: c.string.isRequired,
  variant: c.oneOf(["neutral", "attention", "informative", "required", "success", "error"])
};

var re = function re(n) {
  return function (e) {
    return e.isLoading ? r.css(te(), e.theme.colors[n], e.theme.colors[n]) : r.css(ee());
  };
},
    oe = function oe(n) {
  return n.reduced ? r.css(ne(), n.theme.space.smaller) : r.css($n());
};

function ie() {
  var n = P(["\n  border-radius: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: ", ";\n  font-family: ", ";\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  &:active {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  &:hover:not(:active):not(:disabled) {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ", "\n  ", "\n"]);
  return ie = function ie() {
    return n;
  }, n;
}

function ae() {
  var n = P(["\n  border-radius: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: ", ";\n  font-family: ", ";\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:hover:not(:active):not(:disabled) {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ", "\n  ", "\n"]);
  return ae = function ae() {
    return n;
  }, n;
}

function ue() {
  var n = P(["\n  border-radius: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: ", ";\n  font-family: ", ";\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:hover:not(:active):not(:disabled) {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ", "\n  ", "\n"]);
  return ue = function ue() {
    return n;
  }, n;
}

var ce = r.css(ue(), function (n) {
  return n.theme.radii.m;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.large;
}, function (n) {
  return n.theme.space.large;
}, function (n) {
  return n.theme.fontSizes.m;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.colors.secondary;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.fonts.primary;
}, function (n) {
  return n.theme.shadows.focus;
}, function (n) {
  return n.theme.colors.primaryDark;
}, function (n) {
  return n.theme.colors.primaryLight;
}, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.colors.gray;
}, re("primaryDark"), oe),
    le = r.css(ae(), function (n) {
  return n.theme.radii.m;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.large;
}, function (n) {
  return n.theme.space.large;
}, function (n) {
  return n.theme.fontSizes.m;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.colors.secondary;
}, function (n) {
  return n.theme.colors.information;
}, function (n) {
  return n.theme.fonts.primary;
}, function (n) {
  return n.theme.shadows.focus;
}, function (n) {
  return n.theme.colors.information;
}, function (n) {
  return n.theme.colors.informationLight;
}, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.colors.gray;
}, re("information"), oe),
    se = r.css(ie(), function (n) {
  return n.theme.radii.m;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.fontSizes.m;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.fonts.primary;
}, function (n) {
  return n.theme.shadows.focus;
}, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.colors.primaryLight;
}, function (n) {
  return n.theme.colors.primaryLightest;
}, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.colors.gray;
}, re("primaryLight"), oe);

function fe() {
  var n = P(["\n  border-radius: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: transparent;\n  font-family: ", ";\n  text-decoration: underline;\n  font-weight: normal;\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  &:active {\n    color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n  }\n\n  ", "\n"]);
  return fe = function fe() {
    return n;
  }, n;
}

function de() {
  var n = P(["\n  border-radius: ", ";\n  padding: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: transparent;\n  font-family: ", ";\n  text-decoration: underline;\n  font-weight: normal;\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  &:active {\n    color: ", ";\n    background-color: transparent;\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: transparent;\n  }\n\n  &:hover:not(:active):not(:disabled) {\n    background-color: transparent;\n  }\n\n  ", "\n"]);
  return de = function de() {
    return n;
  }, n;
}

var me = r.css(de(), function (n) {
  return n.theme.radii.m;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.fontSizes.m;
}, function (n) {
  return n.theme.lineHeights.l;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.shadows.focus;
}, function (n) {
  return n.theme.colors.primaryLight;
}, function (n) {
  return n.theme.colors.grayDarker;
}, oe),
    pe = r.css(fe(), function (n) {
  return n.theme.radii.m;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.fontSizes.m;
}, function (n) {
  return n.theme.lineHeights.l;
}, function (n) {
  return n.theme.colors.primaryLightest;
}, function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.shadows.focus;
}, function (n) {
  return n.theme.colors.primaryLight;
}, function (n) {
  return n.theme.colors.grayDarker;
}, oe);

function he() {
  var n = P(["\n  border-radius: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: ", ";\n  font-family: ", ";\n  font-weight: bold;\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:hover:not(:active):not(:disabled) {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ", "\n"]);
  return he = function he() {
    return n;
  }, n;
}

var ge = r.css(he(), function (n) {
  return n.theme.radii.m;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.larger;
}, function (n) {
  return n.theme.space.larger;
}, function (n) {
  return n.theme.fontSizes.l;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.colors.secondary;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.fonts.primary;
}, function (n) {
  return n.theme.shadows.focus;
}, function (n) {
  return n.theme.colors.primaryDark;
}, function (n) {
  return n.theme.colors.primaryLight;
}, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.colors.gray;
}, re("primaryDark")),
    ve = {
  "pt-br": {
    label: "Carregando"
  },
  "en-us": {
    label: "Loading"
  },
  "es-mx": {
    label: "Cargando"
  },
  "es-co": {
    label: "Cargando"
  }
};

function be() {
  var n = P(["\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: white;\n  animation: fade 0.8s ease-in-out alternate infinite;\n\n  &:nth-of-type(1) {\n    animation-delay: -0.4s;\n  }\n\n  &:nth-of-type(2) {\n    animation-delay: -0.2s;\n  }\n\n  &:not(:first-of-type) {\n    margin-left: 5px;\n  }\n\n  @keyframes fade {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n"]);
  return be = function be() {
    return n;
  }, n;
}

function ye() {
  var n = P(["\n  position: absolute;\n  right: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n"]);
  return ye = function ye() {
    return n;
  }, n;
}

var xe = o.div(ye()),
    ke = o.div(be()),
    we = function we() {
  var n = l.useContext(J);
  return s.createElement(xe, {
    "aria-label": ve[n.locale].label
  }, s.createElement(ke, null), s.createElement(ke, null), s.createElement(ke, null));
};

function Ee() {
  var n = P(["\n  width: 24px;\n  height: 24px;\n  background-color: ", ";\n  color: ", ";\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  border-radius: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ", ";\n  line-height: 6px;\n"]);
  return Ee = function Ee() {
    return n;
  }, n;
}

var Ce = o.div(Ee(), function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.radii.l;
}, function (n) {
  return n.theme.fontSizes.xs;
}),
    ze = function ze(n) {
  return s.createElement(Ce, null, n.count);
};

function De() {
  var n = P(["\n  border-radius: ", ";\n  border: solid 1px ", ";\n  padding-top: calc(", " - 1px);\n  padding-bottom: calc(", " - 1px);\n  padding-left: ", ";\n  padding-right: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  background-color: ", ";\n  color: ", ";\n  font-family: ", ";\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  &:active {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  &:hover:not(:active):not(:disabled) {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ", "\n  ", "\n"]);
  return De = function De() {
    return n;
  }, n;
}

ze.propTypes = {
  count: u.number.isRequired
};
var Se = r.css(De(), function (n) {
  return n.theme.radii.m;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.large;
}, function (n) {
  return n.theme.space.large;
}, function (n) {
  return n.theme.fontSizes.m;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.fonts.primary;
}, function (n) {
  return n.theme.shadows.focus;
}, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.colors.primaryLight;
}, function (n) {
  return n.theme.colors.primaryLightest;
}, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.colors.gray;
}, re("primaryLight"), oe);

function Oe() {
  var n = P(["\n  visibility: hidden;\n"]);
  return Oe = function Oe() {
    return n;
  }, n;
}

function Pe() {
  var n = P([""]);
  return Pe = function Pe() {
    return n;
  }, n;
}

function Ie() {
  var n = P(["\n          text-align: ", ";\n        "]);
  return Ie = function Ie() {
    return n;
  }, n;
}

function _e() {
  var n = P([""]);
  return _e = function _e() {
    return n;
  }, n;
}

function Le() {
  var n = P([""]);
  return Le = function Le() {
    return n;
  }, n;
}

function Te() {
  var n = P([""]);
  return Te = function Te() {
    return n;
  }, n;
}

function Me() {
  var n = P([""]);
  return Me = function Me() {
    return n;
  }, n;
}

function je() {
  var n = P([""]);
  return je = function je() {
    return n;
  }, n;
}

function Re() {
  var n = P([""]);
  return Re = function Re() {
    return n;
  }, n;
}

function Ae() {
  var n = P(["\n  position: relative;\n  cursor: pointer;\n  transition: ", ";\n\n  border: 0;\n  font-weight: normal;\n\n  ", "\n\n  ", "\n\n", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  &:disabled {\n    cursor: default;\n  }\n\n  ", "\n  ", "\n"]);
  return Ae = function Ae() {
    return n;
  }, n;
}

var Ne = o.button(Ae(), function (n) {
  var e = n.theme,
      t = e.durations,
      r = e.timingFunctions;
  return Z([["background-color", t.promptly, r.easeInOut], ["box-shadow", t.quickly, r.easeInOut]]);
}, ce, function (n) {
  return "primary-inverted" === n.variant ? se : r.css(Re());
}, function (n) {
  return "primary-information" === n.variant ? le : r.css(je());
}, function (n) {
  return "cta" === n.variant ? ge : r.css(Me());
}, function (n) {
  return "secondary" === n.variant ? Se : r.css(Te());
}, function (n) {
  return "tertiary" === n.variant ? me : r.css(Le());
}, function (n) {
  return "tertiary-inverted" === n.variant ? pe : r.css(_e());
}, function (n) {
  return n.textAlign ? r.css(Ie(), n.textAlign) : r.css(Pe());
}, e.space, e.layout),
    Fe = o.span(Oe()),
    Be = function Be(n) {
  var e = n.variant,
      t = void 0 === e ? "primary" : e,
      r = n.className,
      o = void 0 === r ? "" : r,
      i = n.children,
      u = n.isLoading,
      c = void 0 !== u && u,
      l = n.reduced,
      f = void 0 !== l && l,
      d = n.badgeValue,
      m = void 0 === d ? null : d,
      p = O(n, ["variant", "className", "children", "isLoading", "reduced", "badgeValue"]),
      h = c && "tertiary" !== t && "tertiary-inverted" !== t,
      g = m && "secondary" === t ? m : null,
      v = a.pick(p),
      b = Y(p);
  return s.createElement(Ne, Object.assign({
    variant: t,
    isLoading: c,
    reduced: f,
    className: o
  }, b, v), h ? s.createElement(s.Fragment, null, s.createElement(we, null), s.createElement(Fe, null, i)) : s.createElement(s.Fragment, null, g && s.createElement(ze, {
    count: g
  }), i));
};

function qe() {
  var n = P(["\n  background-color: ", ";\n  border-width: 1px;\n  border-style: solid;\n  border-color: ", ";\n"]);
  return qe = function qe() {
    return n;
  }, n;
}

Be.propTypes = {
  isLoading: c.bool,
  variant: c.oneOf(["cta", "primary", "primary-inverted", "primary-information", "secondary", "tertiary", "tertiary-inverted"]),
  reduced: c.bool,
  textAlign: c.oneOf(["left", "center", "right"]),
  badgeValue: c.number
};
var He = r.css(qe(), function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.colors.grayLight;
});

function Ve() {
  var n = P(["\n  background-color: ", ";\n"]);
  return Ve = function Ve() {
    return n;
  }, n;
}

var Ue = r.css(Ve(), function (n) {
  return n.theme.colors.grayLight;
});

function Ge() {
  var n = P(["\n  background-color: ", ";\n"]);
  return Ge = function Ge() {
    return n;
  }, n;
}

var We = r.css(Ge(), function (n) {
  return n.theme.colors.gray;
});

function Qe() {
  var n = P([""]);
  return Qe = function Qe() {
    return n;
  }, n;
}

function Je() {
  var n = P([""]);
  return Je = function Je() {
    return n;
  }, n;
}

function Xe() {
  var n = P([""]);
  return Xe = function Xe() {
    return n;
  }, n;
}

function Ke() {
  var n = P([""]);
  return Ke = function Ke() {
    return n;
  }, n;
}

function Ze() {
  var n = P(["\n  border-radius: ", ";\n  padding: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n  ", "\n"]);
  return Ze = function Ze() {
    return n;
  }, n;
}

function Ye() {
  var n = P(["\n  box-shadow: ", ";\n"]);
  return Ye = function Ye() {
    return n;
  }, n;
}

var $e = r.css(Ye(), function (n) {
  return n.theme.shadows.elevate;
}),
    nt = o.div(Ze(), function (n) {
  return n.theme.radii.m;
}, function (n) {
  return n.theme.space.regular;
}, He, function (n) {
  return "primary" === n.variant ? He : r.css(Ke());
}, function (n) {
  return "secondary" === n.variant ? Ue : r.css(Xe());
}, function (n) {
  return "tertiary" === n.variant ? We : r.css(Je());
}, function (n) {
  return n.elevated ? $e : r.css(Qe());
}, e.space, e.layout),
    et = function et(n) {
  var e = n.variant,
      t = void 0 === e ? "primary" : e,
      r = n.elevated,
      o = void 0 !== r && r,
      i = n.children,
      u = O(n, ["variant", "elevated", "children"]),
      c = a.pick(u),
      l = Y(u);
  return s.createElement(nt, Object.assign({
    variant: t,
    elevated: o
  }, l, c), i);
};

function tt() {
  var n = P(["\n  width: 100%;\n"]);
  return tt = function tt() {
    return n;
  }, n;
}

function rt() {
  var n = P(["\n  max-width: 100%;\n  height: auto;\n  margin: ", ";\n"]);
  return rt = function rt() {
    return n;
  }, n;
}

function ot() {
  var n = P(["\n  box-sizing: border-box;\n  border: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  width: 100%;\n\n  display: flex;\n  align-items: center;\n\n  ", "\n  ", "\n"]);
  return ot = function ot() {
    return n;
  }, n;
}

et.propTypes = {
  elevated: c.bool,
  variant: c.oneOf(["primary", "secondary", "tertiary"])
};

var it = o.div(ot(), function (n) {
  return "solid 1px " + n.theme.colors.gray;
}, function (n) {
  return n.theme.radii.m;
}, function (n) {
  return n.theme.space.regular;
}, e.space, e.layout),
    at = o.img(rt(), function (n) {
  return n.theme.space.regular;
}),
    ut = o.div(tt()),
    ct = function ct(n) {
  var e = n.children,
      t = n.imgSrc,
      r = n.imgAlt,
      o = O(n, ["children", "imgSrc", "imgAlt"]),
      i = a.pick(o),
      u = Y(o);
  return s.createElement(it, Object.assign({}, u, i), t && s.createElement(at, {
    src: t,
    alt: r
  }), s.createElement(ut, null, e));
};

function lt() {
  var n = P(["\n  cursor: pointer;\n"]);
  return lt = function lt() {
    return n;
  }, n;
}

function st() {
  var n = P(["\n  cursor: pointer;\n"]);
  return st = function st() {
    return n;
  }, n;
}

function ft() {
  var n = P(["\n  padding: ", ";\n  border-bottom: ", ";\n"]);
  return ft = function ft() {
    return n;
  }, n;
}

ct.propTypes = {
  imgSrc: c.string,
  imgAlt: c.string
};
var dt = o.div(ft(), function (n) {
  return n.theme.space.larger + " 0 " + n.theme.space.regular;
}, function (n) {
  return "1px solid " + n.theme.colors.gray;
}),
    mt = o(t.ChevronDown)(st()),
    pt = o(t.ChevronUp)(lt()),
    ht = {
  "pt-br": {
    content: "Abrir conteúdo"
  },
  "en-us": {
    content: "Open content"
  },
  "es-mx": {
    content: "Contenido abierto"
  },
  "es-co": {
    content: "Contenido abierto"
  }
};

function gt() {
  var n = P([""]);
  return gt = function gt() {
    return n;
  }, n;
}

function vt() {
  var n = P([""]);
  return vt = function vt() {
    return n;
  }, n;
}

function bt() {
  var n = P(["\n  font-family: ", ";\n  color: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  return bt = function bt() {
    return n;
  }, n;
}

function yt() {
  var n = P(["\n  font-size: ", ";\n  line-height: ", ";\n"]);
  return yt = function yt() {
    return n;
  }, n;
}

function xt() {
  var n = P(["\n  font-size: ", ";\n  line-height: ", ";\n"]);
  return xt = function xt() {
    return n;
  }, n;
}

function kt() {
  var n = P(["\n  font-size: ", ";\n  line-height: ", ";\n"]);
  return kt = function kt() {
    return n;
  }, n;
}

var wt = r.css(kt(), function (n) {
  return n.theme.fontSizes.m;
}, function (n) {
  return n.theme.lineHeights.m;
}),
    Et = r.css(xt(), function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.lineHeights.m;
}),
    Ct = r.css(yt(), function (n) {
  return n.theme.fontSizes.xs;
}, function (n) {
  return n.theme.lineHeights.s;
}),
    zt = o.span(bt(), function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.colors.black;
}, Et, function (n) {
  return "large" === n.variant ? wt : r.css(vt());
}, function (n) {
  return "small" === n.variant ? Ct : r.css(gt());
}, e.space, e.layout, e.typography, e.color),
    Dt = function Dt(n) {
  var e = n.variant,
      t = void 0 === e ? "medium" : e,
      r = n.as,
      o = void 0 === r ? "span" : r,
      i = O(n, ["variant", "as"]),
      u = a.pick(i),
      c = Y(i);
  return s.createElement(zt, Object.assign({
    as: o,
    variant: t
  }, c, u));
};

Dt.propTypes = {
  variant: c.oneOf(["large", "medium", "small"]),
  as: c.oneOf(["p", "span"])
};
var St = {
  s: "300px",
  m: "500px",
  l: "800px",
  xl: "60%"
};

function Ot() {
  var n = P(["\n    ", " {\n      top: ", ";\n      right: ", ";\n    }\n  "]);
  return Ot = function Ot() {
    return n;
  }, n;
}

function Pt() {
  var n = P(["\n  cursor: pointer;\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  color: ", ";\n  z-index: 1;\n\n  ", "\n"]);
  return Pt = function Pt() {
    return n;
  }, n;
}

function It() {
  var n = P(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: black;\n  overflow: hidden;\n  z-index: 1;\n"]);
  return It = function It() {
    return n;
  }, n;
}

function _t() {
  var n = P(["\n    ", " {\n      width: 100%;\n      max-width: 100%;\n      max-height: 100%;\n      height: 100%;\n      border-radius: unset;\n    }\n  "]);
  return _t = function _t() {
    return n;
  }, n;
}

function Lt() {
  var n = P(["\n  min-width: ", ";\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  max-height: 80%;\n  z-index: 2;\n  background: white;\n  border-radius: 6px;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);\n  max-width: ", ";\n\n  ", "\n"]);
  return Lt = function Lt() {
    return n;
  }, n;
}

function Tt() {
  var n = P(["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  z-index: ", ";\n"]);
  return Tt = function Tt() {
    return n;
  }, n;
}

var Mt = o.div(Tt(), function (n) {
  return n.zIndexCustom;
}),
    jt = o(i.motion.div)(Lt(), St.s, function (n) {
  return St[n.size];
}, function (n) {
  var e = n.theme;
  return r.css(_t(), e.mediaQueries.s);
}),
    Rt = o(i.motion.div)(It()),
    At = o(Pn)(Pt(), function (n) {
  return n.theme.space.larger;
}, function (n) {
  return n.theme.space.larger;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  var e = n.theme;
  return r.css(Ot(), e.mediaQueries.s, function (n) {
    return n.theme.space.regular;
  }, function (n) {
    return n.theme.space.large;
  });
});

function Nt() {
  var n = P(["\n    ", " {\n      padding: 0 ", ";\n    }\n  "]);
  return Nt = function Nt() {
    return n;
  }, n;
}

function Ft() {
  var n = P(["\n  width: 100%;\n  padding: 0 ", ";\n  box-sizing: border-box;\n  max-height: 100%;\n  overflow: auto;\n\n  ", "\n\n  ", "\n  ", "\n"]);
  return Ft = function Ft() {
    return n;
  }, n;
}

var Bt = o.div(Ft(), function (n) {
  return n.theme.space.larger;
}, function (n) {
  var e = n.theme;
  return r.css(Nt(), e.mediaQueries.s, function (n) {
    return n.theme.space.large;
  });
}, e.space, e.layout);

function qt() {
  var n = P(["\n    ", " {\n      padding: ", ";\n    }\n  "]);
  return qt = function qt() {
    return n;
  }, n;
}

function Ht() {
  var n = P(["\n  width: 100%;\n  box-sizing: border-box;\n  margin-top: auto;\n  padding: ", ";\n\n  display: flex;\n  justify-content: flex-end;\n\n  ", "\n\n  ", "\n  ", "\n"]);
  return Ht = function Ht() {
    return n;
  }, n;
}

var Vt = o.div(Ht(), function (n) {
  return n.theme.space.larger;
}, function (n) {
  var e = n.theme;
  return r.css(qt(), e.mediaQueries.s, function (n) {
    return n.theme.space.regular + " " + n.theme.space.large;
  });
}, e.space, e.layout);

function Ut() {
  var n = P(["\n    ", " {\n      padding: ", ";\n    }\n  "]);
  return Ut = function Ut() {
    return n;
  }, n;
}

function Gt() {
  var n = P(["\n  padding: ", ";\n  padding-right: ", ";\n  box-sizing: border-box;\n  max-height: 100%;\n\n  ", "\n\n  ", "\n  ", "\n"]);
  return Gt = function Gt() {
    return n;
  }, n;
}

var Wt = {
  "pt-br": {
    close: "Fechar notificação"
  },
  "en-us": {
    close: "Close notification"
  },
  "es-mx": {
    close: "Cerrar notificación"
  },
  "es-co": {
    close: "Cerrar notificación"
  }
},
    Qt = function Qt(n) {
  var e = n.children,
      r = n.onClose,
      o = n.closeAriaLabel,
      u = n.open,
      c = n.id,
      d = void 0 === c ? "pomodoro-modal-root" : c,
      m = n.size,
      p = void 0 === m ? "m" : m,
      h = n.zIndexCustom,
      g = void 0 === h ? 1e3 : h,
      v = O(n, ["children", "onClose", "closeAriaLabel", "open", "id", "size", "zIndexCustom"]),
      b = l.useContext(J).locale,
      y = W(u, r),
      x = y.elementToFocusRef,
      k = y.onKeyDown;
  G(u);
  var w = f().Portal,
      E = a.pick(v),
      C = Y(v);
  return s.createElement(w, {
    id: d
  }, s.createElement(i.AnimatePresence, null, u && s.createElement(Mt, {
    zIndexCustom: g,
    tabIndex: 0,
    onKeyDown: k,
    ref: x
  }, s.createElement(jt, Object.assign({
    initial: {
      opacity: 0,
      y: 100
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: 100
    },
    transition: {
      duration: .25
    },
    size: p
  }, C, E), r ? s.createElement(At, {
    role: "button",
    onClick: r,
    component: t.Close,
    size: "s",
    "aria-label": o || Wt[b].close
  }) : null, e), s.createElement(Rt, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: .5
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: .15
    }
  }))));
};

function Jt() {
  var n = P(["\n    &[data-popper-placement='right-start'],\n    &[data-popper-placement='left-start'] {\n      ", " {\n        &::before {\n          top: ", ";\n        }\n      }\n    }\n\n    &[data-popper-placement='right-end'],\n    &[data-popper-placement='left-end'] {\n      ", " {\n        &::before {\n          top: -", ";\n        }\n      }\n    }\n  "]);
  return Jt = function Jt() {
    return n;
  }, n;
}

function Xt() {
  var n = P(["\n  z-index: 10;\n  opacity: ", ";\n  visibility: ", ";\n  transition: ", ";\n\n  ", "\n\n  ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  return Xt = function Xt() {
    return n;
  }, n;
}

function Kt() {
  var n = P(["\n    padding: ", " ", ";\n    border-radius: ", ";\n    font-size: ", ";\n    box-shadow: ", ";\n    color: ", ";\n    background-color: ", ";\n\n    ", " {\n      &::before {\n        border-bottom: ", " solid\n          ", ";\n        background: transparent;\n      }\n    }\n  "]);
  return Kt = function Kt() {
    return n;
  }, n;
}

function Zt() {
  var n = P(["\n  ", ";\n"]);
  return Zt = function Zt() {
    return n;
  }, n;
}

function Yt() {
  var n = P(["\n    padding: ", " ", ";\n    border-radius: ", ";\n    font-size: ", ";\n    box-shadow: ", ";\n    color: ", ";\n    background-color: ", ";\n\n    ", " {\n      &::before {\n        border-bottom: ", " solid ", ";\n        background: transparent;\n      }\n    }\n  "]);
  return Yt = function Yt() {
    return n;
  }, n;
}

function $t() {
  var n = P(["\n  ", ";\n"]);
  return $t = function $t() {
    return n;
  }, n;
}

function nr() {
  var n = P(["\n    &[data-popper-placement^='left'] {\n      ", " {\n        right: -", ";\n\n        &::before {\n          transform: rotate(90deg);\n        }\n      }\n    }\n  "]);
  return nr = function nr() {
    return n;
  }, n;
}

function er() {
  var n = P(["\n  ", ";\n"]);
  return er = function er() {
    return n;
  }, n;
}

function tr() {
  var n = P(["\n    &[data-popper-placement^='bottom'] {\n      ", " {\n        top: -", ";\n\n        &::before {\n          right: 50%;\n          left: 50%;\n          transform: translateX(-50%);\n        }\n      }\n    }\n  "]);
  return tr = function tr() {
    return n;
  }, n;
}

function rr() {
  var n = P(["\n  ", ";\n"]);
  return rr = function rr() {
    return n;
  }, n;
}

function or() {
  var n = P(["\n    &[data-popper-placement^='right'] {\n      ", " {\n        left: -", ";\n\n        &::before {\n          transform: rotate(-90deg);\n        }\n      }\n    }\n  "]);
  return or = function or() {
    return n;
  }, n;
}

function ir() {
  var n = P(["\n  ", ";\n"]);
  return ir = function ir() {
    return n;
  }, n;
}

function ar() {
  var n = P(["\n    &[data-popper-placement^='top'] {\n      ", " {\n        bottom: -", ";\n\n        &::before {\n          right: 50%;\n          left: 50%;\n          transform: translateX(-50%) rotate(180deg);\n        }\n      }\n    }\n  "]);
  return ar = function ar() {
    return n;
  }, n;
}

function ur() {
  var n = P(["\n  ", ";\n"]);
  return ur = function ur() {
    return n;
  }, n;
}

function cr() {
  var n = P(["\n    width: ", ";\n    height: ", ";\n\n    &::before {\n      display: inline-block;\n      position: absolute;\n      content: '';\n      width: 0;\n      height: 0;\n      top: 0;\n      border-left: ", " solid transparent;\n      border-right: ", " solid transparent;\n    }\n  "]);
  return cr = function cr() {
    return n;
  }, n;
}

function lr() {
  var n = P(["\n  z-index: 10;\n\n  ", ";\n"]);
  return lr = function lr() {
    return n;
  }, n;
}

function sr() {
  var n = P(["\n  cursor: pointer;\n  display: inline-block;\n"]);
  return sr = function sr() {
    return n;
  }, n;
}

Qt.Header = o.div(Gt(), function (n) {
  return n.theme.space.larger;
}, function (n) {
  return n.theme.space.loosest;
}, function (n) {
  var e = n.theme;
  return r.css(Ut(), e.mediaQueries.s, function (n) {
    return n.theme.space.regular + " " + n.theme.space.large;
  });
}, e.space, e.layout), Qt.Body = Bt, Qt.Footer = Vt, Qt.propTypes = {
  onClose: c.func,
  closeAriaLabel: c.string,
  open: c.bool.isRequired,
  id: c.string
};

var fr = o.div(sr()),
    dr = o.div(lr(), function (n) {
  var e = n.theme;
  return r.css(cr(), e.space.smaller, e.space.smaller, e.space.smaller, e.space.smaller);
}),
    mr = r.css(ur(), function (n) {
  var e = n.theme;
  return r.css(ar(), dr, e.space.smaller);
}),
    pr = r.css(ir(), function (n) {
  var e = n.theme;
  return r.css(or(), dr, e.space.small);
}),
    hr = r.css(rr(), function (n) {
  var e = n.theme;
  return r.css(tr(), dr, e.space.smaller);
}),
    gr = r.css(er(), function (n) {
  var e = n.theme;
  return r.css(nr(), dr, e.space.smallest);
}),
    vr = r.css($t(), function (n) {
  var e = n.theme;
  return r.css(Yt(), e.space.smaller, e.space.regular, e.radii.m, e.fontSizes.s, e.shadows.elevate, e.colors.white, e.colors.black, dr, e.space.smaller, e.colors.black);
}),
    br = r.css(Zt(), function (n) {
  var e = n.theme;
  return r.css(Kt(), e.space.regular, e.space.large, e.radii.m, e.fontSizes.s, e.shadows.elevate, e.colors.black, e.colors.informationLightest, dr, e.space.smaller, e.colors.informationLightest);
}),
    yr = o.div(Xt(), function (n) {
  return n.visible ? 1 : 0;
}, function (n) {
  return n.visible ? "visible" : "hidden";
}, function (n) {
  var e = n.theme.durations;
  return Z([["opacity", e.immediately], ["visibility", e.immediately]]);
}, function (n) {
  switch (n.variant) {
    case "neutral":
      return vr;

    case "information":
      return br;

    case "none":
    default:
      return null;
  }
}, function (n) {
  var e = n.theme;
  return r.css(Jt(), dr, e.space.smallest, dr, e.space.smaller);
}, mr, pr, hr, gr),
    xr = function xr(n) {
  var e = n.children,
      t = n.content,
      r = n.placement,
      o = void 0 === r ? "top" : r,
      i = n.variant,
      a = void 0 === i ? "neutral" : i,
      u = n.trigger,
      c = void 0 === u ? "hover" : u,
      f = n.visible,
      d = void 0 !== f && f,
      m = n.autoclose,
      p = void 0 !== m && m,
      g = n.withArrow,
      v = void 0 === g || g,
      b = n.offset,
      y = void 0 === b ? [0, 12] : b,
      x = O(n, ["children", "content", "placement", "variant", "trigger", "visible", "autoclose", "withArrow", "offset"]),
      k = Y(x),
      w = k["data-testid"],
      E = O(k, ["data-testid"]),
      C = l.useState(d),
      z = C[0],
      D = C[1],
      S = l.useState(null),
      P = S[0],
      I = S[1],
      _ = l.useState(null),
      L = _[0],
      T = _[1],
      M = l.useState(null),
      j = M[0],
      R = M[1],
      A = l.useMemo(function () {
    return [{
      name: "arrow",
      options: {
        element: j
      }
    }, {
      name: "flip",
      enabled: !0,
      options: {
        allowedAutoPlacements: ["top", "bottom"]
      }
    }, {
      name: "offset",
      options: {
        offset: y
      }
    }];
  }, [j, y]),
      N = h.usePopper(P, L, {
    placement: o,
    modifiers: A
  }),
      F = N.styles,
      B = N.attributes,
      q = N.update,
      H = l.useCallback(function () {
    D(function (n) {
      return n && (null == q || q()), !n;
    });
  }, [q, D]),
      V = l.useCallback(function () {
    null == q || q(), D(!0);
  }, [q, D]),
      U = l.useCallback(function () {
    D(!1);
  }, [D]),
      G = l.useMemo(function () {
    switch (c) {
      case "click":
        return {
          onClick: function onClick() {
            return H();
          }
        };

      case "hover":
        return {
          onMouseEnter: function onMouseEnter() {
            return V();
          },
          onMouseLeave: function onMouseLeave() {
            return U();
          }
        };

      case "none":
      default:
        return {};
    }
  }, [U, V, H, c]);

  return function (n, e) {
    l.useEffect(function () {
      e(n);
    }, [n, e]);
  }(d, D), function (n, e, t, r) {
    var o = l.useCallback(function (n) {
      (null == e ? void 0 : e.contains(n.target)) || r(!1);
    }, [e, r]);
    l.useEffect(function () {
      return n && (t ? document.addEventListener("mousedown", o) : document.removeEventListener("mousedown", o)), function () {
        return document.removeEventListener("mousedown", o);
      };
    }, [n, t, o]);
  }(p, P, z, D), s.createElement(s.Fragment, null, s.createElement(fr, Object.assign({
    ref: I
  }, G, E), e), s.createElement(yr, Object.assign({
    "data-testid": w,
    ref: T,
    visible: z,
    variant: a,
    style: F.popper
  }, B.popper), t, v && s.createElement(dr, {
    ref: R,
    style: F.arrow
  })));
};

function kr() {
  var n = P(["\n  border-width: 0 0 1px 0;\n  border-bottom-style: solid;\n  border-bottom-color: ", ";\n  ", "\n  ", "\n"]);
  return kr = function kr() {
    return n;
  }, n;
}

xr.propTypes = {
  content: c.oneOfType([c.arrayOf(c.node), c.node, c.string.isRequired]).isRequired,
  placement: c.oneOf(["auto", "auto-start", "auto-end", "top", "bottom", "right", "left", "top-start", "top-end", "bottom-start", "bottom-end", "right-start", "right-end", "left-start", "left-end"]),
  variant: c.oneOf(["none", "neutral", "information"]),
  trigger: c.oneOf(["none", "hover", "click"]),
  visible: c.bool,
  autoclose: c.bool,
  withArrow: c.bool,
  offset: c.arrayOf(function (n) {
    return n.length > 2 ? new Error("offset must be an array with the settings: [X-axis, Y-axis]") : null;
  })
};
var wr = o.hr(kr(), function (n) {
  return n.theme.colors.gray;
}, e.space, e.layout);

function Er() {
  var n = P(["\n    ", " {\n      top: ", ";\n      right: ", ";\n    }\n  "]);
  return Er = function Er() {
    return n;
  }, n;
}

function Cr() {
  var n = P(["\n  cursor: pointer;\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  color: ", ";\n\n  ", "\n"]);
  return Cr = function Cr() {
    return n;
  }, n;
}

function zr() {
  var n = P(["\n      z-index: ", ";\n    "]);
  return zr = function zr() {
    return n;
  }, n;
}

function Dr() {
  var n = P(["\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: black;\n  overflow: hidden;\n  opacity: 0.5;\n\n  ", ";\n"]);
  return Dr = function Dr() {
    return n;
  }, n;
}

function Sr() {
  var n = P(["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  z-index: 110;\n  background: white;\n\n  ", "\n"]);
  return Sr = function Sr() {
    return n;
  }, n;
}

function Or() {
  var n = P(["\n        height: 100%;\n\n        @media (min-width: ", ") {\n          max-width: ", ";\n        }\n      "]);
  return Or = function Or() {
    return n;
  }, n;
}

function Pr() {
  var n = P(["\n        @media (max-width: ", ") {\n          height: 100%;\n        }\n\n        @media (min-width: ", ") {\n          max-height: ", ";\n        }\n      "]);
  return Pr = function Pr() {
    return n;
  }, n;
}

function Ir() {
  var n = P(["\n  position: fixed;\n  z-index: ", ";\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: ", ";\n  align-items: ", ";\n  overflow: hidden;\n"]);
  return Ir = function Ir() {
    return n;
  }, n;
}

var _r = {
  xs: "280px",
  s: "380px",
  m: "506px",
  l: "672px",
  xl: "768px"
},
    Lr = {
  top: "flex-start",
  left: "flex-start",
  bottom: "flex-end",
  right: "flex-end"
},
    Tr = o.div(Ir(), function (n) {
  return n.zIndex;
}, function (n) {
  return Lr[n.placement];
}, function (n) {
  return Lr[n.placement];
}),
    Mr = o(i.motion.div)(Sr(), function (n) {
  return function (n, e) {
    return ["top", "bottom"].includes(e) ? r.css(Pr(), function (n) {
      return n.theme.screens.s.max;
    }, function (n) {
      return n.theme.screens.m.min;
    }, _r[n]) : r.css(Or(), function (n) {
      return n.theme.screens.m.min;
    }, _r[n]);
  }(n.size, n.placement);
}),
    jr = o(i.motion.div)(Dr(), function (n) {
  return r.css(zr(), n.parentZIndex && "number" == typeof n.parentZIndex ? n.parentZIndex - 1 : 100);
}),
    Rr = o(Pn)(Cr(), function (n) {
  return n.theme.space.larger;
}, function (n) {
  return n.theme.space.larger;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  var e = n.theme;
  return r.css(Er(), e.mediaQueries.s, function (n) {
    return n.theme.space.regular;
  }, function (n) {
    return n.theme.space.large;
  });
});

function Ar() {
  var n = P(["\n    ", " {\n      padding: 0 ", ";\n    }\n  "]);
  return Ar = function Ar() {
    return n;
  }, n;
}

function Nr() {
  var n = P(["\n  width: 100%;\n  padding: 0 ", ";\n  box-sizing: border-box;\n  max-height: 100%;\n  overflow: auto;\n\n  ", "\n\n  ", "\n  ", "\n"]);
  return Nr = function Nr() {
    return n;
  }, n;
}

var Fr = o.div(Nr(), function (n) {
  return n.theme.space.larger;
}, function (n) {
  var e = n.theme;
  return r.css(Ar(), e.mediaQueries.s, function (n) {
    return n.theme.space.large;
  });
}, e.space, e.layout);

function Br() {
  var n = P(["\n    ", " {\n      padding: ", ";\n    }\n  "]);
  return Br = function Br() {
    return n;
  }, n;
}

function qr() {
  var n = P(["\n  width: 100%;\n  box-sizing: border-box;\n  margin-top: auto;\n  padding: ", ";\n  display: flex;\n  justify-content: flex-end;\n\n  ", "\n\n  ", "\n  ", "\n"]);
  return qr = function qr() {
    return n;
  }, n;
}

var Hr = o.div(qr(), function (n) {
  return n.theme.space.larger;
}, function (n) {
  var e = n.theme;
  return r.css(Br(), e.mediaQueries.s, function (n) {
    return n.theme.space.regular + " " + n.theme.space.large;
  });
}, e.space, e.layout);

function Vr() {
  var n = P(["\n    ", " {\n      padding: ", ";\n    }\n  "]);
  return Vr = function Vr() {
    return n;
  }, n;
}

function Ur() {
  var n = P(["\n  padding: ", ";\n  box-sizing: border-box;\n  max-height: 100%;\n\n  ", "\n\n  ", "\n  ", "\n"]);
  return Ur = function Ur() {
    return n;
  }, n;
}

var Gr = {
  "pt-br": {
    close: "Fechar notificação"
  },
  "en-us": {
    close: "Close notification"
  },
  "es-mx": {
    close: "Cerrar notificación"
  },
  "es-co": {
    close: "Cerrar notificación"
  }
},
    Wr = {
  top: {
    y: "-100%"
  },
  left: {
    x: "-100%"
  },
  bottom: {
    y: "100%"
  },
  right: {
    x: "100%"
  }
},
    Qr = function Qr(n) {
  var e = n.children,
      r = n.onClose,
      o = n.closeAriaLabel,
      u = n.open,
      c = n.id,
      d = void 0 === c ? "pomodoro-modal-root" : c,
      m = n.size,
      p = void 0 === m ? "xs" : m,
      h = n.placement,
      g = void 0 === h ? "right" : h,
      v = n.zIndex,
      b = void 0 === v ? 1e3 : v,
      y = O(n, ["children", "onClose", "closeAriaLabel", "open", "id", "size", "placement", "zIndex"]),
      x = l.useContext(J).locale,
      k = W(u, r),
      w = k.elementToFocusRef,
      E = k.onKeyDown;
  G(u);
  var C = f().Portal,
      z = a.pick(y),
      D = Y(y);
  return s.createElement(C, {
    id: d
  }, s.createElement(i.AnimatePresence, null, u && s.createElement(s.Fragment, null, s.createElement(Tr, {
    placement: g,
    zIndex: b
  }, s.createElement(Mr, Object.assign({
    size: p,
    initial: S({
      opacity: 0
    }, Wr[g]),
    animate: {
      opacity: 1,
      x: 0,
      y: 0
    },
    exit: S({
      opacity: 0
    }, Wr[g]),
    transition: {
      duration: .25
    },
    placement: g
  }, D, z, {
    tabIndex: 0,
    onKeyDown: E,
    ref: w
  }), r ? s.createElement(Rr, {
    role: "button",
    onClick: r,
    component: t.Close,
    size: "s",
    "aria-label": o || Gr[x].close
  }) : null, e)), s.createElement(jr, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: .5
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: .15
    },
    parentZIndex: b
  }))));
};

function Jr() {
  var n = P(["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  display: block;\n  margin-bottom: ", ";\n  text-align: center;\n  max-width: 370px;\n"]);
  return Jr = function Jr() {
    return n;
  }, n;
}

function Xr() {
  var n = P(["\n  font-weight: bold;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin: 0;\n  margin-bottom: ", ";\n"]);
  return Xr = function Xr() {
    return n;
  }, n;
}

function Kr() {
  var n = P(["\n  width: 120px;\n  height: auto;\n  font-weight: bold;\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  margin: ", ";\n"]);
  return Kr = function Kr() {
    return n;
  }, n;
}

function Zr() {
  var n = P(["\n  display: grid;\n  align-items: center;\n  justify-items: center;\n  font-family: ", ";\n\n  ", "\n  ", "\n"]);
  return Zr = function Zr() {
    return n;
  }, n;
}

Qr.Header = o.div(Ur(), function (n) {
  return n.theme.space.larger;
}, function (n) {
  var e = n.theme;
  return r.css(Vr(), e.mediaQueries.s, function (n) {
    return n.theme.space.regular + " " + n.theme.space.large;
  });
}, e.space, e.layout), Qr.Body = Fr, Qr.Footer = Hr, Qr.propTypes = {
  onClose: c.func,
  closeAriaLabel: c.string,
  open: c.bool.isRequired,
  id: c.string,
  size: c.oneOf(["xs", "s", "m", "l", "xl"]),
  zIndex: c.oneOfType([c.oneOf(["-moz-initial", "inherit", "initial", "revert", "unset", "auto"]), c.number])
};
var Yr = o.div(Zr(), function (n) {
  return n.theme.fonts.secondary;
}, e.space, e.layout),
    $r = o.img(Kr(), function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.large;
}, function (n) {
  return n.theme.space.large;
}, function (n) {
  return n.theme.space.regular;
}),
    no = o.p(Xr(), function (n) {
  return n.theme.fontSizes.l;
}, function (n) {
  return n.theme.lineHeights.l;
}, function (n) {
  return n.theme.colors.black;
}, function (n) {
  return n.theme.space.regular;
}),
    eo = o.span(Jr(), function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.colors.grayDarkest;
}, function (n) {
  return n.theme.space.larger;
});

function to(n) {
  return !!n && "string" == typeof n;
}

var ro = function ro(n) {
  var e = n.title,
      t = n.description,
      r = n.imgSrc,
      o = n.imgAlt,
      i = n.children,
      u = O(n, ["title", "description", "imgSrc", "imgAlt", "children"]),
      c = a.pick(u),
      l = Y(u);
  return s.createElement(Yr, Object.assign({}, c, l), function (n, e) {
    var t = to(n),
        r = to(e);
    return t && r;
  }(r, o) && s.createElement($r, {
    src: r,
    alt: o
  }), s.createElement(no, null, e), s.createElement(eo, null, t), i);
};

ro.propTypes = {
  title: c.string.isRequired,
  description: c.string.isRequired,
  imgSrc: c.string,
  imgAlt: c.string
};
var oo = {
  large: "48px",
  medium: "32px",
  small: "24px",
  xsmall: "16px"
},
    io = {
  large: "4px",
  medium: "2.67px",
  small: "2px",
  xsmall: "1.33px"
},
    ao = {
  large: "6px",
  medium: "4px",
  small: "3px",
  xsmall: "2px"
};

function uo() {
  var n = P(["\n   0%, 25% {\n    stroke-dashoffset: 280;\n    transform: rotate(0);\n  }\n  50%, 75% {\n    stroke-dashoffset: 75;\n    transform: rotate(45deg);\n  }\n  100% {\n    stroke-dashoffset: 280;\n    transform: rotate(360deg);\n  }\n"]);
  return uo = function uo() {
    return n;
  }, n;
}

function co() {
  var n = P(["\n  0% { transform: rotateZ(0deg); }\n  100% { transform: rotateZ(360deg) }\n"]);
  return co = function co() {
    return n;
  }, n;
}

var lo = r.keyframes(co()),
    so = r.keyframes(uo());

function fo() {
  var n = P([""]);
  return fo = function fo() {
    return n;
  }, n;
}

function mo() {
  var n = P(["\n  animation: 1.4s ease-in-out infinite both ", ";\n  fill: transparent;\n  stroke-dasharray: 285;\n  stroke-linecap: round;\n  stroke-width: ", ";\n  ", "\n  transform-origin: 50% 50%;\n"]);
  return mo = function mo() {
    return n;
  }, n;
}

function po() {
  var n = P(["\n  animation: 2s linear infinite both ", ";\n"]);
  return po = function po() {
    return n;
  }, n;
}

function ho() {
  var n = P([""]);
  return ho = function ho() {
    return n;
  }, n;
}

function go() {
  var n = P(["\n  box-sizing: border-box;\n  padding: ", ";\n  height: ", ";\n  width: ", ";\n  margin: auto;\n"]);
  return go = function go() {
    return n;
  }, n;
}

var vo = e.system({
  color: {
    property: "stroke",
    scale: "colors"
  }
}),
    bo = o.div.attrs({
  role: "progressbar",
  "aria-label": "Loading"
})(go(), function (n) {
  return io[n.variant];
}, function (n) {
  return oo[n.variant];
}, function (n) {
  return oo[n.variant];
}),
    yo = o.div(ho()),
    xo = o.svg.attrs({
  viewBox: "0 0 100 100"
})(po(), lo),
    ko = o.circle.attrs({
  cx: "50",
  cy: "50",
  r: "45"
})(mo(), so, function (n) {
  return ao[n.variant];
}, vo),
    wo = o(Dt).attrs({
  display: "block",
  textAlign: "center",
  fontFamily: "primary",
  fontSize: "14px",
  marginTop: "regular",
  "aria-hidden": !0
})(fo()),
    Eo = function n(e) {
  return s.createElement(n.Frame, {
    variant: e.variant
  }, s.createElement(n.OutterCircle, null, s.createElement(n.InnerCircle, {
    variant: e.variant,
    color: e.color
  })));
};

Eo.Frame = bo, Eo.OutterCircle = xo, Eo.InnerCircle = ko;

var Co,
    zo = function n(e) {
  var t = e.color,
      r = e.variant,
      o = O(e, ["color", "variant"]);
  return s.createElement(n.Wrapper, Object.assign({}, o), s.createElement(n.Spinner, {
    color: t,
    variant: r
  }), s.createElement(n.Text, null, o.children));
};

function Do() {
  var n = P(["\n  display: flex;\n  align-items: center;\n"]);
  return Do = function Do() {
    return n;
  }, n;
}

function So() {
  var n = P(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: ", ";\n  ", "\n  ", "\n"]);
  return So = function So() {
    return n;
  }, n;
}

zo.defaultProps = {
  variant: "large",
  color: "primary"
}, zo.Wrapper = yo, zo.Text = wo, zo.Spinner = Eo, function (n) {
  n.left = "left", n.center = "center", n.right = "right";
}(Co || (Co = {}));
var Oo = o.div(So(), function (n) {
  var e = n.position,
      t = void 0 === e ? Co.left : e;
  return t === Co.right ? "flex-end" : t === Co.center ? "center" : "flex-start";
}, e.space, e.layout),
    Po = o(Be).attrs(function () {
  return {
    variant: "tertiary",
    type: "button"
  };
})(Do()),
    Io = {
  "pt-br": {
    of: "de",
    showing: "Exibindo",
    next: "Próximo",
    previous: "Anterior",
    perPage: "Itens por página"
  },
  "en-us": {
    of: "of",
    showing: "Showing",
    next: "Next",
    previous: "Previous",
    perPage: "Items per page"
  },
  "es-mx": {
    of: "de",
    showing: "Exibindo",
    next: "Próxima",
    previous: "Previa",
    perPage: "Itens por página"
  },
  "es-co": {
    of: "de",
    showing: "Exibindo",
    next: "Próxima",
    previous: "Previa",
    perPage: "Artículos por página"
  }
};

function _o() {
  var n = P(["\n  color: ", ";\n"]);
  return _o = function _o() {
    return n;
  }, n;
}

function Lo() {
  var n = P(["\n  border: ", ";\n  color: ", ";\n  background-color: ", ";\n"]);
  return Lo = function Lo() {
    return n;
  }, n;
}

function To() {
  var n = P(["\n  border: solid 1px ", ";\n"]);
  return To = function To() {
    return n;
  }, n;
}

function Mo() {
  var n = P(["\n  border: none;\n  height: auto;\n\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  flex-grow: 1;\n\n  &:focus {\n    outline: none;\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &[disabled] {\n    background-color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"]);
  return Mo = function Mo() {
    return n;
  }, n;
}

function jo() {
  var n = P(["\n  border: ", ";\n  border-radius: ", ";\n  overflow: hidden;\n\n  transition: ", ";\n\n  &:focus-within {\n    outline: none;\n    border: ", ";\n    box-shadow: 0 0 0 1px ", ";\n  }\n"]);
  return jo = function jo() {
    return n;
  }, n;
}

var Ro = r.css(jo(), function (n) {
  return "solid 1px " + n.theme.colors.gray;
}, function (n) {
  return n.theme.radii.m;
}, function (n) {
  var e = n.theme;
  return Z([["box-shadow", e.durations.quickly, e.timingFunctions.easeInOut]]);
}, function (n) {
  return "solid 1px " + n.theme.colors.primary;
}, function (n) {
  return n.theme.colors.primary;
}),
    Ao = r.css(Mo(), function (n) {
  return n.theme.fonts.primary;
}, function (n) {
  return n.theme.fontSizes.m;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.colors.black;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.colors.gray;
}, function (n) {
  return n.theme.colors.grayDarker;
}),
    No = r.css(To(), function (n) {
  return n.theme.colors.error;
}),
    Fo = r.css(Lo(), function (n) {
  return "solid 1px " + n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.colors.gray;
}),
    Bo = r.css(_o(), function (n) {
  return n.theme.colors.grayDarkest;
});

function qo() {
  var n = P(["\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  max-height: 150px;\n  overflow-y: auto;\n\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n  ", "\n"]);
  return qo = function qo() {
    return n;
  }, n;
}

function Ho() {
  var n = P(["\n  cursor: pointer;\n  box-sizing: border-box;\n\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n\n  &.selected {\n    background-color: ", ";\n  }\n"]);
  return Ho = function Ho() {
    return n;
  }, n;
}

var Vo = o.li.attrs({
  role: "option",
  "aria-selected": !1
})(Ho(), function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.colors.black;
}, function (n) {
  return n.theme.colors.grayLight;
}),
    Uo = o.ul.attrs({
  role: "listbox"
})(qo(), e.layout, e.space);

function Go() {
  var n = P(["\n  font-weight: bold;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n\n  margin-bottom: ", ";\n\n  ", "\n  ", "\n"]);
  return Go = function Go() {
    return n;
  }, n;
}

var Wo = o.label(Go(), function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.colors.black;
}, function (n) {
  return n.theme.space.smallest;
}, e.space, e.layout);

function Qo() {
  var n = P(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n\n  margin-top: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n"]);
  return Qo = function Qo() {
    return n;
  }, n;
}

var Jo = o.span(Qo(), function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.fontSizes.xs;
}, function (n) {
  return n.theme.lineHeights.s;
}, function (n) {
  return n.theme.colors.error;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.smaller;
});

function Xo() {
  var n = P([""]);
  return Xo = function Xo() {
    return n;
  }, n;
}

function Ko() {
  var n = P(["\n          color: ", ";\n        "]);
  return Ko = function Ko() {
    return n;
  }, n;
}

function Zo() {
  var n = P(["\n  font-family: ", ";\n  line-height: ", ";\n\n  ", "\n\n  margin-top: 2px;\n  margin-left: auto;\n  padding-left: ", ";\n  padding-right: ", ";\n\n  background-color: ", ";\n  border-radius: ", ";\n"]);
  return Zo = function Zo() {
    return n;
  }, n;
}

var Yo = o.div(Zo(), function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.disabled ? r.css(Ko(), n.theme.colors.grayDarker) : r.css(Xo());
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.colors.grayLight;
}, function (n) {
  return n.theme.radii.m;
}),
    $o = function $o(n) {
  return s.createElement(Yo, {
    disabled: n.disabled
  }, n.children);
},
    ni = function ni(n) {
  var e, t;
  return (null == n || null === (e = n.current) || void 0 === e || null === (t = e.value) || void 0 === t ? void 0 : t.length) || 0;
};

function ei(n) {
  var e = l.useState(ni(n)),
      t = e[0],
      r = e[1];
  return l.useEffect(function () {
    r(ni(n));
    var e = null == n ? void 0 : n.current,
        t = g(function () {
      r(ni(n));
    }),
        o = new MutationObserver(t);
    return e && (o.observe(e, {
      childList: !0,
      attributes: !0
    }), e.addEventListener("input", t)), function () {
      o.disconnect(), null == e || e.removeEventListener("input", t);
    };
  }, [n]), t;
}

function ti() {
  var n = P(["\n  display: flex;\n  justify-content: space-between;\n"]);
  return ti = function ti() {
    return n;
  }, n;
}

function ri() {
  var n = P(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  ", "\n  ", "\n"]);
  return ri = function ri() {
    return n;
  }, n;
}

var oi = o.div(ri(), e.layout, e.space),
    ii = o.div(ti()),
    ai = function ai(n) {
  var e = n.children,
      t = n.error,
      r = n.label,
      o = n.id,
      i = n.disabled,
      a = n.showCounter,
      u = n.elementRef,
      c = O(n, ["children", "error", "label", "id", "disabled", "showCounter", "elementRef"]),
      l = ei(u);
  return s.createElement(oi, Object.assign({}, {}, c), r && s.createElement(Wo, {
    htmlFor: o
  }, r), e, s.createElement(ii, null, t && s.createElement(Jo, {
    role: "alert"
  }, t), a && s.createElement($o, {
    disabled: i
  }, l)));
};

function ui() {
  var n = P(["\n  width: ", ";\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  line-height: 0;\n"]);
  return ui = function ui() {
    return n;
  }, n;
}

function ci() {
  var n = P(["\n  color: ", ";\n"]);
  return ci = function ci() {
    return n;
  }, n;
}

ai.propTypes = {
  error: c.string,
  label: c.string,
  id: c.string,
  disabled: c.bool,
  showCounter: c.bool
};

var li = o.div(ci(), function (n) {
  return n.theme.colors.error;
}),
    si = o.div(ui(), function (n) {
  return n.size + "px";
}),
    fi = function fi(n) {
  var e = n.error,
      o = n.children,
      i = n.className,
      a = l.useContext(r.ThemeContext),
      u = Boolean(e),
      c = l.Children.count(o),
      f = parseInt(a.space.large),
      d = parseInt(a.space.smallest);
  return s.createElement(si, {
    size: (f + d) * (c + 1),
    className: i
  }, o, u && s.createElement(li, null, s.createElement(Pn, {
    component: t.AlertFilled,
    size: "s"
  })));
};

function di() {
  var n = P(["\n  ", "\n  visibility: ", ";\n  background-color: ", ";\n  z-index: 99;\n\n  &:focus-within {\n    outline: none;\n    border: ", ";\n    box-shadow: ", ";\n  }\n"]);
  return di = function di() {
    return n;
  }, n;
}

fi.propTypes = {
  error: c.string,
  className: c.string
};

var mi = o.div(di(), Ro, function (n) {
  return n.visible ? "visible" : "hidden";
}, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return "solid 1px " + n.theme.colors.gray;
}, function (n) {
  return n.theme.shadows.none;
}),
    pi = function pi(n) {
  var e = n.visible,
      t = n.referenceElement,
      r = n.children,
      o = l.useState(null),
      i = o[0],
      a = o[1],
      u = l.useMemo(function () {
    return [{
      name: "sameWidth",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function fn(n) {
        var e = n.state;
        e.styles.popper.width = e.rects.reference.width + "px";
      }
    }];
  }, []),
      c = h.usePopper(t, i, {
    placement: "bottom-start",
    modifiers: u
  }),
      f = c.styles,
      d = c.attributes,
      m = c.forceUpdate;
  return l.useEffect(function () {
    e && m && m();
  }, [e, m]), s.createElement(mi, Object.assign({
    ref: a,
    style: f.popper,
    visible: e
  }, d.popper), r);
};

function hi() {
  var n = P(["\n  color: ", ";\n"]);
  return hi = function hi() {
    return n;
  }, n;
}

function gi() {
  var n = P(["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"]);
  return gi = function gi() {
    return n;
  }, n;
}

function vi() {
  var n = P([""]);
  return vi = function vi() {
    return n;
  }, n;
}

function bi() {
  var n = P(["\n  ", "\n\n  cursor: pointer;\n  display: inline-flex;\n  width: 100%;\n  justify-content: space-between;\n  box-sizing: border-box;\n  background-color: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n\n  ", ";\n"]);
  return bi = function bi() {
    return n;
  }, n;
}

var yi = o.button(bi(), Ro, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.colors.grayDarkest;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.disabled ? Fo : r.css(vi());
}),
    xi = o.span(gi()),
    ki = o(Pn)(hi(), function (n) {
  return "" + n.theme.colors.primary;
}),
    wi = function wi(n) {
  return (null == n ? void 0 : n.name) ? n.name : "";
},
    Ei = l.forwardRef(function (n, e) {
  var r = n.label,
      o = n.error,
      i = n.items,
      u = void 0 === i ? [] : i,
      c = n.onChange,
      f = n.placeholder,
      d = n.onBlur,
      m = n.value,
      p = n.name,
      h = n.disabled,
      g = n.itemListStyleProps,
      b = O(n, ["label", "error", "items", "onChange", "placeholder", "onBlur", "value", "name", "disabled", "itemListStyleProps"]),
      y = a.pick(b),
      x = Y(b),
      k = X(e),
      w = l.useCallback(function (n) {
    var e,
        t = (null == (e = n.selectedItem) ? void 0 : e.value) ? e.value : "";
    (null == k ? void 0 : k.current) && k.current.value !== t && (k.current.value = t, k.current.dispatchEvent(new Event("input", {
      bubbles: !0
    })));
  }, [k]),
      E = v.useSelect({
    items: u,
    itemToString: wi,
    onSelectedItemChange: w
  }),
      C = E.selectedItem,
      z = E.selectItem,
      D = E.getToggleButtonProps,
      S = E.getLabelProps,
      P = E.getMenuProps,
      I = E.highlightedIndex,
      _ = E.getItemProps,
      L = E.reset,
      T = E.isOpen && !h;
  l.useEffect(function () {
    m ? z(m) : L();
  }, [z, m, L]);
  var M = l.useState(null),
      j = M[0],
      R = M[1],
      A = l.useCallback(function (n) {
    var e = u.find(function (e) {
      return e.value === n.target.value;
    });
    e && z(e), null == c || c(n);
  }, [c, z, u]),
      N = S();
  return s.createElement(ai, Object.assign({
    error: o
  }, y, x, {
    disabled: h
  }), r && s.createElement(Wo, Object.assign({}, N), r), s.createElement("div", {
    ref: R
  }, s.createElement(yi, Object.assign({}, D({
    type: "button",
    disabled: h,
    onBlur: function onBlur() {
      var n;
      null == k || null === (n = k.current) || void 0 === n || n.dispatchEvent(new Event("blur", {
        bubbles: !0
      }));
    }
  }), {
    tabIndex: x.tabIndex
  }), s.createElement(xi, null, C ? wi(C) : f), s.createElement(fi, {
    error: o
  }, s.createElement(ki, {
    component: t.ChevronDown,
    size: "s"
  }))), s.createElement("input", {
    "aria-labelledby": N.id,
    ref: k,
    name: p,
    type: "hidden",
    onInput: A,
    onBlur: d,
    disabled: h
  }), s.createElement(pi, {
    referenceElement: j,
    visible: T
  }, s.createElement(Uo, Object.assign({}, g, P()), T ? u.map(function (n, e) {
    return s.createElement(Vo, Object.assign({
      className: I === e ? "selected" : "",
      key: "" + n + e
    }, _({
      item: n,
      index: e
    })), function (n) {
      return (null == n ? void 0 : n.node) ? n.node(n.name) : wi(n);
    }(n));
  }) : null))));
}),
    Ci = c.shape({
  value: c.string.isRequired,
  name: c.string.isRequired,
  node: c.func
});

function zi() {
  var n = P(["\n          color: ", ";\n        "]);
  return zi = function zi() {
    return n;
  }, n;
}

function Di() {
  var n = P(["\n  padding: ", ";\n  letter-spacing: 1px;\n  color: ", ";\n\n  ", "\n"]);
  return Di = function Di() {
    return n;
  }, n;
}

function Si() {
  var n = P(["\n  flex: 1;\n  display: flex;\n  justify-content: ", ";\n"]);
  return Si = function Si() {
    return n;
  }, n;
}

function Oi() {
  var n = P(["\n  button {\n    padding: ", ";\n  }\n"]);
  return Oi = function Oi() {
    return n;
  }, n;
}

function Pi() {
  var n = P(["\n          background-color: ", ";\n          color: ", ";\n        "]);
  return Pi = function Pi() {
    return n;
  }, n;
}

function Ii() {
  var n = P(["\n  display: flex;\n  align-items: center;\n  padding: ", ";\n  line-height: 1;\n  text-decoration: none;\n  color: ", ";\n  border-radius: ", ";\n\n  &:hover:not(:active):not(:disabled),\n  &:active {\n    cursor: pointer;\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ", "\n"]);
  return Ii = function Ii() {
    return n;
  }, n;
}

function _i() {
  var n = P(["\n  margin: 0 2px;\n  ", "\n  ", "\n"]);
  return _i = function _i() {
    return n;
  }, n;
}

function Li() {
  var n = P(["\n  padding: 0;\n  margin: 0;\n  list-style: none;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n  ", "\n"]);
  return Li = function Li() {
    return n;
  }, n;
}

function Ti() {
  var n = P(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  ", "\n  ", "\n"]);
  return Ti = function Ti() {
    return n;
  }, n;
}

Ei.propTypes = {
  items: c.arrayOf(Ci.isRequired),
  value: Ci,
  error: c.string,
  name: c.string,
  label: c.string,
  disabled: c.bool
};

var Mi = o.div(Ti(), e.space, e.layout),
    ji = o.ul(Li(), e.space, e.layout),
    Ri = o.li(_i(), e.space, e.layout),
    Ai = o(Be).attrs(function (n) {
  return {
    type: "button",
    variant: n.active ? "primary" : "tertiary"
  };
})(Ii(), function (n) {
  var e = n.theme;
  return e.space.smaller + " " + e.space.small;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.radii.m;
}, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  var e = n.theme;
  return n.active ? r.css(Pi(), e.colors.primary, e.colors.white) : void 0;
}),
    Ni = o(Ei).attrs(function () {
  return {
    style: {
      width: "auto"
    }
  };
})(Oi(), function (n) {
  return n.theme.space.smaller;
}),
    Fi = o.nav(Si(), function (n) {
  var e = n.position,
      t = void 0 === e ? Co.left : e;
  return t === Co.right ? "flex-end" : t === Co.center ? "center" : "flex-start";
}),
    Bi = o.span(Di(), function (n) {
  var e = n.theme;
  return e.space.small + " " + e.space.smallest;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  var e = n.theme;
  return n.disabled ? r.css(zi(), e.colors.grayDarker) : void 0;
}),
    qi = function qi(n, e, t) {
  var r = l.useMemo(function () {
    return function (n, e, t) {
      return n * t >= e ? Math.ceil(e / t) : n <= 0 ? 1 : n;
    }(n, t, e);
  }, [n, t, e]),
      o = l.useMemo(function () {
    return function (n, e) {
      var t = n * e;
      return t < 0 ? 0 : t;
    }(n, e);
  }, [n, e]),
      i = l.useMemo(function () {
    return function (n, e, t) {
      var r = n * t;
      return r >= e ? e : r;
    }(n, t, e);
  }, [n, t, e]),
      a = l.useMemo(function () {
    return function (n) {
      return n > 1;
    }(n);
  }, [n]),
      u = l.useMemo(function () {
    return function (n, e, t) {
      return !(n * e >= t || t < e);
    }(n, e, t);
  }, [n, e, t]);
  return {
    currentPage: r,
    totalPages: l.useMemo(function () {
      return function (n, e) {
        return Math.ceil(n / e);
      }(t, e);
    }, [t, e]),
    previousOffset: o,
    nextOffset: i,
    canGoBack: a,
    canGoNext: u
  };
},
    Hi = function Hi(n) {
  return {
    name: String(n),
    value: String(n)
  };
},
    Vi = function Vi(n) {
  var e = n.disabled;
  return s.createElement(Ri, null, s.createElement(Bi, {
    disabled: void 0 !== e && e
  }, "..."));
},
    Ui = function Ui(n) {
  var e = n.disabled,
      r = n.current,
      o = n.nextLabel,
      i = n.onChange,
      u = n.pageSize,
      c = void 0 === u ? 12 : u,
      f = n.pageSizes,
      d = void 0 === f ? [] : f,
      m = n.perPageLabel,
      p = n.position,
      h = void 0 === p ? Co.center : p,
      g = n.previousLabel,
      v = n.showArrowLabel,
      x = void 0 !== v && v,
      k = n.sidePages,
      w = void 0 === k ? 3 : k,
      E = n.totalItems,
      C = O(n, ["disabled", "current", "nextLabel", "onChange", "pageSize", "pageSizes", "perPageLabel", "position", "previousLabel", "showArrowLabel", "sidePages", "totalItems"]),
      z = a.pick(C),
      D = Y(C),
      S = l.useContext(J).locale,
      P = g || Io[S].previous,
      I = o || Io[S].next,
      _ = m || Io[S].perPage,
      L = qi(r, c, E),
      T = L.currentPage,
      j = L.previousOffset,
      R = L.nextOffset,
      A = L.totalPages,
      N = L.canGoBack,
      F = L.canGoNext,
      B = l.useCallback(function (n) {
    null == i || i({
      currentPage: n.currentPage,
      pageSize: n.pageSize,
      previousOffset: j,
      nextOffset: R
    });
  }, [R, i, j]),
      q = l.useMemo(function () {
    return y({
      page: T,
      pages: A,
      beginPages: 3,
      endPages: 1,
      sidePages: w
    });
  }, [T, w, A]),
      H = A > 1,
      V = T - w - 1 >= 1,
      U = T + w + 1 < A,
      G = l.useCallback(function (n) {
    return function () {
      return null == B ? void 0 : B({
        currentPage: n,
        pageSize: c
      });
    };
  }, [B, c]),
      W = l.useCallback(function (n) {
    null == B || B({
      currentPage: T,
      pageSize: +n.target.value
    });
  }, [T, B]),
      Q = l.useMemo(function () {
    return d.map(Hi);
  }, [d]),
      X = l.useMemo(function () {
    return Hi(c);
  }, [c]),
      K = l.useMemo(function () {
    return b(q.previousPages.length ? q.previousPages[0] : 2, q.nextPages.length ? q.nextPages[q.nextPages.length - 1] + 1 : A);
  }, [q.nextPages, q.previousPages, A]);

  return s.createElement(Mi, Object.assign({}, D, z), d.length > 0 && s.createElement(M, {
    centered: !0,
    mr: "regular"
  }, s.createElement(Ni, {
    mr: "regular",
    name: "perPage",
    disabled: e,
    value: X,
    items: Q,
    onChange: W
  }), s.createElement(Dt, null, _)), s.createElement(Fi, {
    role: "navigation",
    position: h
  }, s.createElement(ji, null, N && s.createElement(Ri, null, s.createElement(Po, {
    disabled: e,
    "data-testid": "page-previous",
    onClick: G(T - 1),
    "aria-label": P
  }, s.createElement(Pn, {
    component: t.ChevronLeft,
    size: "s",
    mr: "smaller"
  }), x && P)), s.createElement(Ri, null, s.createElement(Ai, {
    active: !N,
    disabled: e,
    onClick: G(1)
  }, 1)), V && s.createElement(Vi, {
    disabled: e
  }), H && K.map(function (n) {
    return s.createElement(Ri, {
      key: n
    }, s.createElement(Ai, {
      active: T === n,
      disabled: e,
      "data-testid": "page-" + n,
      onClick: G(n)
    }, n));
  }), U && s.createElement(Vi, {
    disabled: e
  }), H && s.createElement(Ri, {
    key: A
  }, s.createElement(Ai, {
    active: !F,
    disabled: e,
    "data-testid": "page-" + A,
    onClick: G(A)
  }, A)), F && s.createElement(Ri, null, s.createElement(Po, {
    "data-testid": "page-next",
    disabled: e,
    onClick: G(T + 1),
    "aria-label": I
  }, x && I, s.createElement(Pn, {
    component: t.ChevronRight,
    size: "s",
    ml: "smaller"
  }))))));
};

function Gi() {
  var n = P(["\n  font-size: ", ";\n  color: ", ";\n  margin-right: ", ";\n  ", "\n  ", ";\n"]);
  return Gi = function Gi() {
    return n;
  }, n;
}

Ui.propTypes = {
  current: c.number.isRequired,
  disabled: c.bool,
  nextLabel: c.string,
  onChange: c.func,
  pageSize: c.number,
  pageSizes: c.array,
  perPageLabel: c.string,
  position: c.oneOf(["left", "center", "right"]),
  previousLabel: c.string,
  sidePages: c.number,
  totalItems: c.number.isRequired
};

var Wi = o(Dt)(Gi(), function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.colors.grayDarkest;
}, function (n) {
  return n.theme.space.largest;
}, e.space, e.layout),
    Qi = function Qi(n) {
  var e = n.currentPage,
      t = n.ofLabel,
      r = n.pageSize,
      o = n.showingLabel,
      i = n.totalItems,
      u = O(n, ["currentPage", "ofLabel", "pageSize", "showingLabel", "totalItems"]),
      c = e * r || 0,
      l = c >= i,
      f = a.pick(u),
      d = Y(u);
  return s.createElement(Wi, Object.assign({}, d, f), o, " ", s.createElement("strong", null, (l ? i : c) + " " + t + " " + i));
};

Qi.propTypes = {
  currentPage: c.number.isRequired,
  ofLabel: c.string.isRequired,
  pageSize: c.number.isRequired,
  showingLabel: c.string.isRequired,
  totalItems: c.number.isRequired
};

var Ji = function Ji(n) {
  var e = n.current,
      r = void 0 === e ? 1 : e,
      o = n.disabled,
      i = void 0 !== o && o,
      u = n.pageSize,
      c = void 0 === u ? 1 : u,
      f = n.totalItems,
      d = n.nextLabel,
      m = n.ofLabel,
      p = n.previousLabel,
      h = n.showingLabel,
      g = n.onChange,
      v = O(n, ["current", "disabled", "pageSize", "totalItems", "nextLabel", "ofLabel", "previousLabel", "showingLabel", "onChange"]),
      b = a.pick(v),
      y = Y(v),
      x = l.useContext(J).locale,
      k = m || Io[x].of,
      w = h || Io[x].showing,
      E = p || Io[x].previous,
      C = d || Io[x].next,
      z = qi(r, c, f),
      D = z.currentPage,
      S = z.previousOffset,
      P = z.nextOffset,
      I = z.canGoBack,
      _ = z.canGoNext,
      L = l.useCallback(function (n) {
    null == g || g({
      currentPage: D + n,
      previousOffset: S,
      nextOffset: P,
      pageSize: c
    });
  }, [g, D, S, P, c]),
      T = l.useCallback(function () {
    L(-1);
  }, [L]),
      M = l.useCallback(function () {
    L(1);
  }, [L]);
  return s.createElement(Oo, Object.assign({}, y, b), s.createElement(Qi, {
    currentPage: D,
    totalItems: f,
    pageSize: c,
    ofLabel: k,
    showingLabel: w
  }), s.createElement(Po, {
    mr: "regular",
    disabled: !I || i,
    onClick: T
  }, s.createElement(Pn, {
    component: t.ChevronLeft,
    size: "s",
    mr: "smaller"
  }), E), s.createElement(Po, {
    ml: "regular",
    disabled: !_ || i,
    onClick: M
  }, C, s.createElement(Pn, {
    component: t.ChevronRight,
    size: "s",
    ml: "smaller"
  })));
};

Ji.Numbered = Ui, Ji.propTypes = {
  current: c.number.isRequired,
  disabled: c.bool,
  nextLabel: c.string,
  ofLabel: c.string,
  onChange: c.func,
  pageSize: c.number,
  position: c.oneOf(["left", "center", "right"]),
  previousLabel: c.string,
  showingLabel: c.string,
  totalItems: c.number.isRequired
};
var Xi = {
  "pt-br": {
    close: "Fechar notificação"
  },
  "en-us": {
    close: "Close notification"
  },
  "es-mx": {
    close: "Cerrar notificación"
  },
  "es-co": {
    close: "Cerrar notificación"
  }
};

function Ki() {
  var n = P(["\n  border-color: ", ";\n  background-color: ", ";\n"]);
  return Ki = function Ki() {
    return n;
  }, n;
}

var Zi = r.css(Ki(), function (n) {
  return n.theme.colors.error;
}, function (n) {
  return n.theme.colors.error;
});

function Yi() {
  var n = P(["\n  color: ", ";\n  border-color: ", ";\n  background-color: ", ";\n"]);
  return Yi = function Yi() {
    return n;
  }, n;
}

var $i = r.css(Yi(), function (n) {
  return n.theme.colors.black;
}, function (n) {
  return n.theme.colors.attention;
}, function (n) {
  return n.theme.colors.attention;
});

function na() {
  var n = P(["\n  padding: ", ";\n\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: bold;\n"]);
  return na = function na() {
    return n;
  }, n;
}

var ea = r.css(na(), function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.fontSizes.xs;
}, function (n) {
  return n.theme.lineHeights.s;
});

function ta() {
  var n = P(["\n  &.Toastify__toast-container {\n    z-index: 9999;\n    transform: translate3d(0, 0, 9999px);\n    position: fixed;\n    padding: 4px;\n    min-width: 320px;\n    box-sizing: border-box;\n  }\n  &.Toastify__toast-container--top-right {\n    top: 1em;\n    right: 1em;\n  }\n  &.Toastify__toast-container--bottom-center {\n    bottom: 1em;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  @media only screen and (max-width: 480px) {\n    &.Toastify__toast-container {\n      width: 100vw;\n      padding: 0;\n      left: 0;\n      margin: 0;\n    }\n    &.Toastify__toast-container--top-right {\n      top: 0;\n      transform: translateX(0);\n    }\n    &.Toastify__toast-container--bottom-center {\n      bottom: 0;\n      transform: translateX(0);\n    }\n  }\n  .Toastify__toast {\n    position: relative;\n    box-sizing: border-box;\n    padding: 8px;\n    display: flex;\n    justify-content: space-between;\n    max-height: 800px;\n    overflow: hidden;\n    font-family: sans-serif;\n    cursor: pointer;\n  }\n  .Toastify__toast-body {\n    margin: auto 0;\n    flex: 1 1 auto;\n  }\n  @media only screen and (max-width: 480px) {\n    .Toastify__toast {\n      margin-bottom: 0;\n    }\n  }\n  .Toastify__close-button {\n    display: none;\n  }\n  @keyframes Toastify__trackProgress {\n    0% {\n      transform: scaleX(1);\n    }\n    100% {\n      transform: scaleX(0);\n    }\n  }\n  .Toastify__progress-bar--animated {\n    animation: Toastify__trackProgress linear 1 forwards;\n  }\n  @keyframes Toastify__bounceInRight {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    from {\n      opacity: 0;\n      transform: translate3d(3000px, 0, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(-25px, 0, 0);\n    }\n    75% {\n      transform: translate3d(10px, 0, 0);\n    }\n    90% {\n      transform: translate3d(-5px, 0, 0);\n    }\n    to {\n      transform: none;\n    }\n  }\n  @keyframes Toastify__bounceOutRight {\n    20% {\n      opacity: 1;\n      transform: translate3d(-20px, 0, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(2000px, 0, 0);\n    }\n  }\n  @keyframes Toastify__bounceInUp {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    from {\n      opacity: 0;\n      transform: translate3d(0, 3000px, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(0, -20px, 0);\n    }\n    75% {\n      transform: translate3d(0, 10px, 0);\n    }\n    90% {\n      transform: translate3d(0, -5px, 0);\n    }\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n  }\n  @keyframes Toastify__bounceOutDown {\n    20% {\n      transform: translate3d(0, 10px, 0);\n    }\n    40%,\n    45% {\n      opacity: 1;\n      transform: translate3d(0, -20px, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(0, 2000px, 0);\n    }\n  }\n  .Toastify__bounce-enter--top-right {\n    animation-name: Toastify__bounceInRight;\n  }\n  .Toastify__bounce-exit--top-right {\n    animation-name: Toastify__bounceOutRight;\n  }\n  .Toastify__bounce-enter--bottom-center {\n    animation-name: Toastify__bounceInUp;\n  }\n  .Toastify__bounce-exit--bottom-center {\n    animation-name: Toastify__bounceOutDown;\n  }\n\n  @keyframes Toastify__slideInRight {\n    from {\n      transform: translate3d(110%, 0, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n  }\n  @keyframes Toastify__slideOutRight {\n    from {\n      transform: translate3d(0, 0, 0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(110%, 0, 0);\n    }\n  }\n  @keyframes Toastify__slideInUp {\n    from {\n      transform: translate3d(0, 110%, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n  }\n  @keyframes Toastify__slideOutDown {\n    from {\n      transform: translate3d(0, 0, 0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(0, 500px, 0);\n    }\n  }\n  .Toastify__slide-enter--top-right {\n    animation-name: Toastify__slideInRight;\n  }\n  .Toastify__slide-exit--top-right {\n    animation-name: Toastify__slideOutRight;\n  }\n  .Toastify__slide-enter--bottom-center {\n    animation-name: Toastify__slideInUp;\n  }\n  .Toastify__slide-exit--bottom-center {\n    animation-name: Toastify__slideOutDown;\n  }\n"]);
  return ta = function ta() {
    return n;
  }, n;
}

var ra = o(x.ToastContainer).attrs({
  autoClose: 4e3,
  hideProgressBar: !0,
  newestOnTop: !1,
  closeOnClick: !1,
  rtl: !1,
  pauseOnFocusLoss: !0,
  draggable: !0,
  pauseOnHover: !0
})(ta());

function oa() {
  var n = P(["\n  background-color: ", ";\n  color: ", ";\n"]);
  return oa = function oa() {
    return n;
  }, n;
}

var ia = r.css(oa(), function (n) {
  return n.theme.colors.positive;
}, function (n) {
  return n.theme.colors.white;
});

function aa() {
  var n = P(["\n  cursor: pointer;\n"]);
  return aa = function aa() {
    return n;
  }, n;
}

function ua() {
  var n = P(["\n  font-size: 0px;\n  line-height: 0px;\n  margin-left: ", ";\n  pointer-events: all;\n  width: ", ";\n"]);
  return ua = function ua() {
    return n;
  }, n;
}

function ca() {
  var n = P(["\n  flex-grow: 1;\n"]);
  return ca = function ca() {
    return n;
  }, n;
}

function la() {
  var n = P(["\n  font-size: 0;\n  line-height: 0;\n  margin-right: ", ";\n"]);
  return la = function la() {
    return n;
  }, n;
}

function sa() {
  var n = P([""]);
  return sa = function sa() {
    return n;
  }, n;
}

function fa() {
  var n = P([""]);
  return fa = function fa() {
    return n;
  }, n;
}

function da() {
  var n = P([""]);
  return da = function da() {
    return n;
  }, n;
}

function ma() {
  var n = P(["\n  display: flex;\n  border-radius: ", ";\n  box-shadow: 0px 2px 2px rgba(62, 62, 62, 0.15);\n\n  font-family: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"]);
  return ma = function ma() {
    return n;
  }, n;
}

var pa = o.div(ma(), function (n) {
  return n.theme.radii.m;
}, function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.small;
}, ia, function (n) {
  return "error" === n.variant ? Zi : r.css(da());
}, function (n) {
  return "warning" === n.variant ? $i : r.css(fa());
}, function (n) {
  return n.reduced ? ea : r.css(sa());
}),
    ha = o.div(la(), function (n) {
  return n.theme.space.smaller;
}),
    ga = o.div(ca()),
    va = o.div(ua(), function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}),
    ba = o(Pn)(aa()),
    ya = function ya(n) {
  var e = n.autoClose,
      r = void 0 === e || e,
      o = n.message,
      i = n.closeAriaLabel,
      u = n.icon,
      c = void 0 === u ? null : u,
      f = n.closeToast,
      d = n.variant,
      m = void 0 === d ? "success" : d,
      p = n.children,
      h = O(n, ["autoClose", "message", "closeAriaLabel", "icon", "closeToast", "variant", "children"]),
      g = l.useContext(J).locale,
      v = "success" === m ? t.SuccessFilled : t.AlertFilled,
      b = a.pick(h),
      y = Y(h);
  return s.createElement(pa, Object.assign({
    variant: m
  }, y, b), s.createElement(ha, null, s.createElement(Pn, {
    component: c || v,
    size: "xs"
  })), s.createElement(ga, null, o, s.createElement("div", null, p)), s.createElement(va, {
    variant: m
  }, !r && s.createElement(ba, {
    role: "button",
    onClick: f,
    component: t.Close,
    size: "xs",
    tabIndex: 0,
    "aria-label": i || Xi[g].close
  })));
};

ya.propTypes = {
  autoClose: c.bool,
  message: c.string.isRequired,
  closeAriaLabel: c.string,
  icon: c.node,
  variant: c.oneOf(["success", "error", "warning"]),
  closeToast: c.func,
  timeout: c.number,
  reduced: c.bool
};

var xa = function xa(n) {
  var e = n.theme,
      t = n.snackbarPosition,
      o = n.children,
      i = n.locale,
      a = void 0 === i ? "en-us" : i,
      u = l.useMemo(function () {
    return e ? k(p, e) : p;
  }, [e]);
  return s.createElement(r.ThemeProvider, {
    theme: u
  }, s.createElement(J.Provider, {
    value: {
      locale: a
    }
  }, o, s.createElement(ra, {
    position: t
  })));
};

xa.propTypes = {
  theme: c.object,
  locale: c.oneOf(["pt-br", "en-us", "es-mx", "es-co"])
};
var ka = {
  "pt-br": "D_S_T_Q_Q_S_S".split("_"),
  "en-us": "S_M_T_W_T_F_S".split("_"),
  "es-mx": "D_L_M_M_J_V_S".split("_"),
  "es-co": "D_L_M_M_J_V_S".split("_")
},
    wa = {
  "pt-br": "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split("_"),
  "en-us": "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
  "es-mx": "Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre".split("_"),
  "es-co": "Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre".split("_")
},
    Ea = {
  "pt-br": "Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),
  "en-us": "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
  "es-mx": "Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado".split("_"),
  "es-co": "Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado".split("_")
},
    Ca = {
  "pt-br": 0,
  "en-us": 0,
  "es-mx": 0,
  "es-co": 0
},
    za = {
  "pt-br": {
    nextMonth: "Próximo mês",
    previousMonth: "Mês anterior"
  },
  "en-us": {
    nextMonth: "Next month",
    previousMonth: "Previous month"
  },
  "es-mx": {
    nextMonth: "Proximo mes",
    previousMonth: "Mes anterior"
  },
  "es-co": {
    nextMonth: "Proximo mes",
    previousMonth: "Mes anterior"
  }
};

function Da() {
  var n = P(["\n          .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover\n            .DayPicker-inner-day,\n          .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)\n            .DayPicker-inner-day {\n            font-weight: bold;\n            position: relative;\n            background-color: ", ";\n            color: ", ";\n            border-radius: ", ";\n            padding-top: ", ";\n            padding-bottom: ", ";\n            margin-top: 0px;\n            margin-bottom: 0px;\n            z-index: 1;\n          }\n\n          .DayPicker-Week\n            .DayPicker-Day--selected:first-of-type\n            .DayPicker-inner-day {\n            border-radius: ", ";\n          }\n\n          .DayPicker-Week\n            .DayPicker-Day--selected:last-of-type\n            .DayPicker-inner-day {\n            border-radius: ", ";\n          }\n        "]);
  return Da = function Da() {
    return n;
  }, n;
}

function Sa() {
  var n = P([""]);
  return Sa = function Sa() {
    return n;
  }, n;
}

function Oa() {
  var n = P(["\n  .DayPicker {\n    box-shadow: ", ";\n    border-radius: ", ";\n    overflow: hidden;\n  }\n\n  .DayPicker-wrapper {\n    position: relative;\n    flex-direction: row;\n    padding-bottom: ", ";\n    user-select: none;\n  }\n\n  .DayPicker-Months {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .DayPicker-Month {\n    display: table;\n    margin: 0 ", ";\n    margin-top: ", ";\n    border-spacing: 0;\n    border-collapse: collapse;\n    user-select: none;\n  }\n\n  .DayPicker-NavBar {\n  }\n\n  .DayPicker-NavButton {\n    position: absolute;\n    display: inline-block;\n    width: ", ";\n    height: ", ";\n    cursor: pointer;\n  }\n\n  .DayPicker-NavButton:hover {\n    opacity: 0.8;\n  }\n\n  .DayPicker-NavButton--prev {\n    top: ", ";\n    left: ", ";\n    background-image: ", ";\n    transform: rotate(180deg);\n  }\n\n  .DayPicker-NavButton--next {\n    top: ", ";\n    right: ", ";\n    background-image: ", ";\n  }\n\n  .DayPicker-NavButton--interactionDisabled {\n    display: none;\n  }\n\n  .DayPicker-Caption {\n    font-family: ", ";\n    font-weight: bold;\n    color: ", ";\n    text-transform: capitalize;\n    display: table-caption;\n    margin-bottom: ", ";\n    padding: 0 ", ";\n    text-align: center;\n  }\n\n  .DayPicker-Weekdays {\n    display: table-header-group;\n    margin-top: ", ";\n  }\n\n  .DayPicker-WeekdaysRow {\n    font-family: ", ";\n    font-size: ", ";\n    display: table-row;\n  }\n\n  .DayPicker-Weekday {\n    display: table-cell;\n    color: ", ";\n    font-size: ", ";\n    font-weight: bold;\n    padding: ", ";\n    text-align: center;\n  }\n\n  .DayPicker-Weekday abbr[title] {\n    border-bottom: none;\n    text-decoration: none;\n  }\n\n  .DayPicker-Body {\n    font-family: ", ";\n    font-size: ", ";\n    color: ", ";\n    display: table-row-group;\n  }\n\n  .DayPicker-Week {\n    display: table-row;\n  }\n\n  .DayPicker-Day {\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n    cursor: pointer;\n  }\n\n  .DayPicker-inner-day {\n    margin-top: ", ";\n    margin-bottom: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    padding-right: ", ";\n    padding-left: ", ";\n    margin-left: -3px;\n    margin-right: -3px;\n  }\n\n  .DayPicker--interactionDisabled .DayPicker-Day {\n    cursor: default;\n  }\n\n  .DayPicker-Footer {\n    padding-top: ", ";\n  }\n\n  /* Default modifiers */\n  .DayPicker-Day--outside {\n    color: ", ";\n    cursor: default;\n  }\n\n  .DayPicker-Day--disabled {\n    color: ", ";\n    pointer-events: none;\n    cursor: default;\n  }\n\n  /* Selected day common */\n  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)\n    .DayPicker-inner-day {\n    position: relative;\n    background-color: ", ";\n    color: ", ";\n    z-index: 0;\n  }\n\n  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover\n    .DayPicker-inner-day {\n    background-color: ", ";\n  }\n\n  .DayPicker-Day:focus {\n    outline: none;\n  }\n\n  .DayPicker-Day:focus-within .DayPicker-inner-day {\n    outline: ", " auto 5px;\n  }\n\n  .DayPicker:focus,\n  .DayPicker-wrapper:focus,\n  .DayPicker-Months:focus {\n    outline: none;\n  }\n\n  /* Selected Start and End */\n  .DayPicker-Day--start:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover\n    .DayPicker-inner-day,\n  .DayPicker-Day--end:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover\n    .DayPicker-inner-day {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  .DayPicker-Day--selected.DayPicker-Day--start:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)\n    .DayPicker-inner-day,\n  .DayPicker-Day--selected.DayPicker-Day--end:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)\n    .DayPicker-inner-day {\n    font-weight: bold;\n    position: relative;\n    background-color: ", ";\n    color: ", ";\n    border-radius: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin-top: 0px;\n    margin-bottom: 0px;\n    z-index: 1;\n  }\n\n  .DayPicker-Day--selected.DayPicker-Day--end:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover\n    .DayPicker-inner-day,\n  .DayPicker-Day--selected.DayPicker-Day--start:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover\n    .DayPicker-inner-day {\n    background-color: ", ";\n  }\n\n  /* Single selection */\n\n  /* Disabled */\n  .DayPicker-Week .DayPicker-Day--selected:first-of-type .DayPicker-inner-day {\n    border-radius: 16px 0 0 16px;\n  }\n\n  .DayPicker-Week .DayPicker-Day--selected:last-of-type .DayPicker-inner-day {\n    border-radius: 0 16px 16px 0;\n  }\n\n  /* DayPickerInput */\n  .DayPickerInput {\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n  }\n\n  .DayPickerInput-OverlayWrapper {\n    position: relative;\n  }\n\n  .DayPickerInput-Overlay {\n    position: absolute;\n    left: 0;\n    z-index: 1;\n\n    background: white;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);\n  }\n\n  ", "\n\n  ", "\n  ", "\n"]);
  return Oa = function Oa() {
    return n;
  }, n;
}

var Pa = E,
    Ia = K('<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.2704 8.83757C12.5955 8.51513 13.1198 8.5178 13.4416 8.84352L19.9343 15.4161C20.255 15.7407 20.2536 16.2638 19.9314 16.5868L13.4386 23.093C13.1152 23.4171 12.5908 23.4171 12.2674 23.093C11.944 22.7689 11.944 22.2435 12.2674 21.9194L18.1776 15.997L12.2645 10.0112C11.9427 9.68545 11.9454 9.16 12.2704 8.83757Z" fill="currentColor"/></svg>'),
    _a = o.div(Oa(), function (n) {
  return n.theme.shadows.elevate;
}, function (n) {
  return n.theme.radii.m;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.large;
}, Ia, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.large;
}, Ia, function (n) {
  return n.theme.fonts.primary;
}, function (n) {
  return n.theme.colors.black;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.fonts.primary;
}, function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.colors.black;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.colors.gray;
}, function (n) {
  return n.theme.colors.gray;
}, function (n) {
  return n.theme.colors.gray;
}, function (n) {
  return n.theme.colors.black;
}, function (n) {
  return n.theme.colors.grayLight;
}, function (n) {
  return n.theme.colors.focus;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.radii.l;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.colors.primaryLight;
}, function (n) {
  return n.rangeSelection ? r.css(Sa()) : r.css(Da(), function (n) {
    return n.theme.colors.primary;
  }, function (n) {
    return n.theme.colors.white;
  }, function (n) {
    return n.theme.radii.l;
  }, function (n) {
    return n.theme.space.smaller;
  }, function (n) {
    return n.theme.space.smaller;
  }, function (n) {
    return n.theme.radii.l;
  }, function (n) {
    return n.theme.radii.l;
  });
}, e.layout, e.space),
    La = function La(n) {
  var e = n.className,
      t = void 0 === e ? "" : e,
      r = n.modifiers,
      o = n.selectedDays,
      i = n.rangeSelection,
      a = void 0 !== i && i,
      u = n.renderFooter,
      c = n.onDayClick,
      f = n.initialMonth,
      d = O(n, ["className", "modifiers", "selectedDays", "rangeSelection", "renderFooter", "onDayClick", "initialMonth"]),
      m = l.useContext(J).locale,
      p = Y(d);
  return s.createElement(_a, {
    className: t,
    rangeSelection: a
  }, s.createElement(Pa, Object.assign({
    locale: m,
    months: wa[m],
    weekdaysLong: Ea[m],
    weekdaysShort: ka[m],
    firstDayOfWeek: Ca[m],
    labels: za[m],
    numberOfMonths: 1,
    selectedDays: o,
    modifiers: r,
    onDayClick: c,
    initialMonth: f,
    renderDay: function renderDay(n) {
      return s.createElement("div", {
        className: "DayPicker-inner-day"
      }, C.format(n, "d"));
    }
  }, p)), u ? s.createElement("div", null, u()) : null);
};

La.propTypes = {
  modifiers: c.object,
  selectedDays: c.oneOfType([c.object, c.array]),
  rangeSelection: c.bool,
  renderFooter: c.func,
  onDayClick: c.func
};

var Ta = E,
    Ma = function Ma(n) {
  var e = n.className,
      t = void 0 === e ? "" : e,
      r = n.renderFooter,
      o = n.modifiers,
      i = n.initialMonth,
      a = O(n, ["className", "renderFooter", "modifiers", "initialMonth"]),
      u = l.useState({
    from: void 0,
    to: void 0
  }),
      c = u[0],
      f = u[1],
      d = c.from,
      m = c.to,
      p = S({
    start: d,
    end: m
  }, o),
      h = Y(a);
  return s.createElement(La, Object.assign({
    className: t,
    rangeSelection: !0,
    selectedDays: [d, {
      from: d,
      to: m
    }],
    modifiers: p,
    onDayClick: function onDayClick(n) {
      var e = Ta.DateUtils.addDayToRange(n, c);
      f(e);
    },
    renderFooter: function renderFooter() {
      return (null == r ? void 0 : r(c)) || null;
    },
    initialMonth: i
  }, h));
};

Ma.propTypes = {
  renderFooter: c.func
};
var ja = {
  "pt-br": {
    of: "de",
    step: "Passo"
  },
  "en-us": {
    of: "of",
    step: "Step"
  },
  "es-mx": {
    of: "de",
    step: "Paso"
  },
  "es-co": {
    of: "de",
    step: "Paso"
  }
};

function Ra() {
  var n = P(["\n  display: flex;\n  overflow: hidden;\n\n  ", " {\n    margin-left: ", ";\n    margin-right: ", ";\n\n    &:first-child {\n      margin-left: ", ";\n    }\n\n    &:last-child {\n      margin-right: ", ";\n    }\n  }\n"]);
  return Ra = function Ra() {
    return n;
  }, n;
}

function Aa() {
  var n = P(["\n  height: ", ";\n  border-radius: ", ";\n\n  flex-grow: 1;\n  transition: ", ";\n\n  background-color: ", ";\n"]);
  return Aa = function Aa() {
    return n;
  }, n;
}

function Na() {
  var n = P(["\n  display: flex;\n  flex-direction: column;\n  margin-top: ", ";\n  margin-bottom: ", ";\n\n  ", " {\n    text-align: right;\n  }\n\n  ", "\n  ", "\n"]);
  return Na = function Na() {
    return n;
  }, n;
}

var Fa = o.div(Na(), function (n) {
  return n.theme.space.larger;
}, function (n) {
  return n.theme.space.larger;
}, zt, e.space, e.layout),
    Ba = o.div(Aa(), function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.radii.m;
}, function (n) {
  var e = n.theme;
  return Z([["background-color", e.durations.slowly, e.timingFunctions.easeIn]]);
}, function (n) {
  return n.complete ? n.theme.colors.primary : n.theme.colors.gray;
}),
    qa = o.div(Ra(), Ba, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.space.none;
}, function (n) {
  return n.theme.space.none;
}),
    Ha = function Ha(n) {
  var e,
      t = n.className,
      r = n.steps,
      o = n.activeIndex,
      i = O(n, ["className", "steps", "activeIndex"]),
      u = a.pick(i),
      c = Y(i),
      f = (e = l.useContext(J).locale, function (n) {
    return ja[e][n] || (console.warn('No message found in Stepper Locales with "' + e + '" locale and "' + n + '" key'), "");
  }),
      d = function (n, e) {
    var t = e - 1;
    return n > t ? (console.warn("Active index must be lesser or equal than " + (t < 0 ? 0 : t)), t) : n < 0 ? (console.warn("Active index must be greater or equal than 0"), 0) : n;
  }(o, r),
      m = l.useMemo(function () {
    return r <= 0 ? (console.warn("Steps count must be greater than 0"), []) : Array.from(new Array(r), function (n, e) {
      return {
        complete: e <= d
      };
    });
  }, [r, d]);

  if (0 === m.length) return null;
  var p = f("step") + " " + (d + 1) + " " + f("of") + " " + r;
  return s.createElement(Fa, Object.assign({
    className: t
  }, u, c), s.createElement(qa, null, m.map(function (n, e) {
    return s.createElement(Ba, {
      key: e,
      complete: n.complete
    });
  })), s.createElement(Dt, null, p));
};

function Va() {
  var n = P(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-self: stretch;\n  justify-content: flex-start;\n  flex-shrink: 0;\n  height: 100%;\n  overflow: hidden;\n  outline: none;\n"]);
  return Va = function Va() {
    return n;
  }, n;
}

function Ua() {
  var n = P(["\n  flex-direction: row;\n  direction: ltr;\n  will-change: transform;\n  min-height: 0;\n  flex: 1;\n  display: flex;\n"]);
  return Ua = function Ua() {
    return n;
  }, n;
}

function Ga() {
  var n = P(["\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  width: 100%;\n  ", "\n  ", "\n"]);
  return Ga = function Ga() {
    return n;
  }, n;
}

Ha.propTypes = {
  activeIndex: c.number.isRequired,
  steps: c.number.isRequired,
  initialIndex: c.number
};

var Wa = o.div(Ga(), e.space, e.layout),
    Qa = o(i.motion.div)(Ua()),
    Ja = o(i.motion.div)(Va()),
    Xa = function Xa(n) {
  var e = n.currentIndex;
  return s.createElement(Wa, null, s.createElement(Qa, {
    transition: {
      tension: 190,
      friction: 70,
      mass: .4
    },
    initial: !1,
    animate: {
      x: -100 * e + "%"
    }
  }, s.createElement(i.AnimatePresence, null, l.Children.map(n.children, function (n, t) {
    return s.createElement(Ja, {
      key: t,
      "aria-hidden": e !== t,
      tabIndex: e === t ? 0 : -1,
      animate: {
        opacity: 1
      },
      exit: {
        opacity: 0
      }
    }, n);
  }))));
};

function Ka() {
  var n = P(["\n  border-color: ", ";\n  color: ", ";\n"]);
  return Ka = function Ka() {
    return n;
  }, n;
}

Xa.propTypes = {
  currentIndex: c.number.isRequired
};
var Za = r.css(Ka(), function (n) {
  return n.theme.colors.positive;
}, function (n) {
  return n.theme.colors.positive;
});

function Ya() {
  var n = P(["\n  border-color: ", ";\n  color: ", ";\n"]);
  return Ya = function Ya() {
    return n;
  }, n;
}

var $a = r.css(Ya(), function (n) {
  return n.theme.colors.error;
}, function (n) {
  return n.theme.colors.error;
});

function nu() {
  var n = P(["\n  border-color: ", ";\n  color: ", ";\n"]);
  return nu = function nu() {
    return n;
  }, n;
}

var eu = r.css(nu(), function (n) {
  return n.theme.colors.attention;
}, function (n) {
  return n.theme.colors.attention;
});

function tu() {
  var n = P(["\n  background-color: ", ";\n  border-color: ", ";\n  color: ", ";\n"]);
  return tu = function tu() {
    return n;
  }, n;
}

var ru = r.css(tu(), function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.colors.white;
});

function ou() {
  var n = P(["\n  background-color: ", ";\n  border-color: ", ";\n  color: ", ";\n"]);
  return ou = function ou() {
    return n;
  }, n;
}

var iu = r.css(ou(), function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.colors.primary;
});

function au() {
  var n = P(["\n  border-color: ", ";\n  color: ", ";\n"]);
  return au = function au() {
    return n;
  }, n;
}

var uu = r.css(au(), function (n) {
  return n.theme.colors.gray;
}, function (n) {
  return n.theme.colors.grayDarker;
});

function cu() {
  var n = P([""]);
  return cu = function cu() {
    return n;
  }, n;
}

function lu() {
  var n = P([""]);
  return lu = function lu() {
    return n;
  }, n;
}

function su() {
  var n = P([""]);
  return su = function su() {
    return n;
  }, n;
}

function fu() {
  var n = P([""]);
  return fu = function fu() {
    return n;
  }, n;
}

function du() {
  var n = P([""]);
  return du = function du() {
    return n;
  }, n;
}

function mu() {
  var n = P([""]);
  return mu = function mu() {
    return n;
  }, n;
}

function pu() {
  var n = P([""]);
  return pu = function pu() {
    return n;
  }, n;
}

function hu() {
  var n = P(["\n  display: inline-block;\n  padding-left: ", ";\n  padding-right: ", ";\n  padding-top: calc(", " - 1px);\n  padding-bottom: calc(", " - 1px);\n  border-style: solid;\n  border-width: 1px;\n  font-weight: bold;\n  font-family: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n  ", "\n"]);
  return hu = function hu() {
    return n;
  }, n;
}

function gu() {
  var n = P(["\n  ", "\n  line-height: ", ";\n  padding: ", ";\n"]);
  return gu = function gu() {
    return n;
  }, n;
}

function vu() {
  var n = P(["\n  line-height: ", ";\n  font-size: ", ";\n  border-radius: 16px;\n"]);
  return vu = function vu() {
    return n;
  }, n;
}

function bu() {
  var n = P(["\n  line-height: ", ";\n  font-size: ", ";\n  border-radius: 24px;\n"]);
  return bu = function bu() {
    return n;
  }, n;
}

var yu = r.css(bu(), function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.fontSizes.m;
}),
    xu = r.css(vu(), function (n) {
  return n.theme.lineHeights.s;
}, function (n) {
  return n.theme.fontSizes.xs;
}),
    ku = r.css(gu(), xu, function (n) {
  return n.theme.lineHeights.xs;
}, function (n) {
  return n.theme.space.smallest + " " + n.theme.space.smaller;
}),
    wu = o.div(hu(), function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.fonts.secondary;
}, uu, function (n) {
  return "secondary" === n.variant ? iu : r.css(pu());
}, function (n) {
  return "positive" === n.variant ? Za : r.css(mu());
}, function (n) {
  return "error" === n.variant ? $a : r.css(du());
}, function (n) {
  return "attention" === n.variant ? eu : r.css(fu());
}, function (n) {
  return "required" === n.variant ? ru : r.css(su());
}, yu, function (n) {
  return "s" === n.size ? xu : r.css(lu());
}, function (n) {
  return "xs" === n.size ? ku : r.css(cu());
}, e.space, e.layout),
    Eu = function Eu(n) {
  var e = n.variant,
      t = n.size,
      r = void 0 === t ? "m" : t,
      o = n.children,
      i = O(n, ["variant", "size", "children"]),
      u = a.pick(i),
      c = Y(i);
  return s.createElement(wu, Object.assign({
    variant: e,
    size: r
  }, c, u), o);
};

function Cu() {
  var n = P(["\n  display: flex;\n\n  ", ",\n  ", " {\n    align-self: flex-start;\n    margin-left: ", ";\n  }\n"]);
  return Cu = function Cu() {
    return n;
  }, n;
}

function zu() {
  var n = P(["\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n\n  width: ", ";\n  height: ", ";\n\n  background-color: ", ";\n  border-radius: ", ";\n\n  padding: 2px;\n"]);
  return zu = function zu() {
    return n;
  }, n;
}

function Du() {
  var n = P(["\n            color: ", ";\n          "]);
  return Du = function Du() {
    return n;
  }, n;
}

function Su() {
  var n = P([""]);
  return Su = function Su() {
    return n;
  }, n;
}

function Ou() {
  var n = P(["\n  border: none;\n  outline: none;\n  cursor: pointer;\n\n  box-sizing: border-box;\n  white-space: nowrap;\n  text-align: center;\n  text-overflow: ellipsis;\n  font-size: ", ";\n  font-family: ", ";\n  line-height: ", ";\n\n  color: ", ";\n\n  padding: ", ";\n  background-color: ", ";\n\n  :hover {\n    background-color: ", ";\n\n    ", "\n  }\n\n  margin: 2px;\n  margin-bottom: ", ";\n\n  &:focus {\n    outline: ", " auto 1px;\n    border-radius: ", ";\n  }\n"]);
  return Ou = function Ou() {
    return n;
  }, n;
}

Eu.propTypes = {
  variant: c.oneOf(["neutral", "secondary", "positive", "error", "attention", "required"]),
  size: c.oneOf(["m", "s", "xs"]),
  children: c.node
};

var Pu = o(i.motion.button)(Ou(), function (n) {
  return n.theme.fontSizes.m;
}, function (n) {
  return n.theme.fonts.primary;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.active ? n.theme.colors.primary : n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.space.smallest + " " + n.theme.space.regular;
}, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.colors.white;
}, function (n) {
  var e = n.theme,
      t = n.active;
  return n.disabled ? r.css(Su()) : r.css(Du(), t ? e.colors.primary : e.colors.grayDarkest);
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.colors.focus;
}, function (n) {
  return n.theme.radii.m;
}),
    Iu = o.span(zu(), function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.fontSizes.xs;
}, function (n) {
  return n.theme.lineHeights.s;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.radii.l;
}),
    _u = o.div(Cu(), Iu, wu, function (n) {
  return n.theme.space.smallest;
});

function Lu(n) {
  return "tag" === n;
}

var Tu = l.forwardRef(function (n, e) {
  var t = n.children,
      r = n.active,
      o = void 0 !== r && r,
      i = n.notification,
      a = n.disabled,
      u = void 0 !== a && a,
      c = n.onClick,
      f = l.useState(!1),
      d = f[0],
      m = f[1],
      p = null == i ? void 0 : i.isPersistent;
  l.useEffect(function () {
    d && !o || m(o);
  }, [o, d]);

  var h = function (n) {
    if (!n) return !1;
    var e = n.variant,
        t = n.label;
    if (!Lu(e) && !function (n) {
      return "badge" === n;
    }(e)) return console.warn('Pane notification variant: "' + e + '" is not a "tag" nor "badge"'), !1;
    var r = Lu(e) ? "string" : "number",
        o = typeof t === r,
        i = "string" == typeof t ? t.length > 0 : void 0 !== t;
    return o || console.warn('Pane notification label: "' + t + '" does not have the expected type "' + r + '"'), i || console.warn('Pane notification label: "' + t + '" is not valid'), i && o;
  }(i),
      g = p ? h && !o : h && !o && !d,
      v = Lu(null == i ? void 0 : i.variant) ? s.createElement(Eu, {
    variant: "secondary",
    size: "xs"
  }, null == i ? void 0 : i.label) : s.createElement(Iu, null, null == i ? void 0 : i.label);

  return s.createElement(Pu, {
    active: !u && o,
    onClick: function onClick() {
      m(!0), null == c || c();
    },
    ref: e,
    disabled: u,
    type: "button"
  }, s.createElement(_u, null, t, g && v));
});

function Mu() {
  var n = P(["\n  flex-grow: 1;\n"]);
  return Mu = function Mu() {
    return n;
  }, n;
}

var ju = o.div(Mu());

function Ru() {
  var n = P(["\n  height: 2px;\n  margin-left: 2px;\n  margin-right: 2px;\n  bottom: 0;\n  position: absolute;\n  transition: ", ";\n\n  background: ", ";\n"]);
  return Ru = function Ru() {
    return n;
  }, n;
}

var Au = o(i.motion.div)(Ru(), function (n) {
  var e = n.theme,
      t = e.durations,
      r = e.timingFunctions;
  return Z([["left", t.slowly, r.easeInOut], ["width", t.slowly, r.easeInOut]]);
}, function (n) {
  return n.theme.colors.primary;
});

function Nu() {
  var n = P(["\n  position: relative;\n  display: flex;\n  overflow-x: auto;\n  border-bottom: 1px solid ", ";\n"]);
  return Nu = function Nu() {
    return n;
  }, n;
}

function Fu() {
  var n = P(["\n  overflow-y: hidden;\n\n  ", "\n  ", "\n"]);
  return Fu = function Fu() {
    return n;
  }, n;
}

var Bu = o.div(Fu(), e.space, e.layout),
    qu = o.div(Nu(), function (n) {
  return n.theme.colors.gray;
}),
    Hu = function Hu(n) {
  var e = n.className,
      t = n.children,
      r = n.activeIndex,
      o = n.onChange,
      i = O(n, ["className", "children", "activeIndex", "onChange"]),
      u = a.pick(i),
      c = Y(i),
      f = l.useMemo(function () {
    return function (n) {
      return l.Children.toArray(n).map(function (n) {
        return l.isValidElement(n) ? S({
          key: void 0 !== n.key ? String(n.key) : void 0
        }, n.props, {
          node: n
        }) : null;
      }).filter(Boolean);
    }(t);
  }, [t]),
      d = l.useState(function (n, e) {
    var t = (null == n ? void 0 : n.activeIndex) || (null == n ? void 0 : n.initialIndex) || 0;
    return t > e.length ? e.length - 1 : t;
  }(n, f)),
      m = d[0],
      p = d[1];
  l.useEffect(function () {
    void 0 !== r && (p(r), null == o || o(r, f));
  }, [r, f, o]);
  var h = l.useRef(new Map()),
      g = l.useRef(null),
      v = l.useState({
    visible: !1,
    left: 0,
    width: 0
  }),
      b = v[0],
      y = v[1];
  return l.useEffect(function () {
    var n = h.current.get(m),
        e = g.current;

    if (n && e) {
      var t = e.getBoundingClientRect();

      if (t && 0 !== t.width) {
        var r = n.getBoundingClientRect();
        y({
          visible: !0,
          left: r.left + e.scrollLeft - t.left,
          width: r.width
        });
      }
    }
  }, [m]), s.createElement(Bu, Object.assign({
    className: e
  }, u, c), s.createElement(qu, {
    ref: g
  }, f.map(function (n, e) {
    return s.createElement(Tu, {
      key: n.key,
      active: e === m,
      transition: {
        duration: .25
      },
      onClick: (t = e, function () {
        p(t), null == o || o(t, f);
      }),
      label: n.label,
      notification: n.notification,
      ref: function ref(n) {
        h.current.set(e, n);
      },
      disabled: n.disabled
    }, n.label);
    var t;
  }), b.visible && s.createElement(Au, {
    initial: !1,
    style: {
      left: b.left,
      width: b.width
    }
  })), s.createElement(Xa, {
    currentIndex: m
  }, f.map(function (n) {
    return n.node;
  })));
};

function Vu() {
  var n = P(["\n  position: relative;\n  display: inline-block;\n"]);
  return Vu = function Vu() {
    return n;
  }, n;
}

function Uu() {
  var n = P(["\n  cursor: ", ";\n  clip-path: ", ";\n  position: ", ";\n  z-index: ", ";\n\n  svg {\n    transition: color 0.1s;\n  }\n"]);
  return Uu = function Uu() {
    return n;
  }, n;
}

Hu.propTypes = {
  activeIndex: c.number,
  children: c.oneOfType([c.arrayOf(c.node), c.node]).isRequired,
  initialIndex: c.number,
  onChange: c.func
}, Hu.Pane = ju;

var Gu = {
  s: "16px",
  m: "24px",
  l: "32px"
},
    Wu = o(Pn).attrs(function (n) {
  var e = n.size,
      r = void 0 === e ? "m" : e;
  return {
    component: t.Star,
    width: Gu[r],
    height: Gu[r]
  };
})(Uu(), function (n) {
  return n.readOnly ? "default" : "pointer";
}, function (n) {
  return n.half ? "polygon(0 0, 50% 0, 50% 100%, 0 100%)" : "none";
}, function (n) {
  return n.half ? "absolute" : "relative";
}, function (n) {
  return n.half ? "9" : "0";
}),
    Qu = o.div(Vu()),
    Ju = function Ju(n) {
  var e = n.count,
      r = void 0 === e ? 5 : e,
      o = n.rating,
      i = n.onRating,
      u = void 0 === i ? void 0 : i,
      c = n.size,
      f = void 0 === c ? "m" : c,
      d = n.disabled,
      p = void 0 !== d && d,
      h = O(n, ["count", "rating", "onRating", "size", "disabled"]),
      g = l.useState(0),
      v = g[0],
      b = g[1],
      y = m.colors.gray,
      x = m.colors.grayLight,
      k = a.pick(h),
      w = Y(h),
      E = l.useCallback(function (n) {
    if (p) return x;
    var e = !v && o >= n;
    return u ? v >= n || e ? "#FCBB00" : y : e ? "#FCBB00" : y;
  }, [v, u, o, y]),
      C = l.useCallback(function (n) {
    return function () {
      if (!p && u) return b(n);
    };
  }, [u, p]),
      z = Array.from(Array(r), function (n, e) {
    return e + 1;
  }),
      D = S({
    component: t.Star,
    readOnly: !u,
    size: f,
    onMouseLeave: C(0),
    disabled: p
  }, k, w);
  return s.createElement(s.Fragment, null, z.map(function (n) {
    return s.createElement(Qu, {
      key: n
    }, s.createElement(Wu, Object.assign({
      "data-testid": "half-star-rating",
      onClick: function onClick() {
        return !p && !!u && u(n - .5);
      },
      svgProps: {
        color: E(n - .5)
      },
      onMouseEnter: C(n - .5),
      title: n.toString(),
      half: !0
    }, D)), s.createElement(Wu, Object.assign({
      "data-testid": "star-rating",
      onClick: function onClick() {
        return !!u && u(n);
      },
      svgProps: {
        color: E(n)
      },
      onMouseEnter: C(n),
      title: n.toString()
    }, D)));
  }));
};

function Xu() {
  var n = P([""]);
  return Xu = function Xu() {
    return n;
  }, n;
}

function Ku() {
  var n = P([""]);
  return Ku = function Ku() {
    return n;
  }, n;
}

function Zu() {
  var n = P(["\n  font-family: ", ";\n  color: ", ";\n  text-decoration: underline;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  return Zu = function Zu() {
    return n;
  }, n;
}

function Yu() {
  var n = P(["\n  font-size: ", ";\n  line-height: ", ";\n"]);
  return Yu = function Yu() {
    return n;
  }, n;
}

function $u() {
  var n = P(["\n  font-size: ", ";\n  line-height: ", ";\n"]);
  return $u = function $u() {
    return n;
  }, n;
}

function nc() {
  var n = P(["\n  font-size: ", ";\n  line-height: ", ";\n"]);
  return nc = function nc() {
    return n;
  }, n;
}

Ju.defaultProps = {
  count: 5,
  onRating: void 0,
  size: "m"
}, Ju.propTypes = {
  count: u.number,
  rating: u.number.isRequired,
  onRating: u.func,
  size: u.oneOf(["s", "m", "l"])
};

var ec = r.css(nc(), function (n) {
  return n.theme.fontSizes.m;
}, function (n) {
  return n.theme.lineHeights.m;
}),
    tc = r.css($u(), function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.lineHeights.m;
}),
    rc = r.css(Yu(), function (n) {
  return n.theme.fontSizes.xs;
}, function (n) {
  return n.theme.lineHeights.s;
}),
    oc = o.a(Zu(), function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.colors.primary;
}, tc, function (n) {
  return "large" === n.variant ? ec : r.css(Ku());
}, function (n) {
  return "small" === n.variant ? rc : r.css(Xu());
}, e.space, e.layout, e.typography, e.color),
    ic = function ic(n) {
  var e = n.variant,
      t = void 0 === e ? "medium" : e,
      r = O(n, ["variant"]),
      o = Y(r),
      i = a.pick(r);
  return s.createElement(oc, Object.assign({
    variant: t
  }, o, i));
};

function ac() {
  var n = P(["\n  border-bottom: solid 1px ", ";\n\n  ", "\n  ", "\n"]);
  return ac = function ac() {
    return n;
  }, n;
}

ic.propTypes = {
  variant: c.oneOf(["large", "medium", "small"])
};
var uc = r.css(ac(), function (n) {
  return n.theme.colors.gray;
}, e.space, e.layout);

function cc() {
  var n = P(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: bold;\n\n  padding-right: ", ";\n  padding-left: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  text-align: right;\n\n  &:first-child {\n    text-align: left;\n  }\n\n  ", "\n  ", "\n"]);
  return cc = function cc() {
    return n;
  }, n;
}

var lc = r.css(cc(), function (n) {
  return n.theme.fonts.primary;
}, function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.small;
}, e.space, e.layout);

function sc() {
  var n = P(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n\n  padding-right: ", ";\n  padding-left: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  text-align: right;\n\n  ", "\n  ", "\n"]);
  return sc = function sc() {
    return n;
  }, n;
}

var fc = r.css(sc(), function (n) {
  return n.theme.fonts.primary;
}, function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.large;
}, function (n) {
  return n.theme.space.large;
}, e.space, e.layout);

function dc() {
  var n = P(["\n  width: 100%;\n  height: 100%;\n\n  border-spacing: 0px;\n  border-collapse: collapse;\n\n  & tr:hover > td {\n    background-color: ", ";\n  }\n"]);
  return dc = function dc() {
    return n;
  }, n;
}

function mc() {
  var n = P(["\n  overflow-x: auto;\n  ", "\n  ", "\n"]);
  return mc = function mc() {
    return n;
  }, n;
}

function pc() {
  var n = P(["\n  ", "\n\n  &:first-child {\n    font-weight: bold;\n    text-align: left;\n  }\n"]);
  return pc = function pc() {
    return n;
  }, n;
}

function hc() {
  var n = P(["\n  ", "\n"]);
  return hc = function hc() {
    return n;
  }, n;
}

function gc() {
  var n = P(["\n  ", "\n"]);
  return gc = function gc() {
    return n;
  }, n;
}

function vc() {
  var n = P([""]);
  return vc = function vc() {
    return n;
  }, n;
}

function bc() {
  var n = P([""]);
  return bc = function bc() {
    return n;
  }, n;
}

function yc() {
  var n = P([""]);
  return yc = function yc() {
    return n;
  }, n;
}

var xc = o.thead(yc()),
    kc = o.tbody(bc()),
    wc = o.tfoot(vc()),
    Ec = o.tr(gc(), uc),
    Cc = o.th(hc(), lc),
    zc = o.td(pc(), fc),
    Dc = o.div(mc(), e.layout, e.space),
    Sc = o.table(dc(), function (n) {
  return n.theme.colors.grayLight;
}),
    Oc = function Oc(n) {
  var e = n.width,
      t = n.children,
      r = O(n, ["width", "children"]),
      o = a.pick(r),
      i = Y(r);
  return s.createElement(Dc, Object.assign({
    width: e
  }, o, {}), s.createElement(Sc, Object.assign({}, i), t));
};

function Pc() {
  var n = P(["\n  width: 100%;\n  height: 100%;\n\n  & li:hover {\n    background-color: ", ";\n  }\n\n  list-style: none;\n  padding-left: 0px;\n"]);
  return Pc = function Pc() {
    return n;
  }, n;
}

function Ic() {
  var n = P(["\n  ", "\n  ", "\n"]);
  return Ic = function Ic() {
    return n;
  }, n;
}

function _c() {
  var n = P(["\n  ", "\n"]);
  return _c = function _c() {
    return n;
  }, n;
}

function Lc() {
  var n = P(["\n  ", "\n  ", "\n  text-align: left;\n"]);
  return Lc = function Lc() {
    return n;
  }, n;
}

Oc.Head = xc, Oc.Body = kc, Oc.Foot = wc, Oc.Data = zc, Oc.Header = Cc, Oc.Row = Ec;

var Tc = o.li(Lc(), uc, fc),
    Mc = o.div(_c(), lc),
    jc = o.div(Ic(), e.layout, e.space),
    Rc = o.ul(Pc(), function (n) {
  return n.theme.colors.grayLight;
}),
    Ac = function Ac(n) {
  var e = n.children,
      t = O(n, ["children"]),
      r = a.pick(t),
      o = Y(t);
  return s.createElement(jc, Object.assign({}, r, {}), s.createElement(Rc, Object.assign({}, o), e));
};

function Nc() {
  var n = P(["\n  padding: 0;\n  font-size: 0;\n  line-height: 0;\n"]);
  return Nc = function Nc() {
    return n;
  }, n;
}

function Fc() {
  var n = P(["\n  ", "\n  text-align: center;\n\n  width: 100%;\n\n  color: ", ";\n\n  &[disabled] {\n    background-color: ", ";\n  }\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    appearance: none;\n    margin: 0;\n  }\n"]);
  return Fc = function Fc() {
    return n;
  }, n;
}

function Bc() {
  var n = P(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  display: flex;\n  flex-direction: column;\n  ", "\n  ", ";\n"]);
  return Bc = function Bc() {
    return n;
  }, n;
}

function qc() {
  var n = P(["\n  min-width: 5rem;\n  display: inline-flex;\n  align-items: center;\n  padding: ", " 0;\n"]);
  return qc = function qc() {
    return n;
  }, n;
}

Ac.Item = Tc, Ac.Header = Mc;
var Hc = o.div(qc(), function (n) {
  return n.theme.space.smallest;
}),
    Vc = o(ai)(Bc(), function (n) {
  return n.theme.fonts.primary;
}, function (n) {
  return n.theme.fontSizes.m;
}, function (n) {
  return n.theme.lineHeights.m;
}, e.space, e.layout),
    Uc = o.input(Fc(), Ao, function (n) {
  return n.disabled ? n.theme.colors.grayDarker : n.theme.colors.black;
}, function (n) {
  return n.theme.colors.white;
}),
    Gc = o(Be)(Nc()),
    Wc = {
  "pt-br": {
    increase: "Aumentar valor",
    decrease: "Diminuir valor"
  },
  "en-us": {
    increase: "Increase value",
    decrease: "Decrease value"
  },
  "es-mx": {
    increase: "Aumentar valor",
    decrease: "Disminuir valor"
  },
  "es-co": {
    increase: "Aumentar valor",
    decrease: "Disminuir valor"
  }
},
    Qc = l.forwardRef(function (n, e) {
  var r = n.increaseAriaLabel,
      o = n.decreaseAriaLabel,
      i = n.error,
      u = n.label,
      c = n.step,
      f = void 0 === c ? 1 : c,
      d = n.disabled,
      m = n.value,
      p = O(n, ["increaseAriaLabel", "decreaseAriaLabel", "error", "label", "step", "disabled", "value"]),
      h = a.pick(p),
      g = Y(p),
      v = g["data-testid"],
      b = O(g, ["data-testid"]),
      y = l.useContext(J).locale,
      x = X(e);
  l.useEffect(function () {
    if (x.current) {
      var n = "" === m || void 0 === m || isNaN(Number(m)) ? "" : Number(m);
      x.current.value = "" + n;
    }
  }, [x, m]);
  var k = l.useCallback(function () {
    if (x.current && !d) {
      var n = Number(x.current.value) - f;
      (!x.current.min || n >= Number(x.current.min)) && (x.current.value = "" + n, x.current.dispatchEvent(new Event("input", {
        bubbles: !0
      })));
    }
  }, [d, x, f]),
      w = l.useCallback(function () {
    if (x.current && !d) {
      var n = Number(x.current.value) + f;
      (!x.current.max || n <= Number(x.current.max)) && (x.current.value = "" + n, x.current.dispatchEvent(new Event("input", {
        bubbles: !0
      })));
    }
  }, [d, x, f]),
      E = b.id ? b.id : b.name;
  return s.createElement(Vc, Object.assign({}, h, {
    id: E,
    "data-testid": v,
    error: i,
    label: u
  }), s.createElement(Hc, null, s.createElement(Gc, {
    px: 0,
    onClick: k,
    type: "button",
    variant: "tertiary",
    disabled: d,
    "aria-label": o || Wc[y].decrease
  }, s.createElement(Pn, {
    component: t.Minus,
    size: "s"
  })), s.createElement(Uc, Object.assign({}, b, {
    type: "number",
    ref: x,
    step: "" + f,
    id: E,
    value: m,
    disabled: d,
    onInput: b.onChange
  })), s.createElement(Gc, {
    p: 0,
    onClick: w,
    type: "button",
    variant: "tertiary",
    disabled: d,
    "aria-label": r || Wc[y].increase
  }, s.createElement(Pn, {
    component: t.Plus,
    size: "s"
  }))));
});

function Jc() {
  var n = P(["\n          &:focus {\n            + ", " > ", " > ", " {\n              outline: none;\n              box-shadow: ", ";\n            }\n          }\n        "]);
  return Jc = function Jc() {
    return n;
  }, n;
}

function Xc() {
  var n = P(["\n          + ", " {\n            box-shadow: 0px 2px 2px rgba(62, 62, 62, 0.15);\n          }\n\n          &:focus {\n            + ", " {\n              box-shadow: ", ";\n            }\n          }\n        "]);
  return Xc = function Xc() {
    return n;
  }, n;
}

function Kc() {
  var n = P(["\n  width: 0;\n  height: 0;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n  position: absolute;\n\n  &:checked {\n    + ", " {\n      border-color: ", ";\n    }\n\n    + ", " > ", " > ", " {\n      border-color: ", ";\n      background-color: ", ";\n    }\n\n    + ", " > ", " > ", "::after {\n      background-color: ", ";\n      box-shadow: 0px 1px 1px\n        ", ";\n    }\n  }\n\n  ", "\n"]);
  return Kc = function Kc() {
    return n;
  }, n;
}

function Zc() {
  var n = P(["\n  display: block;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"]);
  return Zc = function Zc() {
    return n;
  }, n;
}

function Yc() {
  var n = P(["\n  display: block;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: bold;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"]);
  return Yc = function Yc() {
    return n;
  }, n;
}

function $c() {
  var n = P(["\n  flex: 1;\n"]);
  return $c = function $c() {
    return n;
  }, n;
}

function nl() {
  var n = P(["\n  position: relative;\n  width: ", ";\n  height: ", ";\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  box-sizing: border-box;\n  border-style: solid;\n  border-width: 1px;\n  border-color: ", ";\n  border-radius: ", ";\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n\n  box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.15);\n\n  transition: ", ";\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &::after {\n    width: 6px;\n    height: 6px;\n    content: '';\n    background-color: transparent;\n    border-radius: ", ";\n    box-shadow: none;\n  }\n"]);
  return nl = function nl() {
    return n;
  }, n;
}

function el() {
  var n = P(["\n  line-height: 0;\n  margin: 0;\n  margin-right: ", ";\n"]);
  return el = function el() {
    return n;
  }, n;
}

function tl() {
  var n = P(["\n  display: flex;\n  border-style: solid;\n  border-width: 1px;\n  border-color: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  cursor: pointer;\n  align-items: center;\n\n  transition: ", ";\n\n  &:hover {\n    background: ", ";\n  }\n"]);
  return tl = function tl() {
    return n;
  }, n;
}

function rl() {
  var n = P(["\n  ", "\n  ", "\n"]);
  return rl = function rl() {
    return n;
  }, n;
}

Qc.propTypes = {
  step: c.number,
  value: c.number,
  id: c.string,
  error: c.string,
  label: c.string,
  disabled: c.bool,
  onChange: c.func
};
var ol = o.div(rl(), e.space, e.layout),
    il = o.label(tl(), function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.radii.m;
}, function (n) {
  return n.theme.space.large;
}, function (n) {
  var e = n.theme,
      t = e.durations,
      r = e.timingFunctions;
  return Z([["background", t.promptly, r.ease], ["border-color", t.promptly, r.ease], ["box-shadow", t.promptly, r.ease]]);
}, function (n) {
  return n.theme.colors.grayLight;
}),
    al = o.div(el(), function (n) {
  return n.theme.space.large;
}),
    ul = o.div(nl(), function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.radii.l;
}, function (n) {
  var e = n.theme,
      t = e.durations,
      r = e.timingFunctions;
  return Z([["background", t.promptly, r.ease], ["border-color", t.promptly, r.ease], ["box-shadow", t.promptly, r.ease]]);
}, function (n) {
  return n.theme.radii.l;
}),
    cl = o.div($c()),
    ll = o.span(Yc(), function (n) {
  return n.theme.fonts.primary;
}, function (n) {
  return n.theme.fontSizes.m;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.colors.black;
}),
    sl = o.span(Zc(), function (n) {
  return n.theme.fonts.primary;
}, function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.colors.black;
}),
    fl = o.input(Kc(), il, function (n) {
  return n.theme.colors.primary;
}, il, al, ul, function (n) {
  return n.theme.colors.grayDarkest;
}, function (n) {
  return n.theme.colors.primary;
}, il, al, ul, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.colors.grayDarkest;
}, function (n) {
  return n.icon ? r.css(Xc(), il, il, function (n) {
    return n.theme.shadows.focus;
  }) : r.css(Jc(), il, al, ul, function (n) {
    return n.theme.shadows.focus;
  });
}),
    dl = l.forwardRef(function (n, e) {
  var t = n.title,
      r = n.description,
      o = n.className,
      i = n.icon,
      u = n.svgProps,
      c = n.id,
      f = O(n, ["title", "description", "className", "icon", "svgProps", "id"]),
      d = a.pick(f),
      m = Y(f),
      p = m["data-testid"],
      h = O(m, ["data-testid"]),
      g = X(e),
      v = l.useCallback(function () {
    var n;
    null == g || null === (n = g.current) || void 0 === n || n.click();
  }, [g]);
  return s.createElement(ol, Object.assign({
    className: o,
    "data-testid": p
  }, d), s.createElement(fl, Object.assign({
    id: c,
    ref: g,
    type: "radio",
    icon: i
  }, h)), s.createElement(il, {
    htmlFor: c,
    onClick: v
  }, s.createElement(al, null, i ? s.createElement(Pn, {
    size: "l",
    svgProps: u,
    component: i
  }) : s.createElement(ul, null)), s.createElement(cl, null, s.createElement(ll, null, t), s.createElement(sl, null, r))));
});

function ml() {
  var n = P(["\n  margin-left: 0;\n  margin-right: 0;\n"]);
  return ml = function ml() {
    return n;
  }, n;
}

function pl() {
  var n = P([""]);
  return pl = function pl() {
    return n;
  }, n;
}

function hl() {
  var n = P(["\n  ", "\n  ", "\n"]);
  return hl = function hl() {
    return n;
  }, n;
}

dl.propTypes = {
  title: c.string.isRequired,
  description: c.string.isRequired,
  icon: c.oneOfType([c.node, c.func]),
  id: c.string,
  className: c.string
};

var gl = o.div(hl(), e.space, e.layout),
    vl = o.div(pl()),
    bl = o(Jo)(ml()),
    yl = function yl(n) {
  var e = n.className,
      t = n.children,
      r = n.error,
      o = O(n, ["className", "children", "error"]);
  return s.createElement(gl, Object.assign({
    role: "radiogroup"
  }, o), s.createElement(vl, {
    className: e
  }, t), r && s.createElement(bl, {
    role: "alert"
  }, r));
};

yl.propTypes = {
  error: c.string,
  className: c.string
};
var xl = {
  Group: yl,
  Option: dl
};

function kl(n) {
  return "url(data:image/svg+xml;utf8," + encodeURIComponent('<svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.11092 4.36385C0.720391 3.97332 0.720391 3.34016 1.11092 2.94963C1.50144 2.55911 2.1346 2.55911 2.52513 2.94963L5.35356 5.77806L3.93934 7.19227L1.11092 4.36385Z" fill="' + n + '"/><path d="M2.5249 5.77783L7.47465 0.828085C7.86517 0.43756 8.49834 0.43756 8.88886 0.828085C9.27939 1.21861 9.27939 1.85177 8.88886 2.2423L3.93912 7.19205L2.5249 5.77783Z" fill="' + n + '"/></svg>') + ")";
}

function wl() {
  var n = P(["\n  margin-left: 0;\n  margin-right: 0;\n"]);
  return wl = function wl() {
    return n;
  }, n;
}

function El() {
  var n = P(["\n  display: flex;\n  flex-direction: column;\n"]);
  return El = function El() {
    return n;
  }, n;
}

function Cl() {
  var n = P(["\n  ", "\n  ", "\n"]);
  return Cl = function Cl() {
    return n;
  }, n;
}

var zl = o.div(Cl(), e.space, e.layout),
    Dl = o.div(El()),
    Sl = o(Jo)(wl()),
    Ol = function Ol(n) {
  var e = n.className,
      t = n.children,
      r = n.error,
      o = O(n, ["className", "children", "error"]);
  return s.createElement(zl, Object.assign({
    role: "group"
  }, o), s.createElement(Dl, {
    className: e
  }, t), r && s.createElement(Sl, {
    role: "alert"
  }, r));
};

function Pl() {
  var n = P(["\n  position: absolute;\n  width: 0;\n  height: 0;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n\n  &:checked {\n    + ", " > ", " {\n      border-color: ", ";\n      background-color: ", ";\n      background-image: ", ";\n    }\n  }\n\n  &:disabled {\n    + ", " > ", " {\n      border-color: ", ";\n      background-color: ", ";\n      background-image: unset;\n    }\n  }\n\n  &:checked:disabled {\n    + ", " > ", " {\n      border-color: ", ";\n      background-color: ", ";\n      background-image: ", ";\n    }\n  }\n\n  &:focus {\n    + ", " > ", " {\n      outline: none;\n      box-shadow: ", ";\n    }\n  }\n"]);
  return Pl = function Pl() {
    return n;
  }, n;
}

function Il() {
  var n = P(["\n  position: relative;\n  width: 14px;\n  height: 14px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  box-sizing: border-box;\n  border-style: solid;\n  border-width: 1px;\n  border-color: ", ";\n  border-radius: 2px;\n  padding: 0;\n  margin: 0;\n  margin-right: ", ";\n  display: inline-block;\n  transition: ", ";\n  cursor: pointer;\n\n  &:hover {\n    border-color: ", ";\n    background-color: ", ";\n  }\n"]);
  return Il = function Il() {
    return n;
  }, n;
}

function _l() {
  var n = P(["\n  font-weight: normal;\n  margin-bottom: 0px;\n"]);
  return _l = function _l() {
    return n;
  }, n;
}

function Ll() {
  var n = P(["\n  display: flex;\n  align-items: center;\n"]);
  return Ll = function Ll() {
    return n;
  }, n;
}

function Tl() {
  var n = P(["\n  display: inline-block;\n\n  ", "\n  ", "\n"]);
  return Tl = function Tl() {
    return n;
  }, n;
}

Ol.propTypes = {
  error: c.string
};
var Ml = o.div(Tl(), e.space, e.layout),
    jl = o.div(Ll()),
    Rl = o(Wo)(_l()),
    Al = o.span(Il(), function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  var e = n.theme;
  return Z([["all", e.durations.quickly, e.timingFunctions.ease]]);
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.colors.primaryLightest;
}),
    Nl = o.input(Pl(), jl, Al, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return kl(n.theme.colors.white);
}, jl, Al, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.colors.gray;
}, jl, Al, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.colors.gray;
}, function (n) {
  return kl(n.theme.colors.grayDarker);
}, jl, Al, function (n) {
  return n.theme.shadows.focus;
}),
    Fl = l.forwardRef(function (n, e) {
  var t = n.label,
      r = n.className,
      o = n.id,
      i = O(n, ["label", "className", "id"]),
      u = a.pick(n),
      c = Y(i),
      f = c["data-testid"],
      d = c["aria-label"],
      m = O(c, ["data-testid", "aria-label"]),
      p = X(e),
      h = l.useCallback(function () {
    (null == p ? void 0 : p.current) && (null == p || p.current.click());
  }, [p]);
  return s.createElement(Ml, Object.assign({
    className: r,
    "data-testid": f
  }, u), s.createElement(Nl, Object.assign({
    id: o,
    ref: p,
    type: "checkbox"
  }, m)), s.createElement(jl, null, s.createElement(Al, {
    role: "checkbox",
    onClick: h,
    "aria-label": d
  }), s.createElement(Rl, {
    htmlFor: o
  }, t)));
});
Fl.propTypes = {
  label: c.string
};

var Bl = {
  Group: Ol,
  Button: Fl
},
    ql = function ql(n, e) {
  return C.format(n, e);
},
    Hl = function Hl(n, e) {
  if (n.length === e.length) {
    var t = C.parse(n, e, new Date());
    if (w.DateUtils.isDate(t)) return t;
  }
};

function Vl() {
  var n = P(["\n  ", "\n  padding-left: ", ";\n  margin-right: ", ";\n"]);
  return Vl = function Vl() {
    return n;
  }, n;
}

function Ul() {
  var n = P(["\n  ", "\n  margin-left: ", ";\n  padding-right: ", ";\n"]);
  return Ul = function Ul() {
    return n;
  }, n;
}

function Gl() {
  var n = P(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n"]);
  return Gl = function Gl() {
    return n;
  }, n;
}

function Wl() {
  var n = P(["\n  margin-left: ", ";\n  border: none;\n  padding: 0;\n  color: ", ";\n  background-color: transparent;\n  cursor: pointer;\n  font-size: 0;\n\n  &:focus-within {\n    outline: none;\n    border-radius: ", ";\n    box-shadow: ", ";\n  }\n"]);
  return Wl = function Wl() {
    return n;
  }, n;
}

function Ql() {
  var n = P(["\n      ", " ", "\n    "]);
  return Ql = function Ql() {
    return n;
  }, n;
}

function Jl() {
  var n = P(["\n  ", "\n  width: 100%;\n  padding: ", ";\n"]);
  return Jl = function Jl() {
    return n;
  }, n;
}

function Xl() {
  var n = P([""]);
  return Xl = function Xl() {
    return n;
  }, n;
}

function Kl() {
  var n = P([""]);
  return Kl = function Kl() {
    return n;
  }, n;
}

function Zl() {
  var n = P([""]);
  return Zl = function Zl() {
    return n;
  }, n;
}

function Yl() {
  var n = P(["\n  ", "\n  display: flex;\n  align-items: center;\n\n  background-color: ", ";\n\n  ", "\n\n  ", ";\n\n  ", ";\n\n  ", "\n  ", "\n"]);
  return Yl = function Yl() {
    return n;
  }, n;
}

function $l() {
  var n = P(["\n  color: ", ";\n  background-color: ", ";\n"]);
  return $l = function $l() {
    return n;
  }, n;
}

var ns = r.css($l(), function (n) {
  return n.theme.colors.black;
}, function (n) {
  return n.theme.colors.white;
}),
    es = o.div(Yl(), Ro, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.error ? No : r.css(Zl());
}, function (n) {
  return n.disabled ? Fo : r.css(Kl());
}, function (n) {
  return n.allowClear ? ns : r.css(Xl());
}, e.space, e.layout),
    ts = o.input(Jl(), Ao, function (n) {
  var e = n.theme.space;
  return r.css(Ql(), e.small, e.smaller);
}),
    rs = o.button(Wl(), function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.radii.l;
}, function (n) {
  return n.theme.shadows.focusLight;
}),
    os = r.css(Gl()),
    is = o.div(Ul(), os, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.smaller;
}),
    as = o.div(Vl(), os, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.smaller;
}),
    us = {
  "pt-br": {
    clear: "Limpar campo"
  },
  "en-us": {
    clear: "Clear field"
  },
  "es-mx": {
    clear: "Limpiar campo"
  },
  "es-co": {
    clear: "Limpiar campo"
  }
},
    cs = l.forwardRef(function (n, e) {
  var r = a.pick(n),
      o = l.useContext(J).locale,
      i = X(e),
      u = l.useState(!1),
      c = u[0],
      f = u[1],
      d = n.onChange,
      m = n.onInput;
  l.useEffect(function () {
    i.current && i.current.value && f(!0);
  }, [i]);
  var p = l.useCallback(function () {
    i.current && (i.current.value = "", i.current.dispatchEvent(new Event("input", {
      bubbles: !0
    })), f(!1));
  }, [i]),
      h = l.useCallback(function (n) {
    f(!(!n || !n.target.value)), null == d || d(n);
  }, [d]),
      g = l.useCallback(function (n) {
    f(!(!n || !n.target.value)), null == m || m(n);
  }, [m]),
      v = Y(n),
      b = v.id ? v.id : v.name,
      y = !n.disabled && n.allowClear && c,
      x = n.suffixComponent || y;
  return s.createElement(ai, Object.assign({
    id: b,
    error: n.error,
    label: n.label,
    disabled: n.disabled,
    elementRef: i,
    showCounter: n.showCounter
  }, r), s.createElement(es, {
    error: n.error,
    disabled: n.disabled
  }, n.prefixComponent && s.createElement(is, null, n.prefixComponent), s.createElement(ts, Object.assign({}, v, {
    id: b,
    ref: i,
    onChange: h,
    onInput: g,
    "aria-invalid": Boolean(n.error)
  })), x && s.createElement(as, null, s.createElement(fi, {
    error: n.error
  }, y && s.createElement(rs, {
    type: "button",
    "aria-label": n.clearAriaLabel || us[o].clear,
    onClick: p
  }, s.createElement(Pn, {
    component: t.ClearFieldFilled,
    size: "s"
  }))), n.suffixComponent)));
});

function ls() {
  var n = P(["\n  color: ", ";\n  cursor: pointer;\n"]);
  return ls = function ls() {
    return n;
  }, n;
}

cs.propTypes = {
  allowClear: c.bool,
  clearAriaLabel: c.string,
  error: c.string,
  name: c.string,
  label: c.string,
  disabled: c.bool,
  prefixComponent: c.node,
  suffixComponent: c.node
};
var ss = o(Pn)(ls(), function (n) {
  return "" + n.theme.colors.primary;
}),
    fs = l.forwardRef(function (n, e) {
  var r = n.className,
      o = n.value,
      i = n.placeholder,
      u = n.format,
      c = void 0 === u ? "dd/MM/yyyy" : u,
      f = n.onBlur,
      d = n.id,
      m = n.name,
      p = n.month,
      h = n.error,
      g = n.disabledDays,
      v = O(n, ["className", "value", "placeholder", "format", "onBlur", "id", "name", "month", "error", "disabledDays"]),
      b = a.pick(v),
      y = Y(v),
      x = y["data-testid"],
      k = O(y, ["data-testid"]),
      E = l.useContext(J).locale,
      D = X(e),
      P = l.useCallback(function (n) {
    D.current && w.DateUtils.isDate(n) && (D.current.value = ql(n, c), D.current.dispatchEvent(new Event("input", {
      bubbles: !0
    })));
  }, [c, D]);
  return s.createElement(_a, Object.assign({}, b, {
    "data-testid": x,
    className: r,
    rangeSelection: !1,
    style: {
      position: "relative"
    }
  }), s.createElement(z, {
    format: c,
    formatDate: ql,
    parseDate: Hl,
    onDayChange: P,
    placeholder: i || c,
    value: o,
    component: cs,
    inputProps: S({}, k, {
      showCounter: !1,
      ref: D,
      id: d,
      name: m,
      onBlur: f,
      onInput: k.onChange,
      suffixComponent: s.createElement(ss, {
        "data-testid": "calendar-icon",
        onClick: function onClick() {
          var n;
          return null === (n = D.current) || void 0 === n ? void 0 : n.focus();
        },
        component: t.CalendarOutlined,
        size: "s"
      }),
      error: h
    }),
    dayPickerProps: {
      disabledDays: g,
      locale: E,
      month: p,
      months: wa[E],
      weekdaysLong: Ea[E],
      weekdaysShort: ka[E],
      firstDayOfWeek: Ca[E],
      labels: za[E],
      numberOfMonths: 1,
      renderDay: function renderDay(n) {
        return s.createElement("div", {
          className: "DayPicker-inner-day"
        }, C.format(n, "d"));
      }
    }
  }));
});

function ds() {
  var n = P(["\n  position: absolute;\n  width: 0;\n  height: 0;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n\n  &:checked {\n    + ", " > ", " {\n      border-color: ", ";\n      background-color: ", ";\n    }\n\n    + ", " > ", "::after {\n      background-color: ", ";\n      box-shadow: 0px 1px 1px\n        ", ";\n    }\n  }\n\n  &:focus {\n    + ", " > ", " {\n      outline: none;\n      box-shadow: ", ";\n    }\n  }\n\n  &:disabled {\n    + ", " > ", " {\n      border-color: ", ";\n      background-color: ", ";\n      background-image: unset;\n    }\n  }\n\n  &:checked:disabled {\n    + ", " > ", " {\n      border-color: ", ";\n      background-color: ", ";\n    }\n  }\n"]);
  return ds = function ds() {
    return n;
  }, n;
}

function ms() {
  var n = P(["\n  position: relative;\n  width: ", ";\n  height: ", ";\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  box-sizing: border-box;\n  border-style: solid;\n  border-width: 1px;\n  border-color: ", ";\n  border-radius: ", ";\n  padding: 0;\n  margin: 0;\n  margin-right: ", ";\n  display: inline-block;\n  transition: ", ";\n  cursor: pointer;\n\n  box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.15);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &::after {\n    width: 6px;\n    height: 6px;\n    content: '';\n    background-color: transparent;\n    border-radius: ", ";\n    box-shadow: ", ";\n  }\n"]);
  return ms = function ms() {
    return n;
  }, n;
}

function ps() {
  var n = P(["\n  font-weight: normal;\n  margin-bottom: 0px;\n"]);
  return ps = function ps() {
    return n;
  }, n;
}

function hs() {
  var n = P(["\n  display: flex;\n  align-items: center;\n"]);
  return hs = function hs() {
    return n;
  }, n;
}

function gs() {
  var n = P(["\n  display: inline-block;\n\n  ", "\n  ", "\n"]);
  return gs = function gs() {
    return n;
  }, n;
}

fs.propTypes = {
  value: c.string,
  format: c.string,
  error: c.string,
  name: c.string,
  label: c.string,
  disabled: c.bool
};
var vs = o.div(gs(), e.space, e.layout),
    bs = o.div(hs()),
    ys = o(Wo)(ps()),
    xs = o.span(ms(), function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.radii.l;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  var e = n.theme;
  return Z([["all", e.durations.quickly, e.timingFunctions.ease]]);
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.radii.l;
}, function (n) {
  return n.theme.shadows.none;
}),
    ks = o.input(ds(), bs, xs, function (n) {
  return n.theme.colors.grayDarkest;
}, function (n) {
  return n.theme.colors.primary;
}, bs, xs, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.colors.grayDarker;
}, bs, xs, function (n) {
  return n.theme.shadows.focus;
}, bs, xs, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.colors.gray;
}, bs, xs, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.colors.gray;
}),
    ws = l.forwardRef(function (n, e) {
  var t = n.label,
      r = n.className,
      o = n.id,
      i = O(n, ["label", "className", "id"]),
      u = a.pick(n),
      c = Y(i),
      f = c["data-testid"],
      d = c["aria-label"],
      m = O(c, ["data-testid", "aria-label"]),
      p = X(e),
      h = l.useCallback(function () {
    var n;
    null == p || null === (n = p.current) || void 0 === n || n.click();
  }, [p]);
  return s.createElement(vs, Object.assign({
    className: r,
    "data-testid": f
  }, u), s.createElement(ks, Object.assign({
    id: o,
    ref: p,
    type: "radio"
  }, m)), s.createElement(bs, null, s.createElement(xs, {
    role: "checkbox",
    "aria-label": d,
    onClick: h
  }), s.createElement(ys, {
    htmlFor: o
  }, t)));
});

function Es() {
  var n = P(["\n  margin-left: 0;\n  margin-right: 0;\n"]);
  return Es = function Es() {
    return n;
  }, n;
}

function Cs() {
  var n = P(["\n  display: flex;\n  flex-direction: column;\n"]);
  return Cs = function Cs() {
    return n;
  }, n;
}

function zs() {
  var n = P(["\n  ", "\n  ", "\n"]);
  return zs = function zs() {
    return n;
  }, n;
}

ws.propTypes = {
  label: c.string
};

var Ds = o.div(zs(), e.space, e.layout),
    Ss = o.div(Cs()),
    Os = o(Jo)(Es()),
    Ps = function Ps(n) {
  var e = n.className,
      t = n.children,
      r = n.error,
      o = O(n, ["className", "children", "error"]);
  return s.createElement(Ds, Object.assign({
    role: "radiogroup"
  }, o), s.createElement(Ss, {
    className: e
  }, t), r && s.createElement(Os, {
    role: "alert"
  }, r));
};

Ps.propTypes = {
  error: c.string
};
var Is = {
  Group: Ps,
  Button: ws
},
    _s = {
  "pt-br": {
    search: "Buscar"
  },
  "en-us": {
    search: "Search"
  },
  "es-mx": {
    search: "Buscar"
  },
  "es-co": {
    search: "Buscar"
  }
};

function Ls() {
  var n = P(["\n  color: ", ";\n"]);
  return Ls = function Ls() {
    return n;
  }, n;
}

var Ts = o(Pn)(Ls(), function (n) {
  return n.theme.colors.primary;
}),
    Ms = l.forwardRef(function (n, e) {
  var r = l.useContext(J).locale,
      o = n.label,
      i = n.options,
      u = void 0 === i ? [] : i,
      c = n.value,
      f = n.onSearch,
      d = n.onChange,
      m = n.onSelectOption,
      p = n.allowClear,
      h = n.error,
      g = O(n, ["label", "options", "value", "onSearch", "onChange", "onSelectOption", "allowClear", "error"]),
      b = X(e),
      y = l.useCallback(function (n) {
    var e = n.selectedItem;
    (null == b ? void 0 : b.current) && (b.current.value = e, b.current.dispatchEvent(new Event("input", {
      bubbles: !0
    }))), null == m || m(e);
  }, [b, m]),
      x = l.useCallback(function (n) {
    null == f || f(n.inputValue);
  }, [f]),
      k = v.useCombobox({
    items: u,
    onInputValueChange: x,
    onSelectedItemChange: y,
    initialSelectedItem: c
  }),
      w = k.isOpen,
      E = k.reset,
      C = k.getInputProps,
      z = k.getLabelProps,
      D = k.getMenuProps,
      P = k.getComboboxProps,
      I = k.highlightedIndex,
      _ = k.getItemProps,
      L = k.selectItem;
  l.useEffect(function () {
    c && u.includes(c) && L(c);
  }, [u, L, c]);
  var T = l.useCallback(function (n) {
    null == d || d(n), n.target.value || E();
  }, [d, E]),
      M = l.useState(null),
      j = M[0],
      R = M[1],
      A = Y(g),
      N = a.pick(g);
  return s.createElement(ai, Object.assign({}, N, {
    error: h
  }), o && s.createElement(Wo, Object.assign({}, z()), o), s.createElement("div", {
    ref: R
  }, s.createElement("div", Object.assign({}, P()), s.createElement(cs, Object.assign({}, C(S({}, A, {
    ref: b
  })), {
    onInput: T,
    allowClear: p,
    prefixComponent: s.createElement(Ts, {
      component: t.SearchOutlined,
      size: "xs",
      svgProps: {
        "aria-label": n.searchIconLabel || _s[r].search
      }
    })
  }))), s.createElement(pi, {
    referenceElement: j,
    visible: w
  }, s.createElement(Uo, Object.assign({}, D()), w ? u.map(function (n, e) {
    return s.createElement(Vo, Object.assign({
      className: I === e ? "selected" : "",
      key: "" + n + e
    }, _({
      item: n,
      index: e
    })), n);
  }) : null))));
});

function js() {
  var n = P(["\n  width: 0;\n  height: 0;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n\n  &:checked {\n    + ", " {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n\n  &:disabled {\n    + ", " {\n      border-color: ", ";\n      background-color: ", ";\n      background-image: unset;\n    }\n  }\n\n  &:checked:disabled {\n    + ", " {\n      border-color: ", ";\n      background-color: ", ";\n    }\n  }\n"]);
  return js = function js() {
    return n;
  }, n;
}

function Rs() {
  var n = P(["\n  box-sizing: border-box;\n\n  padding-left: ", ";\n  padding-right: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  margin: 0;\n\n  text-align: center;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: ", ";\n\n  transition: ", ";\n  cursor: pointer;\n"]);
  return Rs = function Rs() {
    return n;
  }, n;
}

function As() {
  var n = P(["\n  display: inline-flex;\n  overflow: hidden;\n  border: solid 1px ", ";\n  border-right: 0px;\n\n  &:first-child {\n    border-top-left-radius: ", ";\n    border-bottom-left-radius: ", ";\n  }\n\n  &:last-child {\n    border-top-right-radius: ", ";\n    border-bottom-right-radius: ", ";\n    border-right: solid 1px ", ";\n  }\n\n  &:focus-within {\n    position: relative;\n    z-index: 1;\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  ", "\n  ", "\n"]);
  return As = function As() {
    return n;
  }, n;
}

Ms.propTypes = {
  className: c.string,
  allowClear: c.bool,
  clearAriaLabel: c.string,
  options: c.arrayOf(c.string.isRequired),
  onSearch: c.func,
  onSelectOption: c.func,
  error: c.string,
  name: c.string,
  label: c.string,
  disabled: c.bool,
  showCounter: c.bool,
  searchIconLabel: c.string
};
var Ns = o.div(As(), function (n) {
  return n.theme.colors.gray;
}, function (n) {
  return n.theme.radii.s;
}, function (n) {
  return n.theme.radii.s;
}, function (n) {
  return n.theme.radii.s;
}, function (n) {
  return n.theme.radii.s;
}, function (n) {
  return n.theme.colors.gray;
}, function (n) {
  return n.theme.shadows.focusLight;
}, e.space, e.layout),
    Fs = o.label(Rs(), function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.fontSizes.xs;
}, function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.colors.grayLight;
}, function (n) {
  var e = n.theme;
  return Z([["all", e.durations.quickly, e.timingFunctions.ease]]);
}),
    Bs = o.input(js(), Fs, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.colors.primary;
}, Fs, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.colors.gray;
}, Fs, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.colors.gray;
}),
    qs = l.forwardRef(function (n, e) {
  var t = n.label,
      r = n.id,
      o = O(n, ["label", "id"]),
      i = X(e),
      u = l.useCallback(function () {
    var n;
    null == i || null === (n = i.current) || void 0 === n || n.click();
  }, [i]),
      c = a.pick(o),
      f = Y(o),
      d = f["data-testid"],
      m = O(f, ["data-testid"]);
  return s.createElement(Ns, Object.assign({
    role: "radio",
    "data-testid": d
  }, c), s.createElement(Bs, Object.assign({
    id: r,
    ref: i,
    type: "radio"
  }, m)), s.createElement(Fs, {
    htmlFor: r,
    onClick: u
  }, t));
});

function Hs() {
  var n = P(["\n  margin-left: 0;\n  margin-right: 0;\n"]);
  return Hs = function Hs() {
    return n;
  }, n;
}

function Vs() {
  var n = P(["\n  ", "\n  ", "\n"]);
  return Vs = function Vs() {
    return n;
  }, n;
}

qs.propTypes = {
  label: c.string.isRequired
};

var Us = o.div(Vs(), e.space, e.layout),
    Gs = o(Jo)(Hs()),
    Ws = function Ws(n) {
  var e = n.className,
      t = n.children,
      r = n.error,
      o = O(n, ["className", "children", "error"]),
      i = a.pick(o),
      u = Y(o);
  return s.createElement(Us, Object.assign({
    role: "radiogroup"
  }, u, i), s.createElement("div", {
    className: e
  }, t), r && s.createElement(Gs, {
    role: "alert"
  }, r));
};

Ws.propTypes = {
  error: c.string
};
var Qs = {
  Group: Ws,
  Button: qs
};

function Js() {
  var n = P(["\n  cursor: auto;\n  text-align: center;\n  box-sizing: border-box;\n\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n\n  &.selected {\n    background-color: ", ";\n  }\n"]);
  return Js = function Js() {
    return n;
  }, n;
}

function Xs() {
  var n = P(["\n  margin-left: ", ";\n  border: none;\n  padding: 0;\n  color: ", ";\n  background-color: transparent;\n  cursor: pointer;\n  font-size: 0;\n\n  &:focus-within {\n    outline: none;\n    border-radius: ", ";\n    box-shadow: ", ";\n  }\n"]);
  return Xs = function Xs() {
    return n;
  }, n;
}

function Ks() {
  var n = P(["\n  padding-left: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n"]);
  return Ks = function Ks() {
    return n;
  }, n;
}

function Zs() {
  var n = P(["\n  display: inline;\n  margin-left: ", ";\n  font-family: ", ";\n  white-space: nowrap;\n\n  ::after {\n    content: ',';\n  }\n\n  :last-child::after {\n    content: '';\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: none;\n    border: solid 1px ", ";\n    border-radius: ", ";\n    padding: ", ";\n  }\n"]);
  return Zs = function Zs() {
    return n;
  }, n;
}

function Ys() {
  var n = P(["\n      li:last-child::after {\n        content: ',';\n      }\n    "]);
  return Ys = function Ys() {
    return n;
  }, n;
}

function $s() {
  var n = P(["\n    ", ";\n  "]);
  return $s = function $s() {
    return n;
  }, n;
}

function nf() {
  var n = P(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  list-style: none;\n  margin: 0;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  padding-top: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  display: block;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n\n  ", "\n\n  ", " {\n    li {\n      display: none;\n\n      &:first-child {\n        display: inline;\n\n        &::after {\n          content: '...';\n        }\n      }\n    }\n  }\n"]);
  return nf = function nf() {
    return n;
  }, n;
}

function ef() {
  var n = P(["\n  cursor: pointer;\n  margin-left: ", ";\n  margin-right: ", ";\n  line-height: normal;\n  border-bottom: ", ";\n\n  label {\n    cursor: pointer;\n  }\n"]);
  return ef = function ef() {
    return n;
  }, n;
}

function tf() {
  var n = P(["\n  max-height: 300px;\n"]);
  return tf = function tf() {
    return n;
  }, n;
}

function rf() {
  var n = P(["\n      transform: rotate(180deg);\n    "]);
  return rf = function rf() {
    return n;
  }, n;
}

function of() {
  var n = P(["\n    cursor: pointer;\n    color: ", ";\n    transition: ", ";\n    ", ";\n  "]);
  return of = function of() {
    return n;
  }, n;
}

function af() {
  var n = P(["\n  ", "\n"]);
  return af = function af() {
    return n;
  }, n;
}

function uf() {
  var n = P(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n"]);
  return uf = function uf() {
    return n;
  }, n;
}

function cf() {
  var n = P(["\n  ", " {\n    max-width: 55%;\n  }\n"]);
  return cf = function cf() {
    return n;
  }, n;
}

var lf = o.div(cf(), is),
    sf = o(Pn)(uf(), function (n) {
  return n.theme.colors.primary;
}),
    ff = o.div(af(), function (n) {
  var e = n.theme,
      t = n.isOpen;
  return r.css(of(), e.colors.primary, function (n) {
    var e = n.theme;
    return Z([["transform", e.durations.promptly, e.timingFunctions.easeInOut]]);
  }, t && r.css(rf()));
}),
    df = o(Uo)(tf()),
    mf = o(Vo)(ef(), function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.borderBottom ? "solid 1px " + n.theme.colors.gray : "";
}),
    pf = o.ul(nf(), function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.fontSizes.m;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.colors.black;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.none;
}, function (n) {
  return n.theme.space.smallest;
}, function (n) {
  var e = n.isUserTyping;
  return r.css($s(), e && r.css(Ys()));
}, function (n) {
  return n.theme.mediaQueries.s;
}),
    hf = o.li(Zs(), function (n) {
  return n.theme.space.smallest;
}, function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.radii.m;
}, function (n) {
  return n.theme.space.smallest;
}),
    gf = o.div(Ks(), function (n) {
  return n.theme.space.regular;
}, function (n) {
  return n.theme.space.large;
}, function (n) {
  return n.theme.space.small;
}),
    vf = o.button(Xs(), function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.colors.grayDarker;
}, function (n) {
  return n.theme.radii.l;
}, function (n) {
  return n.theme.shadows.focusLight;
}),
    bf = o.div.attrs({
  role: "alert"
})(Js(), function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.small;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.fonts.secondary;
}, function (n) {
  return n.theme.fontSizes.s;
}, function (n) {
  return n.theme.lineHeights.m;
}, function (n) {
  return n.theme.colors.black;
}, function (n) {
  return n.theme.colors.grayLight;
}),
    yf = function yf(n) {
  var e = n[0];
  return "object" == typeof e && e.hasOwnProperty("options");
},
    xf = function xf(n, e) {
  return e.some(function (e) {
    return e.value === n.value;
  });
},
    kf = function kf(n, e) {
  return !n.some(function (n) {
    return !xf(n, e);
  }) && n.length === e.length;
},
    wf = function wf(n, e) {
  if (n.length !== e.length) return !1;

  for (var t = n.sort(), r = e.sort(), o = 0; o < t.length; o++) {
    if (t[o] !== r[o]) return !1;
  }

  return !0;
},
    Ef = {
  "pt-br": {
    search: "Buscar",
    clear: "Limpar campo"
  },
  "en-us": {
    search: "Search",
    clear: "Clear field"
  },
  "es-mx": {
    search: "Buscar",
    clear: "Limpiar campo"
  },
  "es-co": {
    search: "Buscar",
    clear: "Limpiar campo"
  }
},
    Cf = function Cf(n) {
  var e = n.onlySelectedVisible,
      t = n.selectedItems,
      r = n.highlightedIndex,
      o = n.getItemProps,
      i = n.getItemIndex;
  return s.createElement(Bl.Group, {
    role: "group"
  }, n.options.map(function (n) {
    if (e && !t.some(function (e) {
      return e.value === n.value;
    })) return null;
    var a = i(n);
    return s.createElement(mf, Object.assign({
      className: r === a ? "selected" : "",
      key: "" + n + a
    }, o({
      item: n,
      index: a
    })), s.createElement(Bl.Button, {
      checked: xf(n, t),
      readOnly: !0,
      label: n.name
    }));
  }));
},
    zf = {
  "pt-br": {
    selectAll: "Selecionar todas ({counter})",
    showOnlySelected: "Mostrar apenas selecionadas ({counter})",
    resultsNotFound: "Nenhum resultado encontrado."
  },
  "en-us": {
    selectAll: "Select all ({counter})",
    showOnlySelected: "Show only selected ({counter})",
    resultsNotFound: "No results found."
  },
  "es-mx": {
    selectAll: "Seleccionar todo ({counter})",
    showOnlySelected: "Mostrar solo los seleccionados ({counter})",
    resultsNotFound: "Ningún resultado encontrado."
  },
  "es-co": {
    selectAll: "Seleccionar todo ({counter})",
    showOnlySelected: "Mostrar solo los seleccionados ({counter})",
    resultsNotFound: "Ningún resultado encontrado."
  }
};

function Df(n) {
  var e = n.referenceElement,
      t = n.getMenuProps,
      r = n.isOpen,
      o = n.options,
      i = n.selectedItems,
      a = n.isUserTyping,
      u = n.handleSelectAllOptions,
      c = n.items,
      f = n.highlightedIndex,
      d = n.getItemProps,
      m = n.getItemIndex,
      p = n.onlySelectedVisible,
      h = n.setOnlySelectedVisible,
      g = n.resultsNotFoundMessage,
      v = n.allowSelectAll,
      b = n.allowShowOnlySelected,
      y = l.useContext(J).locale,
      x = l.useCallback(function () {
    h(!p);
  }, [h, p]);
  return s.createElement(pi, {
    referenceElement: e,
    visible: r
  }, s.createElement(df, Object.assign({}, t()), r && o.length ? s.createElement(s.Fragment, null, s.createElement(Bl.Group, {
    role: "group"
  }, i.length && !a && b ? s.createElement(mf, {
    key: "show-only-selected",
    onClick: function onClick() {
      return x();
    },
    borderBottom: !0
  }, s.createElement(Bl.Button, {
    label: zf[y].showOnlySelected.replace("{counter}", i.length.toString()),
    checked: p,
    readOnly: !0
  })) : null, v && s.createElement(mf, {
    key: "select-all",
    onClick: function onClick() {
      return u();
    },
    borderBottom: !0
  }, s.createElement(Bl.Button, {
    label: zf[y].selectAll.replace("{counter}", c.length.toString()),
    checked: kf(c, i),
    readOnly: !0
  }))), yf(o) ? o.map(function (n, e) {
    return s.createElement("div", {
      key: n.label
    }, function (n) {
      return !!(n.label && n.options && n.label && (!p || p && (e = n.options, i.some(function (n) {
        return e.includes(n);
      }))));
      var e;
    }(n) ? s.createElement(gf, null, s.createElement(Wo, {
      id: "group-label-" + e
    }, n.label)) : null, s.createElement(Bl.Group, {
      key: e,
      role: "group",
      "aria-labelledby": "group-label-" + e
    }, s.createElement(Cf, {
      onlySelectedVisible: p,
      selectedItems: i,
      highlightedIndex: f,
      getItemProps: d,
      options: n.options,
      getItemIndex: m
    })));
  }) : s.createElement(Cf, {
    onlySelectedVisible: p,
    selectedItems: i,
    highlightedIndex: f,
    getItemProps: d,
    options: o,
    getItemIndex: m
  })) : null), r && !o.length ? s.createElement(bf, null, g || zf[y].resultsNotFound) : null);
}

var Sf = l.forwardRef(function (n, e) {
  var r,
      o = l.useState(!1),
      i = o[0],
      u = o[1],
      c = l.useContext(J).locale,
      f = n.label,
      d = n.placeholder,
      m = n.options,
      p = void 0 === m ? [] : m,
      h = n.value,
      g = n.onSearch,
      b = n.onChange,
      y = n.onSelectionChange,
      x = n.allowClear,
      k = void 0 === x || x,
      w = n.allowSelectAll,
      E = void 0 === w || w,
      C = n.allowShowOnlySelected,
      z = void 0 === C || C,
      D = n.error,
      P = n.openMenuOnFocus,
      I = void 0 === P || P,
      _ = n.clearAriaLabel,
      L = n.resultsNotFoundMessage,
      T = void 0 === L ? "" : L,
      M = O(n, ["label", "placeholder", "options", "value", "onSearch", "onChange", "onSelectionChange", "allowClear", "allowSelectAll", "allowShowOnlySelected", "error", "openMenuOnFocus", "clearAriaLabel", "resultsNotFoundMessage"]),
      j = X(e),
      R = !!(null == j || null === (r = j.current) || void 0 === r ? void 0 : r.value),
      A = function A(n) {
    return (null == n ? void 0 : n.name) ? n.name : "";
  },
      N = l.useCallback(function (n) {
    var e,
        t = n.selectedItem;
    (null == j ? void 0 : j.current) && j.current.value !== ((null == (e = t) ? void 0 : e.value) ? e.value : "") && (j.current.value = t, j.current.dispatchEvent(new Event("input", {
      bubbles: !0
    })));
  }, [j]),
      F = l.useCallback(function (n) {
    var e = n ? n.map(function (n) {
      return n.value;
    }) : [],
        t = (h || []).map(function (n) {
      return n.value;
    });
    void 0 !== h && wf(t, e) || null == y || y(e);
  }, [h, y]),
      B = v.useMultipleSelection({
    initialSelectedItems: h || [],
    itemToString: A,
    onStateChange: function onStateChange(n) {
      var e = n.selectedItems;

      switch (n.type) {
        case v.useMultipleSelection.stateChangeTypes.FunctionRemoveSelectedItem:
        case v.useMultipleSelection.stateChangeTypes.DropdownKeyDownBackspace:
        case v.useMultipleSelection.stateChangeTypes.SelectedItemKeyDownBackspace:
          (null == e ? void 0 : e.length) || u(!1), F(e);
          break;

        case v.useMultipleSelection.stateChangeTypes.FunctionAddSelectedItem:
        case v.useMultipleSelection.stateChangeTypes.FunctionSetSelectedItems:
          F(e);
      }
    }
  }),
      q = B.getSelectedItemProps,
      H = B.getDropdownProps,
      V = B.addSelectedItem,
      U = B.selectedItems,
      G = B.setSelectedItems,
      W = B.removeSelectedItem,
      Q = l.useCallback(function (n) {
    return yf(n) ? n.flatMap(function (n) {
      return n.options;
    }) : n;
  }, []),
      K = yf(p) ? Q(p) : p;

  i && (K = K.filter(function (n) {
    return xf(n, U);
  }));
  var Z = !U.length,
      $ = v.useCombobox({
    items: K,
    onSelectedItemChange: N,
    itemToString: A,
    onStateChange: function onStateChange(n) {
      var e = n.inputValue,
          t = n.selectedItem;

      switch (n.type) {
        case v.useCombobox.stateChangeTypes.InputChange:
          null == g || g(e || "");
          break;

        case v.useCombobox.stateChangeTypes.InputKeyDownEnter:
        case v.useCombobox.stateChangeTypes.ItemClick:
        case v.useCombobox.stateChangeTypes.InputBlur:
          if (!t) return;

          var r = function (n, e) {
            return e.find(function (e) {
              return e.value === n.value;
            });
          }(t, U);

          r ? W(r) : V(t), ln(null);
      }
    }
  }),
      nn = $.isOpen,
      en = $.reset,
      tn = $.getInputProps,
      rn = $.getLabelProps,
      on = $.getMenuProps,
      an = $.getComboboxProps,
      un = $.highlightedIndex,
      cn = $.getItemProps,
      ln = $.selectItem,
      sn = $.openMenu,
      fn = $.closeMenu,
      dn = l.useCallback(function () {
    G([]), u(!1);
  }, [G, u]),
      mn = l.useCallback(function () {
    kf(K, U) ? dn() : G(K), null == g || g(""), ln(null);
  }, [G, ln, g, K, U, dn]),
      pn = l.useState(h),
      hn = pn[0],
      gn = pn[1];
  l.useEffect(function () {
    if (gn(h), void 0 !== h) {
      var n = h.map(function (n) {
        return n.value;
      }),
          e = (hn || []).map(function (n) {
        return n.value;
      }),
          t = U.map(function (n) {
        return n.value;
      });
      wf(e, n) || wf(n, t) || G(h);
    }
  }, [p, G, h, U, hn]);
  var vn = l.useCallback(function (n) {
    null == b || b(n), n.target.value || en();
  }, [b, en]),
      bn = l.useState(null),
      yn = bn[0],
      xn = bn[1],
      kn = Y(M),
      wn = a.pick(M),
      En = nn && !M.disabled;
  return s.createElement(ai, Object.assign({}, wn, {
    error: D
  }), f && s.createElement(Wo, Object.assign({}, rn()), f), s.createElement("div", {
    ref: xn
  }, s.createElement(lf, Object.assign({}, an()), s.createElement(cs, Object.assign({}, H(tn(S({}, kn, {
    ref: j,
    onClick: function onClick() {
      return I && sn();
    }
  }))), {
    placeholder: Z ? d : "",
    onInput: vn,
    prefixComponent: s.createElement(s.Fragment, null, s.createElement(sf, {
      component: t.SearchOutlined,
      size: "xs",
      svgProps: {
        "aria-label": n.searchIconLabel || Ef[c].search
      }
    }), U.length ? s.createElement(pf, {
      isUserTyping: R
    }, U.map(function (n, e) {
      return s.createElement(hf, Object.assign({
        key: "selected-item-" + e
      }, q({
        selectedItem: n,
        index: e
      }), {
        "aria-label": n.name
      }), n.name);
    })) : null),
    suffixComponent: s.createElement(fi, null, s.createElement(ff, {
      isOpen: En
    }, s.createElement(Pn, {
      role: "button",
      onClick: function onClick() {
        return En ? fn() : sn();
      },
      component: t.ChevronDown,
      size: "s"
    })), k && (R || U.length) && !M.disabled ? s.createElement(vf, {
      type: "button",
      "aria-label": _ || Ef[c].clear,
      onClick: function onClick() {
        j.current && (j.current.value = "", j.current.dispatchEvent(new Event("input", {
          bubbles: !0
        }))), null == g || g(""), dn(), ln(null);
      }
    }, s.createElement(Pn, {
      component: t.ClearFieldFilled,
      size: "s"
    })) : null)
  }))), s.createElement(Df, {
    referenceElement: yn,
    getMenuProps: on,
    isOpen: En,
    options: p,
    selectedItems: U,
    isUserTyping: R,
    handleSelectAllOptions: mn,
    items: K,
    highlightedIndex: un,
    getItemProps: cn,
    getItemIndex: function getItemIndex(n) {
      return K.findIndex(function (e) {
        return e.value === n.value;
      });
    },
    onlySelectedVisible: i,
    setOnlySelectedVisible: u,
    resultsNotFoundMessage: T,
    allowSelectAll: E,
    allowShowOnlySelected: z
  })));
});

function Of() {
  var n = P(["\n    ", "\n    ", "\n  "]);
  return Of = function Of() {
    return n;
  }, n;
}

function Pf() {
  var n = P(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n\n  ", "\n"]);
  return Pf = function Pf() {
    return n;
  }, n;
}

function If() {
  var n = P(["\n  text-align: center;\n  font-weight: 300;\n  margin: 20px 0px;\n"]);
  return If = function If() {
    return n;
  }, n;
}

function _f() {
  var n = P(["\n    flex-direction: row;\n\n    ", " {\n      img,\n      svg {\n        flex: 0 1 auto;\n        justify-content: flex-start;\n        width: ", ";\n        height: 40px;\n        margin-right: ", ";\n      }\n    }\n\n    ", " {\n      flex: 2;\n      justify-content: flex-start;\n      margin-right: ", ";\n    }\n\n    button {\n      flex: 0 1 auto;\n      justify-content: flex-end;\n      white-space: nowrap;\n    }\n  "]);
  return _f = function _f() {
    return n;
  }, n;
}

function Lf() {
  var n = P(["\n    flex-direction: column;\n\n    ", " {\n      margin-top: ", ";\n      text-align: center;\n    }\n\n    button {\n      margin-top: ", ";\n    }\n  "]);
  return Lf = function Lf() {
    return n;
  }, n;
}

function Tf() {
  var n = P([""]);
  return Tf = function Tf() {
    return n;
  }, n;
}

function Mf() {
  var n = P(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);
  return Mf = function Mf() {
    return n;
  }, n;
}

Sf.propTypes = {
  className: c.string,
  allowClear: c.bool,
  allowSelectAll: c.bool,
  allowShowOnlySelected: c.bool,
  clearAriaLabel: c.string,
  options: c.array,
  onSearch: c.func,
  error: c.string,
  name: c.string,
  label: c.string,
  disabled: c.bool,
  showCounter: c.bool,
  searchIconLabel: c.string
};

var jf = o.div(Mf()),
    Rf = o.div(Tf()),
    Af = o(Dt)(If()),
    Nf = o.div(Pf(), function (n) {
  var e = n.variant;
  return r.css(Of(), e.includes("large") && r.css(Lf(), Rf, function (n) {
    return n.theme.space.looser;
  }, function (n) {
    return n.theme.space.looser;
  }), e.includes("small") && r.css(_f(), jf, function (n) {
    return n.theme.space.looser;
  }, function (n) {
    return n.theme.space.large;
  }, Rf, function (n) {
    return n.theme.space.large;
  }));
}),
    Ff = function Ff(n) {
  var e = r.useTheme().colors;
  return s.createElement("svg", Object.assign({}, n, {
    width: "180",
    height: "128",
    fill: "none",
    viewBox: "0 0 180 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), s.createElement("g", {
    clipPath: "url(#clip0)"
  }, s.createElement("g", {
    opacity: ".4",
    filter: "url(#filter0_d)"
  }, s.createElement("path", {
    d: "M4 71.92l28.263-10.287 14.015 6.848 13.167 36.177-38.437 13.99L4 71.92z",
    fill: e.white
  }), s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.992 69.638l-12.821-6.264-26.115 9.505 15.91 43.713 35.423-12.893-12.397-34.06zm-12.73-8.005l14.016 6.848 13.167 36.177-38.437 13.99L4 71.92l28.263-10.287z",
    fill: e.primary
  }), s.createElement("path", {
    fill: e.primaryLightest,
    d: "M12.598 82.172l22.02-8.015 1.173 3.222-22.02 8.015zm1.955 5.371l29.003-10.557 1.173 3.223-29.003 10.556zm1.954 5.371L45.51 82.358l1.172 3.222L17.68 96.136zm1.955 5.371L47.465 87.73l1.173 3.222-29.003 10.556zm1.955 5.371L49.421 93.1l1.172 3.222-29.003 10.556z"
  }), s.createElement("path", {
    d: "M54.807 91.914l4.153-5.004 2.993 8.222-4.154 5.004-2.992-8.222z",
    fill: e.primaryDark
  }), s.createElement("path", {
    fill: e.primary,
    d: "M21.138 95.555l36.176-13.167 4.39 12.059-36.177 13.167z"
  }), s.createElement("path", {
    d: "M33.266 101.267a.588.588 0 01-.037-.217.612.612 0 01.047-.205.567.567 0 01.313-.288.554.554 0 01.712.333.544.544 0 01-.333.708.53.53 0 01-.218.032.495.495 0 01-.205-.047.647.647 0 01-.167-.122.613.613 0 01-.112-.194zm4.775-3.719L36.23 95.47a5.235 5.235 0 01-.376-.492c.023.245.032.454.025.625l-.055 2.752 2.218-.807zm2.477 1.595l-.621.227a.285.285 0 01-.194.01.353.353 0 01-.15-.101l-1.077-1.233-2.665.97-.034 1.637a.307.307 0 01-.047.167.281.281 0 01-.153.122l-.621.226.213-6.805.812-.295 4.537 5.075zm1.312-3.946a2.22 2.22 0 00.584-.306c.158-.124.278-.258.36-.404.083-.15.13-.307.138-.472a1.288 1.288 0 00-.082-.51c-.13-.354-.342-.579-.64-.674-.297-.095-.678-.058-1.142.111l-.88.32.817 2.242.846-.307zm3.86 2.064l-.713.26c-.147.053-.275.036-.385-.053l-2.315-1.56a.456.456 0 00-.205-.086.55.55 0 00-.265.045l-.61.222.903 2.479-.8.291-2.162-5.94 1.679-.611a3.837 3.837 0 011.016-.239c.3-.025.566.002.795.082.232.078.428.204.588.377.159.17.284.382.376.633.076.21.115.419.115.625 0 .207-.037.406-.111.6a1.79 1.79 0 01-.326.535 2.38 2.38 0 01-.529.456c.123.02.243.073.358.156l2.59 1.728zm.127-3.407c.132.365.301.674.506.928.205.251.434.444.69.58.258.131.536.204.835.217.298.01.606-.042.924-.158a2.45 2.45 0 00.813-.474c.22-.203.386-.436.496-.702a2.24 2.24 0 00.155-.887 3.211 3.211 0 00-.208-1.037 3.215 3.215 0 00-.507-.928 2.19 2.19 0 00-.69-.58A1.94 1.94 0 0048 90.59a2.396 2.396 0 00-.929.155 2.384 2.384 0 00-.807.477 1.98 1.98 0 00-.499.708c-.11.265-.162.56-.156.887.006.327.076.672.209 1.037zm6.837 2.262l-.664.242a.837.837 0 01-.28.055.564.564 0 01-.264-.069l-1.454-.757c-.277.22-.6.397-.967.53-.436.16-.86.231-1.273.215a2.87 2.87 0 01-2.098-1.03 3.667 3.667 0 01-.658-1.15 3.631 3.631 0 01-.234-1.3 2.98 2.98 0 01.247-1.178 2.84 2.84 0 01.695-.967c.305-.28.676-.5 1.112-.658a3.28 3.28 0 011.276-.21 2.83 2.83 0 011.158.291c.354.175.67.423.947.745.275.319.494.7.656 1.146.102.279.17.555.203.827a2.994 2.994 0 01-.168 1.526c-.09.233-.209.45-.355.65l2.12 1.092z",
    fill: e.white
  })), s.createElement("g", {
    opacity: ".5",
    filter: "url(#filter1_d)"
  }, s.createElement("path", {
    d: "M116.85 41l38.075 12.005 9.225 18.536-15.366 48.736-51.782-16.327L116.85 41z",
    fill: e.white
  }), s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.861 71.72l-8.439-16.956L118.24 43.67l-18.567 58.89 47.72 15.046 14.468-45.885zm-6.936-18.715l9.225 18.536-15.366 48.736-51.782-16.327L116.85 41l38.075 12.005z",
    fill: e.primary
  }), s.createElement("path", {
    fill: e.primaryLightest,
    d: "M117.62 58.743l29.665 9.354-1.368 4.341-29.667-9.354zm-2.282 7.236l39.073 12.32-1.369 4.34L113.97 70.32zm-2.281 7.236l39.073 12.32-1.369 4.34-39.073-12.319zm-2.282 7.236l39.073 12.32-1.37 4.34-39.072-12.319zm-2.281 7.235l39.073 12.32-1.369 4.34-39.073-12.319z"
  }), s.createElement("path", {
    d: "M154.197 103.109l8.417-1.913-3.493 11.076-8.417 1.913 3.493-11.076z",
    fill: e.primaryDark
  }), s.createElement("path", {
    fill: e.primary,
    d: "M115.799 79.738l48.736 15.366-5.122 16.246-48.736-15.366z"
  }), s.createElement("path", {
    d: "M124.037 95.29a.781.781 0 01.137-.257.81.81 0 01.215-.177.758.758 0 01.271-.08.704.704 0 01.291.03.746.746 0 01.513.634c.01.097 0 .194-.031.291a.705.705 0 01-.363.432.675.675 0 01-.269.075.709.709 0 01-.291-.03.703.703 0 01-.256-.143.66.66 0 01-.178-.215.84.84 0 01-.077-.264.801.801 0 01.038-.295zm8.034-.057l-.23-3.652a7.777 7.777 0 01.002-.822 6.393 6.393 0 01-.478.678l-2.281 2.854 2.987.942zm1.32 3.682l-.838-.264a.38.38 0 01-.212-.146.467.467 0 01-.075-.227l-.14-2.168-3.59-1.132-1.358 1.696a.408.408 0 01-.185.138.373.373 0 01-.259.005l-.837-.264 5.723-6.994 1.094.345.677 9.011zm4.571-3.095c.312.098.6.148.861.149a1.82 1.82 0 00.706-.134c.208-.09.384-.219.527-.387.142-.167.251-.369.325-.603.15-.477.107-.885-.129-1.226-.237-.34-.668-.61-1.293-.806l-1.184-.374-.953 3.021 1.14.36zm2.395 5.292l-.96-.303c-.198-.062-.319-.184-.364-.366l-1.176-3.514a.612.612 0 00-.146-.255c-.058-.064-.163-.12-.316-.167l-.821-.26-1.053 3.34-1.078-.34 2.524-8.002 2.261.713c.507.16.928.35 1.263.57.337.217.594.46.771.728.181.27.286.561.315.873.029.308-.009.632-.116.97a2.406 2.406 0 01-.384.751 2.2 2.2 0 01-.601.541 2.385 2.385 0 01-.776.302 3.17 3.17 0 01-.925.052c.113.122.196.273.25.453l1.332 3.914zm2.887-3.486a4.256 4.256 0 00-.216 1.387c.012.43.098.819.258 1.168.165.347.399.648.704.904.305.251.672.445 1.1.58.432.136.845.188 1.239.157a2.603 2.603 0 001.089-.338c.332-.194.625-.464.882-.809.257-.348.463-.768.618-1.26.155-.491.227-.953.216-1.387a2.912 2.912 0 00-.258-1.168 2.576 2.576 0 00-.696-.907 3.178 3.178 0 00-1.104-.587 3.164 3.164 0 00-1.236-.15 2.626 2.626 0 00-1.096.342c-.33.19-.624.46-.881.808a4.249 4.249 0 00-.619 1.26zm5.372 7.907l-.894-.282a1.096 1.096 0 01-.339-.168.75.75 0 01-.224-.285l-.919-1.972a4.568 4.568 0 01-1.446-.223 4.44 4.44 0 01-1.515-.803 3.805 3.805 0 01-.979-1.236 3.964 3.964 0 01-.398-1.543 4.877 4.877 0 01.237-1.743c.189-.6.457-1.119.804-1.558.348-.442.752-.79 1.212-1.042a3.774 3.774 0 011.513-.456 4.36 4.36 0 011.704.206 4.36 4.36 0 011.513.808c.424.355.752.77.983 1.243.232.47.364.987.396 1.55a4.833 4.833 0 01-.235 1.737c-.118.376-.27.721-.455 1.035a4.33 4.33 0 01-.629.845 3.941 3.941 0 01-.78.626 3.765 3.765 0 01-.9.398l1.351 2.863z",
    fill: e.white
  })), s.createElement("g", {
    filter: "url(#filter2_d)"
  }, s.createElement("path", {
    d: "M45 30h52.621l18.944 19.645V117H45V30z",
    fill: e.white
  }), s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.758 50.778l-17.33-17.971H47.807v81.387h65.951V50.778zM97.621 30l18.944 19.645V117H45V30h52.621z",
    fill: e.primary
  }), s.createElement("path", {
    fill: e.primaryLightest,
    d: "M53 52h41v6H53zm0 10h54v6H53zm0 10h54v6H53zm0 10h54v6H53zm0 10h54v6H53z"
  }), s.createElement("path", {
    d: "M116.565 93.273l9.822-5.74v15.307l-9.822 5.741V93.273z",
    fill: e.primaryDark
  }), s.createElement("path", {
    fill: e.primary,
    d: "M59.032 79.113h67.355v22.452H59.032z"
  }), s.createElement("path", {
    d: "M75.553 95.264c0-.134.023-.26.07-.378.051-.118.118-.221.2-.309a.991.991 0 01.31-.208.94.94 0 01.377-.077.94.94 0 01.378.077.991.991 0 01.517.517.938.938 0 01.078.378.957.957 0 01-.078.386.973.973 0 01-.208.3.891.891 0 01-.309.201.938.938 0 01-.378.078.938.938 0 01-.378-.078.891.891 0 01-.309-.2 1.101 1.101 0 01-.2-.301 1.05 1.05 0 01-.07-.386zm10.077-3.257l-1.736-4.5a9.221 9.221 0 01-.325-1.034 8.423 8.423 0 01-.332 1.042l-1.736 4.492h4.129zm3.118 4.106H87.59a.498.498 0 01-.324-.1.617.617 0 01-.185-.255l-1.034-2.67h-4.963l-1.034 2.67a.543.543 0 01-.177.247.493.493 0 01-.325.108h-1.157l4.422-11.06h1.513l4.422 11.06zm4.519-5.703c.432 0 .813-.052 1.142-.155.334-.108.612-.257.834-.447.226-.196.396-.428.509-.695a2.26 2.26 0 00.17-.888c0-.658-.216-1.155-.649-1.49-.432-.334-1.08-.5-1.944-.5h-1.637v4.174h1.575zm5.109 5.703h-1.328c-.272 0-.473-.106-.602-.317l-2.87-3.951a.797.797 0 00-.286-.262c-.098-.057-.252-.085-.463-.085h-1.135v4.615h-1.49v-11.06h3.127c.7 0 1.304.072 1.813.216.51.14.929.343 1.258.61.335.268.582.592.741.973.16.375.24.797.24 1.265 0 .391-.062.757-.186 1.096-.123.34-.303.646-.54.919a3.168 3.168 0 01-.857.687c-.334.19-.715.334-1.142.432.19.108.355.265.494.47l3.226 4.392zm2.248-5.526c0 .68.092 1.289.277 1.83.186.534.448.99.788 1.365.344.37.759.656 1.242.857a4.272 4.272 0 001.613.293c.597 0 1.137-.098 1.621-.293a3.44 3.44 0 001.235-.857c.339-.375.602-.83.787-1.366.185-.54.278-1.15.278-1.829 0-.68-.093-1.289-.278-1.83a3.833 3.833 0 00-.787-1.365 3.396 3.396 0 00-1.235-.864 4.193 4.193 0 00-1.621-.302c-.591 0-1.129.1-1.613.302a3.45 3.45 0 00-1.242.864c-.34.37-.602.826-.788 1.366-.185.54-.277 1.15-.277 1.829zm9.886 7.81h-1.235c-.185 0-.35-.025-.494-.077a.981.981 0 01-.393-.27l-1.937-2.115a5.997 5.997 0 01-1.907.294c-.813 0-1.554-.137-2.222-.41a5.029 5.029 0 01-1.722-1.165 5.238 5.238 0 01-1.11-1.782 6.415 6.415 0 01-.394-2.285c0-.828.13-1.587.393-2.277a5.222 5.222 0 011.111-1.79 4.976 4.976 0 011.722-1.173c.668-.278 1.409-.417 2.222-.417s1.554.139 2.223.417c.674.278 1.25.669 1.729 1.173a5.219 5.219 0 011.111 1.79c.262.69.394 1.449.394 2.277 0 .52-.054 1.014-.162 1.482a5.72 5.72 0 01-.456 1.312 5.14 5.14 0 01-.733 1.096 4.91 4.91 0 01-.972.856l2.832 3.064z",
    fill: e.white
  })), s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.631 24L82.816 3 59 24h14.316v20h19V24h14.315z",
    fill: e.primary
  }), s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.816.333L111.924 26H94.316v20h-23V26H53.708L82.816.333zM73.316 24v20h19V24h14.315L82.816 3 59 24h14.316z",
    fill: e.grayLight
  })), s.createElement("defs", null, s.createElement("filter", {
    id: "filter0_d",
    x: "-1.716",
    y: "53.357",
    width: "69.384",
    height: "72.15",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, s.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), s.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), s.createElement("feOffset", {
    dy: "1.143"
  }), s.createElement("feGaussianBlur", {
    stdDeviation: "2.858"
  }), s.createElement("feColorMatrix", {
    values: "0 0 0 0 0.243137 0 0 0 0 0.243137 0 0 0 0 0.243137 0 0 0 0.25 0"
  }), s.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), s.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), s.createElement("filter", {
    id: "filter1_d",
    x: "89.415",
    y: "34.931",
    width: "82.706",
    height: "94.451",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, s.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), s.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), s.createElement("feOffset", {
    dy: "1.517"
  }), s.createElement("feGaussianBlur", {
    stdDeviation: "3.793"
  }), s.createElement("feColorMatrix", {
    values: "0 0 0 0 0.243137 0 0 0 0 0.243137 0 0 0 0 0.243137 0 0 0 0.25 0"
  }), s.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), s.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), s.createElement("filter", {
    id: "filter2_d",
    x: "35",
    y: "22",
    width: "101.387",
    height: "107",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, s.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), s.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), s.createElement("feOffset", {
    dy: "2"
  }), s.createElement("feGaussianBlur", {
    stdDeviation: "5"
  }), s.createElement("feColorMatrix", {
    values: "0 0 0 0 0.243137 0 0 0 0 0.243137 0 0 0 0 0.243137 0 0 0 0.25 0"
  }), s.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), s.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), s.createElement("clipPath", {
    id: "clip0"
  }, s.createElement("path", {
    fill: e.white,
    d: "M0 0h180v128H0z"
  }))));
},
    Bf = function Bf(n) {
  var e,
      t = n.onButtonClick,
      r = n.description,
      o = n.buttonText,
      i = n.variant,
      a = void 0 === i ? "large" : i,
      u = n.uploadImage,
      c = void 0 === u ? {
    src: "",
    alt: ""
  } : u;
  return s.createElement(Nf, {
    "aria-label": "base-description-container",
    variant: a,
    className: n.className
  }, s.createElement(jf, null, (e = c).src && e.alt ? s.createElement("img", {
    src: c.src,
    alt: c.alt
  }) : s.createElement(Ff, null)), s.createElement(Rf, null, s.createElement(Af, null, r)), s.createElement(Be, {
    variant: a.includes("large") ? "secondary" : "tertiary",
    onClick: t,
    type: "button"
  }, o));
},
    qf = {
  "pt-br": {
    defaultButtonText: "Selecionar arquivos",
    defaultDescription: "Arraste e solte o(s) arquivo(s) no formato [INSIRA A EXTENSÃO DO ARQUIVO AQUI ex: .kml] aqui ou selecione arquivo(s) do seu dispositivo"
  },
  "en-us": {
    defaultButtonText: "Select Files",
    defaultDescription: "Drag and drop the file(s) in the format [INSERT FILE EXTENSION HERE eg .kml] here or select file(s) from your device"
  },
  "es-mx": {
    defaultButtonText: "Selecciona Archivos",
    defaultDescription: "Arrastre y suelte el (los) archivo (s) en el formato [INSERTAR LA EXTENSIÓN DEL ARCHIVO AQUÍ, por ejemplo .kml] aquí o seleccione el (los) archivo (s) de su dispositivo"
  },
  "es-co": {
    defaultButtonText: "Selecciona Archivos",
    defaultDescription: "Arrastre y suelte el (los) archivo (s) en el formato [INSERTAR LA EXTENSIÓN DEL ARCHIVO AQUÍ, por ejemplo .kml] aquí o seleccione el (los) archivo (s) de su dispositivo"
  }
};

function Hf() {
  var n = P(["\n    background-color: ", ";\n    max-height: ", ";\n\n    border-radius: ", ";\n    border: ", ";\n    padding: ", ";\n\n    ", "\n\n    ", "\n    ", "\n  "]);
  return Hf = function Hf() {
    return n;
  }, n;
}

function Vf() {
  var n = P(["\n  justify-content: 'center';\n  outline: 'none';\n  height: 100%;\n  width: auto;\n\n  ", "\n"]);
  return Vf = function Vf() {
    return n;
  }, n;
}

function Uf() {
  var n = P(["\n  vertical-align: middle;\n  margin-left: 20px;\n"]);
  return Uf = function Uf() {
    return n;
  }, n;
}

function Gf() {
  var n = P(["\n    display: inline-flex;\n    height: auto;\n    padding: 0px;\n  "]);
  return Gf = function Gf() {
    return n;
  }, n;
}

var Wf = o(Pn)(Uf()),
    Qf = o(M)(Vf(), function (n) {
  var t = n.variant,
      o = n.theme;
  return r.css(Hf(), t.includes("white") || "button" === t ? o.colors.white : o.colors.grayLight, t.includes("small") && "" + o.space.loosest, o.radii.m, t.includes("white") && "1px dashed " + o.colors.primary, t.includes("small") ? " " + o.space.smaller + " " + o.space.large + " " : o.space.large, "button" === t && r.css(Gf()), e.space, e.layout);
});

function Jf() {
  var n = P(["\n  ", "\n\n  &::-webkit-scrollbar {\n    width: 0.5em;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    border-radius: ", ";\n  }\n\n  padding: 0;\n  overflow: auto;\n  resize: none;\n  cursor: auto;\n"]);
  return Jf = function Jf() {
    return n;
  }, n;
}

function Xf() {
  var n = P([""]);
  return Xf = function Xf() {
    return n;
  }, n;
}

function Kf() {
  var n = P([""]);
  return Kf = function Kf() {
    return n;
  }, n;
}

function Zf() {
  var n = P(["\n  ", "\n\n  display: flex;\n  align-items: baseline;\n\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n\n  ", "\n\n  ", ";\n\n  ", "\n  ", "\n"]);
  return Zf = function Zf() {
    return n;
  }, n;
}

var Yf = o.div(Zf(), Ro, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.theme.space.smaller;
}, function (n) {
  return n.error ? No : r.css(Kf());
}, function (n) {
  return n.disabled ? Fo : r.css(Xf());
}, e.space, e.layout),
    $f = o.textarea(Jf(), Ao, function (n) {
  return n.theme.colors.gray;
}, function (n) {
  return n.theme.space.smallest;
}),
    nd = l.forwardRef(function (n, e) {
  var t = X(e),
      r = a.pick(n),
      o = Y(n),
      i = o.id ? o.id : o.name;
  return s.createElement(ai, Object.assign({
    id: i,
    error: n.error,
    label: n.label,
    disabled: n.disabled,
    elementRef: t,
    showCounter: n.showCounter
  }, r), s.createElement(Yf, {
    error: n.error,
    disabled: n.disabled
  }, s.createElement($f, Object.assign({}, o, {
    id: i,
    ref: t,
    "aria-invalid": Boolean(n.error)
  })), n.error ? s.createElement(fi, {
    error: n.error
  }) : null));
});

function ed() {
  var n = P(["\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    + ", " {\n      &:before {\n        width: ", ";\n        height: ", ";\n        background-color: ", ";\n        border-color: ", ";\n        top: -1px;\n        left: -1px;\n      }\n    }\n  }\n\n  &:checked {\n    + ", " {\n      border-color: ", ";\n      background-color: ", ";\n\n      &:before {\n        transform: ", ";\n      }\n    }\n  }\n\n  &:disabled {\n    cursor: default;\n\n    + ", " {\n      border-color: ", ";\n      background-color: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n  }\n\n  &:focus {\n    + ", " {\n      outline: none;\n      box-shadow: ", ";\n    }\n  }\n"]);
  return ed = function ed() {
    return n;
  }, n;
}

function td() {
  var n = P(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 1px;\n  background-color: ", ";\n  border-radius: ", ";\n  transition: ", ";\n  pointer-events: none;\n\n  &:before {\n    position: absolute;\n    content: '';\n    top: 1px;\n    left: 1px;\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n\n    transition: ", ";\n    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15), 0px 2px 4px rgba(0, 0, 0, 0.06);\n    border: 1px solid rgba(0, 0, 0, 0.04);\n    box-sizing: content-box;\n  }\n"]);
  return td = function td() {
    return n;
  }, n;
}

function rd() {
  var n = P([""]);
  return rd = function rd() {
    return n;
  }, n;
}

function od() {
  var n = P([""]);
  return od = function od() {
    return n;
  }, n;
}

function id() {
  var n = P(["\n  position: relative;\n  width: ", ";\n  height: ", ";\n\n  ", "\n\n  ", ";\n\n  ", "\n  ", "\n"]);
  return id = function id() {
    return n;
  }, n;
}

nd.propTypes = {
  error: c.string,
  name: c.string,
  label: c.string,
  disabled: c.bool,
  showCounter: c.bool
};
var ad = o.div(id(), function (n) {
  return n.theme.space.largest;
}, function (n) {
  return n.theme.space.large;
}, function (n) {
  return n.error ? No : r.css(od());
}, function (n) {
  return n.disabled ? Fo : r.css(rd());
}, e.space, e.layout),
    ud = o.span(td(), function (n) {
  return n.theme.colors.gray;
}, function (n) {
  return "calc(" + n.theme.space.large + "/2)";
}, function (n) {
  var e = n.theme;
  return Z([["background-color", e.durations.slowly, e.timingFunctions.easeInOut]]);
}, function (n) {
  return "calc(" + n.theme.space.large + " - 4px)";
}, function (n) {
  return "calc(" + n.theme.space.large + " - 4px)";
}, function (n) {
  return n.theme.colors.white;
}, function (n) {
  return n.theme.radii.l;
}, function (n) {
  var e = n.theme;
  return Z([["transform", e.durations.slowly, e.timingFunctions.easeInOut]]);
}),
    cd = o.input(ed(), ud, function (n) {
  return n.theme.space.large;
}, function (n) {
  return n.theme.space.large;
}, function (n) {
  return n.theme.colors.primaryLightest;
}, function (n) {
  return n.theme.colors.primary;
}, ud, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return n.theme.colors.primary;
}, function (n) {
  return " translateX(" + n.theme.space.largest + ")   translateX(-" + n.theme.space.large + ")";
}, ud, function (n) {
  return n.theme.colors.grayLight;
}, function (n) {
  return n.theme.colors.gray;
}, function (n) {
  return n.theme.colors.gray;
}, ud, function (n) {
  return n.theme.shadows.focus;
}),
    ld = l.forwardRef(function (n, e) {
  var t = a.pick(n),
      r = Y(n),
      o = r["data-testid"],
      i = O(r, ["data-testid"]),
      u = X(e),
      c = l.useCallback(function () {
    var n;
    null == u || null === (n = u.current) || void 0 === n || n.click();
  }, [u]),
      f = i.id ? i.id : i.name;
  return s.createElement(ai, Object.assign({}, t, {
    "data-testid": o,
    id: f,
    error: n.error,
    label: n.label
  }), s.createElement(ad, null, s.createElement(cd, Object.assign({}, i, {
    ref: u,
    type: "checkbox",
    id: f
  })), s.createElement(ud, {
    onClick: c
  })));
});

function sd() {
  var n = P(["\n  display: grid;\n\n  ", "\n  ", "\n  ", "\n"]);
  return sd = function sd() {
    return n;
  }, n;
}

ld.propTypes = {
  error: c.string,
  name: c.string,
  label: c.string,
  disabled: c.bool
};
var fd = o.div(sd(), e.grid, e.layout, e.space);
exports.ActionSheet = bn, exports.ActionSheetButton = vn, exports.Alert = Yn, exports.Button = Be, exports.CONTAINER_TEST_ID = "form-element-test-id", exports.Card = et, exports.CardSelect = xl, exports.CharCounter = $o, exports.Checkbox = Bl, exports.Collapse = function (n) {
  var e = n.title,
      t = n.description,
      r = n.children,
      o = n.chevronDataTestId,
      i = n.className,
      a = n.contentAriaLabel,
      u = n.onChange,
      c = n.isExpanded,
      f = n.initializeExpanded,
      d = s.useState(void 0 !== f && f),
      m = d[0],
      h = d[1],
      g = l.useContext(J).locale,
      v = m ? pt : mt,
      b = l.useCallback(function () {
    h(!m), null == u || u(!m);
  }, [m, h, u]),
      y = void 0 === c ? m : c;
  return s.createElement(dt, {
    className: i
  }, t && s.createElement(mn, {
    as: "h3",
    variant: "small",
    fontWeight: 500
  }, e), s.createElement(M, {
    justifyContent: "space-between"
  }, t ? s.createElement(Dt, {
    color: p.colors.grayDarkest,
    fontFamily: p.fonts.primary,
    fontWeight: 300
  }, t) : s.createElement(mn, {
    as: "h3",
    variant: "small",
    fontWeight: 500
  }, e), s.createElement(v, {
    "data-testid": o,
    color: p.colors.primary,
    fontSize: p.fontSizes.xl,
    onClick: b,
    "aria-label": a || ht[g].content,
    role: "button",
    tabIndex: 0
  })), y && r);
}, exports.ContextualAlert = ct, exports.Counter = Qc, exports.DatePicker = fs, exports.Dialog = Qt, exports.DisabledStyle = Fo, exports.DisabledText = Bo, exports.Divider = wr, exports.Drawer = Qr, exports.EmptyState = ro, exports.ErrorLabel = Jo, exports.ErrorStyle = No, exports.Flex = M, exports.FormElement = ai, exports.FormElementIcons = fi, exports.Grid = fd, exports.Heading = mn, exports.Icon = Pn, exports.Input = cs, exports.Label = Wo, exports.LinkText = ic, exports.List = Ac, exports.Listbox = Uo, exports.ListboxOption = Vo, exports.Loading = zo, exports.MultiSelect = Sf, exports.Pagination = Ji, exports.PomodoroProvider = xa, exports.Popover = pi, exports.Radio = Is, exports.RangePicker = Ma, exports.Search = Ms, exports.Segment = Qs, exports.Select = Ei, exports.SnackbarContainer = ra, exports.StarRating = Ju, exports.Stepper = Ha, exports.Table = Oc, exports.Tabs = Hu, exports.Tag = Eu, exports.Text = Dt, exports.TextArea = nd, exports.TextInputResetStyle = Ao, exports.TextInputStyle = Ro, exports.Toggle = ld, exports.Tooltip = xr, exports.Upload = function (n) {
  var e = n.onUploadChange,
      t = n.onButtonClick,
      r = n.uploadImage,
      o = n.variant,
      i = void 0 === o ? "large" : o,
      u = n.uploadConfig,
      c = n.description,
      f = n.buttonText,
      d = n.buttonIcon,
      m = O(n, ["onUploadChange", "onButtonClick", "uploadImage", "variant", "uploadConfig", "description", "buttonText", "buttonIcon"]),
      p = a.pick(m),
      h = Y(m),
      g = l.useContext(J).locale,
      v = l.useCallback(function (n, t) {
    var r = n.map(function (n) {
      return {
        file: n,
        errors: []
      };
    }),
        o = t.map(function (n) {
      return S({}, n);
    });
    null == e || e(r, o);
  }, [e]),
      b = D.useDropzone(S({
    onDrop: v
  }, u)),
      y = b.getInputProps;
  return s.createElement(s.Fragment, null, s.createElement(Qf, Object.assign({}, h, p, {
    variant: i
  }, (0, b.getRootProps)()), "button" === i ? s.createElement(Be, {
    "area-aria-label": "button-variant",
    variant: "tertiary",
    type: "button"
  }, s.createElement("span", null, f || qf[g].defaultButtonText), d && s.createElement(Wf, {
    component: d,
    size: "s"
  })) : s.createElement(Bf, {
    description: c || qf[g].defaultDescription,
    buttonText: f || qf[g].defaultButtonText,
    variant: i,
    uploadImage: r,
    onButtonClick: t
  }), s.createElement("input", Object.assign({}, y()))));
}, exports.filledColor = "#FCBB00", exports.mountTransition = Z, exports.snackbar = function (n) {
  var e = S({}, 0 == n.autoClose ? {
    autoClose: !1
  } : {
    autoClose: n.timeout || 1e4
  });
  x.toast(s.createElement(ya, Object.assign({}, n)), e);
}, exports.useCharCounter = ei;